
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $b9k8w = parcelRequire("b9k8w");


var $1sCHt = parcelRequire("1sCHt");


var $5YDZX = parcelRequire("5YDZX");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $93Gae = parcelRequire("93Gae");


var $dPoYT = parcelRequire("dPoYT");


var $JTIzG = parcelRequire("JTIzG");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");

/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 









var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");








var $ExetK = parcelRequire("ExetK");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3Am3T = parcelRequire("3Am3T");


var $NomII = parcelRequire("NomII");


var $bQm3c = parcelRequire("bQm3c");


var $7mpOv = parcelRequire("7mpOv");


var $8zMP3 = parcelRequire("8zMP3");














var $9ivsj = parcelRequire("9ivsj");

const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #1868DB)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, pulseCount: t1, isInObjectSideBar: t2 } = t0;
    const pulseCount = t1 === undefined ? 0 : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) {
        let t3;
        if ($[0] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "contextual-pulse-none"
            }, children);
            $[0] = children;
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    switch(pulseCount){
        case 1:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[2] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[2] = t3;
                    $[3] = t4;
                } else t4 = $[3];
                let t5;
                if ($[4] !== children || $[5] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                        "data-testid": "contextual-pulse-single",
                        className: t4
                    }, children);
                    $[4] = children;
                    $[5] = t4;
                    $[6] = t5;
                } else t5 = $[6];
                return t5;
            }
        case 2:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[7] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[7] = t3;
                    $[8] = t4;
                } else t4 = $[8];
                let t5;
                if ($[9] !== children || $[10] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                        "data-testid": "contextual-pulse-double",
                        className: t4
                    }, children);
                    $[9] = children;
                    $[10] = t4;
                    $[11] = t5;
                } else t5 = $[11];
                return t5;
            }
    }
    let t3;
    if ($[12] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "contextual-pulse-none"
        }, children);
        $[12] = children;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};





















var $55fM8 = parcelRequire("55fM8");

const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $cozmU.useCallback)(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else newViewPageContainer ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else newViewPageContainer ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};


var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}



var $i1vUz = parcelRequire("i1vUz");

const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const $ = (0, $bDgLe.c)(7);
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: null
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
            };
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
            };
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    if (scrollY !== null && scrollY < 400) {
        let t0;
        if ($[3] !== queryError) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
                queryError: queryError
            };
            $[3] = queryError;
            $[4] = t0;
        } else t0 = $[4];
        return t0;
    }
    let t0;
    if ($[5] !== queryError) {
        t0 = {
            dynamicActionTarget: null,
            queryError: queryError
        };
        $[5] = queryError;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
        queryError: queryError
    };
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};












var $ivb8S = parcelRequire("ivb8S");


var $d282Z = parcelRequire("d282Z");







const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType)=>{
    const $ = (0, $bDgLe.c)(10);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    let t0;
    let t1;
    if ($[0] !== dynamicSplitButtonLoading || $[1] !== isAdminHubAIEnabled || $[2] !== onboardingStateData || $[3] !== onboardingStateLoading || $[4] !== setOnboardingState || $[5] !== showCatchupAsDefault) {
        t0 = ()=>{
            if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
                hasLoaded.current = true;
                const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
                if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                    setOnboardingState({
                        key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                        value: "true"
                    });
                    setPulseCount(2);
                } else if (showCatchupAsDefault) setPulseCount(1);
            }
        };
        t1 = [
            dynamicSplitButtonLoading,
            onboardingStateData,
            onboardingStateLoading,
            setPulseCount,
            setOnboardingState,
            showCatchupAsDefault,
            isAdminHubAIEnabled
        ];
        $[0] = dynamicSplitButtonLoading;
        $[1] = isAdminHubAIEnabled;
        $[2] = onboardingStateData;
        $[3] = onboardingStateLoading;
        $[4] = setOnboardingState;
        $[5] = showCatchupAsDefault;
        $[6] = t0;
        $[7] = t1;
    } else {
        t0 = $[6];
        t1 = $[7];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[8] !== pulseCount) {
        t2 = {
            pulseCount: pulseCount
        };
        $[8] = pulseCount;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $cozmU.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled
    ]);
    return {
        pulseCount: pulseCount
    };
};
























var $kz1Yj = parcelRequire("kz1Yj");





var $kh0hi = parcelRequire("kh0hi");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



var $320o0 = parcelRequire("320o0");

const $e926aed382b01d25$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });






var $e4o8D = parcelRequire("e4o8D");

const $7b40fa145aa0c9d8$var$i18n = (0, $kSwu1.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $buxP3.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $buxP3.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'radius.small',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-hovered, #CFE1FD)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-pressed, #8FB8F6)",
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $7b40fa145aa0c9d8$var$pressableMotionStyles = (0, $buxP3.xcss)({
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    },
    ':active': {
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $7b40fa145aa0c9d8$var$pressableLegacyMotionStyles = (0, $buxP3.xcss)({
    transition: `background ${"var(--ds-duration-xshort, 100ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`,
    ':active': {
        transition: `background ${"var(--ds-duration-xshort, 100ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { dynamicActionText: dynamicActionText, isDynamicActionSelected: t1, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: t2 } = t0;
    const isDynamicActionSelected = t1 === undefined ? false : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t3 = !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles;
    const t4 = isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = !renderServerPlaceholder;
    let t7;
    if ($[3] !== dynamicActionText || $[4] !== isDynamicActionSelected || $[5] !== isInObjectSideBar || $[6] !== onDynamicActionClick) {
        t7 = dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "right",
            exitDirection: "right",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                "data-vc": "ai-floating-dynamic-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                onClick: ()=>onDynamicActionClick?.(),
                xcss: [
                    $7b40fa145aa0c9d8$var$defaultPressableStyles,
                    isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                    isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                    (0, $9wGTI.fg)("platform-dst-motion-uplift-custom-button") && $7b40fa145aa0c9d8$var$pressableMotionStyles,
                    !(0, $9wGTI.fg)("platform-dst-motion-uplift-custom-button") && $7b40fa145aa0c9d8$var$pressableLegacyMotionStyles
                ]
            }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: [
                !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
            ]
        }));
        $[3] = dynamicActionText;
        $[4] = isDynamicActionSelected;
        $[5] = isInObjectSideBar;
        $[6] = onDynamicActionClick;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: t6,
            exitThenEnter: true
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== onMenuButtonClick) {
        t10 = ()=>onMenuButtonClick?.();
        $[13] = onMenuButtonClick;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = isInObjectSideBar ? "circle" : "default";
    let t12;
    if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
            label: t9,
            onClick: t10,
            appearance: "subtle",
            isSelected: isMenuOpen,
            shape: t11
        });
        $[15] = isMenuOpen;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: t5,
            grow: "hug",
            space: "space.050",
            alignBlock: "center"
        }, t8, t12);
        $[20] = t12;
        $[21] = t5;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, t13);
        $[24] = t13;
        $[25] = triggerProps;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                (0, $9wGTI.fg)('platform-dst-motion-uplift-custom-button') && $7b40fa145aa0c9d8$var$pressableMotionStyles,
                !(0, $9wGTI.fg)('platform-dst-motion-uplift-custom-button') && $7b40fa145aa0c9d8$var$pressableLegacyMotionStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};














// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
            ...props,
            ref: ref,
            role: "dialog"
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = ref;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});















var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $1l0kj = parcelRequire("1l0kj");


var $9KSWX = parcelRequire("9KSWX");


var $3fO5l = parcelRequire("3fO5l");


var $gFEZF = parcelRequire("gFEZF");


var $eDtFr = parcelRequire("eDtFr");


var $5ZtfK = parcelRequire("5ZtfK");











var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $cozmU.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $UNr39.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};












var $4aiCO = parcelRequire("4aiCO");





const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { contentId: contentId, isLivePage: t1, setIsOpen: setIsOpen, setPopupState: setPopupState } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const isSidePanelOpen = t2 === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = typeof document !== "undefined" ? document.querySelector("div#content") : null;
        $[2] = t3;
    } else t3 = $[2];
    const content = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[3] !== contentId) {
        t4 = {
            contentId: contentId,
            content: content
        };
        $[3] = contentId;
        $[4] = t4;
    } else t4 = $[4];
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)(t4);
    let t5;
    if ($[5] !== contentId || $[6] !== createAnalyticsEvent || $[7] !== edition || $[8] !== footerCommentsCount || $[9] !== handleBulkIssueCreate || $[10] !== intl || $[11] !== isLivePage || $[12] !== isSidePanelOpen || $[13] !== setIsOpen || $[14] !== setPopupState || $[15] !== showWarningDialog || $[16] !== unresolvedInlineCommentsCount) {
        const menuItems = [
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
                showMenuItem: true,
                isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
                label: intl.formatMessage((0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation"),
                isDisabled: false,
                beta: false,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                })
            }
        ];
        const sectionItems = [
            {
                key: "Summarize",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showSection: menuItems.some($790b3996dfce6541$var$_temp)
            },
            {
                key: "Create",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
                showSection: !isLivePage && menuItems.some($790b3996dfce6541$var$_temp2)
            }
        ];
        const onMenuItemSelection = (key)=>{
            let additionalAnalyticsAttributes = {};
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
                numPageCommentsSummarized: footerCommentsCount,
                numInlineCommentsSummarized: unresolvedInlineCommentsCount
            };
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: `aiActionsMenuItem-${key}`,
                    attributes: {
                        contentId: contentId,
                        edition: edition,
                        ...additionalAnalyticsAttributes,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation")) {
                if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
                else {
                    setIsOpen(false);
                    handleBulkIssueCreate();
                }
            } else setPopupState(key);
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            testId: "ai-uber-button-menu-group"
        }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                key: section.key,
                title: section.label
            }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    iconBefore: item_1.icon,
                    key: item_1.key,
                    isDisabled: item_1.isDisabled,
                    onClick: ()=>{
                        onMenuItemSelection(item_1.key);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center"
                }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
        $[5] = contentId;
        $[6] = createAnalyticsEvent;
        $[7] = edition;
        $[8] = footerCommentsCount;
        $[9] = handleBulkIssueCreate;
        $[10] = intl;
        $[11] = isLivePage;
        $[12] = isSidePanelOpen;
        $[13] = setIsOpen;
        $[14] = setPopupState;
        $[15] = showWarningDialog;
        $[16] = unresolvedInlineCommentsCount;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ contentId: contentId, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item_0)=>item_0.section === 'Create' && item_0.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
            else {
                setIsOpen(false);
                handleBulkIssueCreate();
            }
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconBefore: item_1.icon,
                key: item_1.key,
                isDisabled: item_1.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item_1.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center"
            }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};
function $790b3996dfce6541$var$_temp(item) {
    return item.section === "Summarize" && item.showMenuItem;
}
function $790b3996dfce6541$var$_temp2(item_0) {
    return item_0.section === "Create" && item_0.showMenuItem;
}















var $i1t43 = parcelRequire("i1t43");








var $5oPgz = parcelRequire("5oPgz");


var $jmjWc = parcelRequire("jmjWc");


const $6654dd6aa1f8b471$export$33b519b7db786337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9WcCJ",
    name: "FooterCommentsSummaryCombined",
    loader: async ()=>(await (parcelRequire("cGlMo"))).FooterCommentsSummaryCombinedWithErrorBoundary
});



var $9VC5k = parcelRequire("9VC5k");


var $auLW1 = parcelRequire("auLW1");


var $eN3MW = parcelRequire("eN3MW");


var $brrvF = parcelRequire("brrvF");






const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $buxP3.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    let t2;
    if ($[0] !== adminLink || $[1] !== contentId || $[2] !== contentType || $[3] !== intl || $[4] !== isLivePage || $[5] !== lastModifiedDate || $[6] !== onClose || $[7] !== popupState || $[8] !== setIsOpen || $[9] !== setPopupState || $[10] !== source || $[11] !== spaceKey) {
        const formatOptInMessageValues = {
            a: $0eb3a6f6be084bf0$var$_temp,
            br: $0eb3a6f6be084bf0$var$_temp2
        };
        const renderContent = ()=>{
            switch(popupState){
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Header,
                        spaceKey: spaceKey
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: onClose,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate,
                        setIsOpen: onClose,
                        source: source,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                        source: "quickSummary",
                        product: "confluence",
                        isOrgAdmin: true,
                        headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                        adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                        adminLink: adminLink,
                        onAdminClose: ()=>setIsOpen(false)
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                        contentId: contentId,
                        setPopupState: setPopupState,
                        setIsOpen: setIsOpen,
                        isLivePage: isLivePage
                    });
            }
        };
        let t3;
        if ($[13] !== popupState) {
            t3 = (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles;
            $[13] = popupState;
            $[14] = t3;
        } else t3 = $[14];
        let t4;
        if ($[15] !== t3) {
            t4 = [
                t3
            ];
            $[15] = t3;
            $[16] = t4;
        } else t4 = $[16];
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t4
        }, renderContent());
        $[0] = adminLink;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = lastModifiedDate;
        $[6] = onClose;
        $[7] = popupState;
        $[8] = setIsOpen;
        $[9] = setPopupState;
        $[10] = source;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setIsOpen: onClose,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                    contentId: contentId,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});
function $0eb3a6f6be084bf0$var$_temp(s) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s);
}
function $0eb3a6f6be084bf0$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null);
}



const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).summarizeSectionLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).inlineCommentsMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).pageCatchupMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $cozmU.useState)((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $83cf8da53844c2d7$export$7571cdd921b49cc0)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage);
    const { pulseCount: pulseCount } = (0, $874fd8abb2c90fe4$export$b938e63de8ec6cb1)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu; // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIFeatureEnabled && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $cozmU.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    }, []);
    const onDynamicActionClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && isAdminHubAIEnabled) setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu) return 0, $44548221e1617185$export$2593be7073434b2d;
        return 0, $NomII.CustomPopupContainer;
    };
    if (!isEnabled) return null;
    if (isAdminHubAIEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        zIndex: popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && (0, $9wGTI.fg)('platform-dst-motion-uplift-popup') ? 1 : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af25143620373faf$export$cd20eff28c3c2c7f), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, !isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
                ...triggerProps,
                onClick: onMenuButtonClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b40fa145aa0c9d8$export$c226a072142c15e9), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu,
                isInObjectSideBar: isInObjectSideBar
            }))
    }));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "ai-floating-context-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _0Bm75Gp0Oa _42Yu6B3p0A _1VJPcaIt9z"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props))))));
};



var $3jwuS = parcelRequire("3jwuS");





var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");








var $kvJHJ = parcelRequire("kvJHJ");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $c4wtI = parcelRequire("c4wtI");


var $eCmUm = parcelRequire("eCmUm");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");





var $amW67 = parcelRequire("amW67");

const $b6f192cd6e2c63ff$export$b9c46d9495de208d = ({ setConfiguration: setConfiguration })=>{
    const { actionsToRender: actionsToRender } = (0, $amW67.useRovoConfigProviderProps)();
    const config = (0, $cozmU.useMemo)(()=>({
            getActions: async ()=>actionsToRender
        }), [
        actionsToRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};






var $bXh4X = parcelRequire("bXh4X");


var $k9SyR = parcelRequire("k9SyR");





























var $f1iv3 = parcelRequire("f1iv3");


var $gC2EJ = parcelRequire("gC2EJ");


var $58cpY = parcelRequire("58cpY");


var $dQeg1 = parcelRequire("dQeg1");


var $6iWVH = parcelRequire("6iWVH");








var $bqcqm = parcelRequire("bqcqm");






var $2bR8c = parcelRequire("2bR8c");

/**
 * @generated SignedSource<<326995534030d0899458e6a733b6b5db>>
 * @relayHash 32878f9dba46f2895d84694c9d4a7420
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aacd295096a5f8c66b22631d164f26a6235408fcb1fae613fb205b249749c44b
const $86cb04399e002e13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContentReviewerNudge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipStatusUpdatesAutomation"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "condition": "skipStatusUpdatesAutomation",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "AtlassianUserEmail",
                        "kind": "LinkedField",
                        "name": "emails",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isPrimary"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v8 = {
        "condition": "skipContentReviewerNudge",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isDraft",
                        "variableName": "isDraft"
                    }
                ],
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v11 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ 
        ]
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 25
            }
        ],
        "concreteType": "PaginatedContentList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v9 /*: any*/ ,
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "createdDate"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "children(first:25)"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "condition": "skipStatusUpdatesAutomation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "condition": "skipStatusUpdatesAutomation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "32878f9dba46f2895d84694c9d4a7420",
            "id": "aacd295096a5f8c66b22631d164f26a6235408fcb1fae613fb205b249749c44b",
            "metadata": {},
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "operationKind": "query",
            "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$skipStatusUpdatesAutomation:Boolean!,$skipContentReviewerNudge:Boolean!,$isDraft:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,emails@skip(if:$skipStatusUpdatesAutomation){value,isPrimary}},singleContent(id:$contentId){__typename,id,contentState(isDraft:$isDraft)@skip(if:$skipContentReviewerNudge){id,name},title@skip(if:$skipStatusUpdatesAutomation)\n    space@skip(if:$skipStatusUpdatesAutomation){id}\n    ancestors@skip(if:$skipStatusUpdatesAutomation){id,title}\n    history@skip(if:$skipStatusUpdatesAutomation){ownedBy{__typename,...on KnownUser{accountId}}}\n    metadata@skip(if:$skipStatusUpdatesAutomation){sourceTemplateEntityId}\n    children(first:25)@skip(if:$skipStatusUpdatesAutomation){nodes{id,title,metadata{createdDate}}}}}"
        }
    };
}();
$86cb04399e002e13$var$node.hash = "22fd54cb5708a9e9424a0c2f37ed9d47";
var $86cb04399e002e13$export$2e2bcd8739ae039 = $86cb04399e002e13$var$node;









var $jMyy4 = parcelRequire("jMyy4");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");








var $hMcNB = parcelRequire("hMcNB");


var $hdBxM = parcelRequire("hdBxM");











var $5v7QA = parcelRequire("5v7QA");


var $hTxAd = parcelRequire("hTxAd");


var $7IVHS = parcelRequire("7IVHS");

const $af67c5ecccab3dfa$export$11ac115c001a028b = 'automation-discovery-content-reviewer-nudge';
const $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE = $af67c5ecccab3dfa$export$11ac115c001a028b;
const $af67c5ecccab3dfa$var$DYNAMIC_CONFIG_CONFIG_KEY = 'confluence-content-reviewer-discovery-prompt';
const $af67c5ecccab3dfa$var$DEFAULT_CONTENT_REVIEWER_PROMPT = `/build-automation

#### Trigger: \`PageStatusChangedTrigger\`
- Run whenever a Confluence page's status changes in the space of this page (use space key).
- Scope the trigger to the single status \`Ready for review\`, so it fires on nothing else.
- Put the status filter on the trigger itself; do not add a separate condition after it.

#### Action 1: \`InvokeAgentAction\`
- **Agent:** Content Reviewer
- Adds the suggestions and writes the email body in one step.
- The agent emits progress narration ahead of its reply, such as \`Reviewing page...Preparing suggestions...Finalising suggestions...\`. That text is plain, never contains HTML tags, and always precedes the reply, so Action 2 strips it by cutting at the first \`<p>\`. The prompt below therefore requires the email to begin with \`<p>Hi\`.
- **Prompt:**

\`\`\`\`text
You review a Confluence page that has just been marked ready for review, add suggestions to it, then write a short HTML email about it.

Act immediately. Never ask questions, offer options, or explain what you'll do.

Recipient name (the person who moved the page to ready for review): {{page.editor.publicName}}

Page title: {{page.title}}

Page URL: {{page.url}}

PERMITTED ACTIONS

Fetch the page from the URL above, analyse it, and use your "Add suggestions to content" skill to add suggestions to it. That skill is the only write you may make, anywhere: never create, publish, move, archive, rename or delete anything, never change the page's status or labels, never rewrite the body yourself, and never accept your own suggestions, which are proposals for a human to act on.

Run the skill once. If it fails or adds nothing, write the email anyway, omitting the count sentence. Do not retry it, reword your suggestions to force a result, or fall back to editing the page or commenting on it.

Look nothing else up. The page is all you need.

THE LINK

The email needs a link that opens the page where your suggestions are visible, not a read-only view that hides them. The content you fetched tells you what kind of page it is, and different kinds are edited in different ways, so work the URL out yourself. Link only to this page and never invent a URL.

THE EMAIL

A nudge, not a review: the suggestions live on the page. Never restate them, list findings, summarise what changed, or judge the writing.

Write to the recipient alone. They moved the page to ready for review but may not have written it, so never credit them for the writing, never name anyone else, and never address a group.

Tone: their assistant handing work back. Warm, direct, plain, using contractions, no corporate filler. Never congratulate. Aim for 60 words and never exceed 100. No context, next steps, deadlines or offers of further help.

Reproduce the page title exactly wherever you use it; never paraphrase or reshape it.

STRUCTURE

Write these paragraphs in order, using only p, a and em tags. No lists, headings, other tags, inline CSS, markdown or code fences.

1. The greeting, alone in its paragraph: "Hi", a space, the recipient's first name, then a comma. The first name is the first word of the recipient name above. If that name is empty, write exactly <p>Hi,</p>
2. One sentence saying the page is ready for review and suggestions have been added, naming it once by its exact title.
3. Only when the skill added one or more suggestions, one short sentence giving that number, taken from the skill's own result and never estimated. Omit this paragraph otherwise.
4. A single anchor, href set to the link described above and text "Review suggestions". It is the only link and the only call to action.
5. <em>Generated via Content Review Action agent.</em>

OUTPUT

The email must begin with the literal characters <p>Hi and end with the closing tag of paragraph 5. A later step finds the email by cutting your reply at its first <p>, so no HTML tag of any kind may appear before the greeting.

Write no commentary after the email: no summary of what you did, no description of the suggestions, no sign-off of your own.
\`\`\`\`

#### Action 2: \`SendTemplatedEmailAction\`
- Sends the email with bodyType=HTML.
- **To:** {{page.editor.emailAddress}} \u{2014} the person who moved the page to ready for review, only
- **Subject:** Ready for review: {{page.title}}
- **Body:** \`<p>{{agentResponse.asString().substringAfter("<p>")}}\`
- The body expression drops the agent's progress narration by keeping only what follows the first \`<p>\`, then restores that opening tag. The narration is plain text and contains no tags, so the whole email survives intact.

#### Output
- One flat sequence: trigger, Action 1, Action 2. No nesting, branches or conditions.
- Create every component fully configured, with nothing left to add by hand in the flow editor.
`;
const $af67c5ecccab3dfa$var$CONTENT_REVIEWER_PROMPT_CONFIG = {
    configKey: $af67c5ecccab3dfa$var$DYNAMIC_CONFIG_CONFIG_KEY,
    fallback: $af67c5ecccab3dfa$var$DEFAULT_CONTENT_REVIEWER_PROMPT
};
const $af67c5ecccab3dfa$export$2821fd2708ed8940 = (isEnabled)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publishRovoChat = (0, $hdBxM.usePublish)('ai-mate');
    const handleLocalStorageUpdate = (0, $cozmU.useCallback)(()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    }, []);
    return (0, $cozmU.useMemo)(()=>isEnabled && (0, $6mKj3.expVal)('confluence-automations-content-reviewer-nudge', 'isEnabled', false) ? {
            id: $af67c5ecccab3dfa$export$11ac115c001a028b,
            title: formatMessage((0, $5v7QA.contentReviewerNudgeI18n).title),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    size: "small",
                    label: formatMessage((0, $5v7QA.contentReviewerNudgeI18n).iconLabel)
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            onClick: ()=>{
                publishRovoChat({
                    type: 'chat-new',
                    source: $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE,
                    openChat: true,
                    openChatMode: 'sidebar',
                    data: {
                        dialogues: [],
                        prompt: (0, $7IVHS.resolveDynamicConfigStringValue)($af67c5ecccab3dfa$var$CONTENT_REVIEWER_PROMPT_CONFIG),
                        placeholderType: 'skill',
                        resultAttributionContext: {
                            launchSource: $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE
                        }
                    }
                });
            },
            nudgeContext: {
                id: $af67c5ecccab3dfa$export$11ac115c001a028b,
                selfEligible: true,
                onAccept: handleLocalStorageUpdate,
                onDismiss: (reason)=>{
                    if (reason?.dismissedMethod === 'manual') handleLocalStorageUpdate();
                }
            }
        } : null, [
        formatMessage,
        handleLocalStorageUpdate,
        publishRovoChat,
        isEnabled
    ]);
};















var $kDhla = parcelRequire("kDhla");

const $e1303b52b0ab60dc$export$24bc364b8af91e6f = ()=>{
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [documentSnapshot, setDocumentSnapshot] = (0, $cozmU.useState)(null);
    const captureSnapshot = (0, $cozmU.useCallback)(()=>{
        fullPageEditorPresetAPI?.core?.actions.requestDocument((doc)=>{
            if (doc) setDocumentSnapshot(doc);
        });
    }, [
        fullPageEditorPresetAPI
    ]);
    return [
        documentSnapshot,
        captureSnapshot
    ];
};


const $7368a45ebdde8034$var$MAX_NODES = 50000;
const $7368a45ebdde8034$var$countWordsInText = (text)=>text?.match(/\S+/g)?.length ?? 0;
const $7368a45ebdde8034$export$2069d83620194dba = (doc)=>{
    if (!doc) return 0;
    let wordCount = 0;
    let nodeCount = 0;
    const visit = (node)=>{
        nodeCount += 1;
        if (nodeCount > $7368a45ebdde8034$var$MAX_NODES) return;
        if (node.type === 'expand' || node.type === 'nestedExpand') return;
        if (node.type === 'text') wordCount += $7368a45ebdde8034$var$countWordsInText(node.text);
        const children = node.content;
        if (children) for (const child of children){
            if (nodeCount > $7368a45ebdde8034$var$MAX_NODES) break;
            if (child) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
            visit(child);
        }
    };
    visit(doc);
    return wordCount;
};

















const $d58deec0f5f8c3d0$export$4ce9149b14868c81 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasUserSeenNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    return !hasUserSeenNudge && isRovoLLMEnabled && (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE);
};


const $140fd2278e447c47$var$TRIGGERING_CONTENT_STATE_NAME = 'Ready for review';
// The page must have at least this many words to be a meaningful review target.
const $140fd2278e447c47$var$MIN_WORD_COUNT = 500;
const $140fd2278e447c47$export$bae9d6abac858b24 = ({ content: content })=>{
    const isEligible = (0, $d58deec0f5f8c3d0$export$4ce9149b14868c81)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const initialContentStateNameRef = (0, $cozmU.useRef)(undefined);
    const [editorDocumentSnapshot, captureEditorDocumentSnapshot] = (0, $e1303b52b0ab60dc$export$24bc364b8af91e6f)();
    const currentContentStateName = content?.contentState?.name ?? null;
    const initialContentStateName = initialContentStateNameRef.current;
    (0, $cozmU.useEffect)(()=>{
        if (initialContentStateNameRef.current === undefined && content != null) initialContentStateNameRef.current = currentContentStateName;
    }, [
        currentContentStateName,
        content
    ]);
    const localizedTriggeringStateName = formatMessage((0, $5v7QA.contentReviewerNudgeI18n).readyForReviewState);
    const matchesTriggeringState = (value)=>value === $140fd2278e447c47$var$TRIGGERING_CONTENT_STATE_NAME || value === localizedTriggeringStateName;
    const hasTransitionedToTriggeringState = initialContentStateName !== undefined && !matchesTriggeringState(initialContentStateName) && matchesTriggeringState(currentContentStateName);
    // Capture the document only once the page becomes a review candidate (eligible + transitioned to
    // the triggering state), so we evaluate the word-count gate against the content at that moment.
    const shouldCaptureDocument = isEligible && hasTransitionedToTriggeringState;
    (0, $cozmU.useEffect)(()=>{
        if (shouldCaptureDocument) captureEditorDocumentSnapshot();
    }, [
        shouldCaptureDocument,
        captureEditorDocumentSnapshot
    ]);
    const wordCount = (0, $cozmU.useMemo)(()=>editorDocumentSnapshot ? (0, $7368a45ebdde8034$export$2069d83620194dba)(editorDocumentSnapshot) : null, [
        editorDocumentSnapshot
    ]);
    const hasEnoughWords = wordCount !== null && wordCount >= $140fd2278e447c47$var$MIN_WORD_COUNT;
    return isEligible && hasTransitionedToTriggeringState && hasEnoughWords;
};


















var $kv1hV = parcelRequire("kv1hV");


// A page must have at least this many words to be a meaningful review target.
const $4210ccd982a80d4f$var$MIN_WORD_COUNT = 500;
// A well-structured page has roughly one heading per this many words. A page with fewer headings
// than that ratio implies is considered to have "low heading density".
const $4210ccd982a80d4f$var$WORDS_PER_HEADING = 300;
// A single plain-text paragraph with at least this many words is considered a "dense" block that
// would benefit from being broken up.
const $4210ccd982a80d4f$var$DENSE_PARAGRAPH_MIN_WORDS = 150;
const $4210ccd982a80d4f$var$MAX_NODES = 50000;
const $4210ccd982a80d4f$var$countWordsInText = (text)=>text?.match(/\S+/g)?.length ?? 0;
const $4210ccd982a80d4f$export$8746d5f8bfda931c = (doc)=>{
    if (!doc) return false;
    const wordCount = (0, $7368a45ebdde8034$export$2069d83620194dba)(doc);
    if (wordCount < $4210ccd982a80d4f$var$MIN_WORD_COUNT) return false;
    let headingCount = 0;
    let hasDenseParagraph = false;
    let nodeCount = 0;
    const visit = (node)=>{
        nodeCount += 1;
        if (nodeCount > $4210ccd982a80d4f$var$MAX_NODES) return;
        // Ignore collapsed content so structure is measured on the same basis as the word count.
        if (node.type === 'expand' || node.type === 'nestedExpand') return;
        if (node.type === 'heading') headingCount += 1;
        if (node.type === 'paragraph') {
            const children = node.content;
            const isPlainTextOnly = !!children && children.length > 0 && children.every((child)=>child?.type === 'text');
            if (isPlainTextOnly) {
                const paragraphWordCount = children.reduce((total, child)=>total + $4210ccd982a80d4f$var$countWordsInText(child?.text), 0);
                if (paragraphWordCount >= $4210ccd982a80d4f$var$DENSE_PARAGRAPH_MIN_WORDS) hasDenseParagraph = true;
            }
            // A paragraph only holds inline content, so there is nothing structural to recurse into.
            return;
        }
        const children = node.content;
        if (children) for (const child of children){
            if (nodeCount > $4210ccd982a80d4f$var$MAX_NODES) break;
            if (child) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
            visit(child);
        }
    };
    visit(doc);
    const hasLowHeadingDensity = headingCount < wordCount / $4210ccd982a80d4f$var$WORDS_PER_HEADING;
    return hasLowHeadingDensity || hasDenseParagraph;
};


const $a4dd19d86c9be313$export$74fa9b01e1f418fd = (contentId)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasDismissedNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    const hasPageJustPublishedSignalForThisContent = Boolean(contentId) && (0, $kv1hV.pageJustPublishedSignal).contentId === contentId;
    return Boolean(isRovoLLMEnabled && pageMode === (0, $cD1qu.PageMode).VIEW && !hasDismissedNudge && hasPageJustPublishedSignalForThisContent && (0, $4210ccd982a80d4f$export$8746d5f8bfda931c)((0, $kv1hV.pageJustPublishedSignal).adf));
};


const $70bf4384341b00a6$export$616a7f72e384ce8e = ({ content: content, contentId: contentId })=>{
    const matchesCriteria = (0, $140fd2278e447c47$export$bae9d6abac858b24)({
        content: content
    });
    const hasOnPublishSignal = (0, $a4dd19d86c9be313$export$74fa9b01e1f418fd)(contentId);
    return (0, $af67c5ecccab3dfa$export$2821fd2708ed8940)(matchesCriteria || hasOnPublishSignal);
};






















var $1xpoY = parcelRequire("1xpoY");
















const $4d932fb0466bb92f$var$MS_PER_DAY = 86400000;
/** A cadence needs at least this many consecutive dates on the same rhythm. */ const $4d932fb0466bb92f$var$MIN_CONSECUTIVE_DATES = 3;
/**
 * Inclusive gap windows (in days) for each cadence, kept tight around a true 7-,
 * 14-, ~30- and ~91-day rhythm to avoid false positives. A cadence needs two
 * back-to-back gaps in the same window, so the intentional spacing between
 * windows — and, because every window starts well above zero, any zero gap (a
 * duplicate date) — never reads as a cadence.
 */ const $4d932fb0466bb92f$var$CADENCE_WINDOWS = [
    {
        cadence: 'daily',
        minDays: 1,
        maxDays: 1
    },
    {
        cadence: 'weekly',
        minDays: 6,
        maxDays: 8
    },
    {
        cadence: 'biweekly',
        minDays: 13,
        maxDays: 15
    },
    {
        cadence: 'monthly',
        minDays: 28,
        maxDays: 32
    },
    {
        cadence: 'quarterly',
        minDays: 85,
        maxDays: 95
    }
];
const $4d932fb0466bb92f$var$toTimestamp = (date)=>{
    if (date instanceof Date) return date.getTime();
    if (typeof date === 'number') return date;
    return new Date(date).getTime();
};
const $4d932fb0466bb92f$var$daysBetween = (earlier, later)=>(later - earlier) / $4d932fb0466bb92f$var$MS_PER_DAY;
/** The cadence a gap of the given length (in days) matches, if any. */ const $4d932fb0466bb92f$var$cadenceForGap = (gapInDays)=>$4d932fb0466bb92f$var$CADENCE_WINDOWS.find(({ minDays: minDays, maxDays: maxDays })=>gapInDays >= minDays && gapInDays <= maxDays)?.cadence;
const $4d932fb0466bb92f$export$ab851cffe4f65379 = (dates)=>{
    const timestamps = [];
    for (const date of dates ?? []){
        const value = $4d932fb0466bb92f$var$toTimestamp(date);
        if (Number.isFinite(value)) timestamps.push(value);
    }
    timestamps.sort((a, b)=>a - b);
    let cadence;
    let datesInARow = 1;
    for(let index = 1; index < timestamps.length; index++){
        const previousDay = timestamps[index - 1];
        const currentDay = timestamps[index];
        const gapCadence = $4d932fb0466bb92f$var$cadenceForGap($4d932fb0466bb92f$var$daysBetween(previousDay, currentDay));
        if (gapCadence !== undefined && gapCadence === cadence) datesInARow += 1;
        else // The run resets: a broken gap starts over at 1, a new rhythm at 2.
        datesInARow = gapCadence === undefined ? 1 : 2;
        cadence = gapCadence;
        if (datesInARow >= $4d932fb0466bb92f$var$MIN_CONSECUTIVE_DATES) return cadence;
    }
    return undefined;
};


const $8a66e0cca9583743$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $8a66e0cca9583743$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $8a66e0cca9583743$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $8a66e0cca9583743$var$buildKeywordRegExp = (keyword)=>{
    const trimmed = keyword.trim();
    if (!trimmed) return null;
    const pattern = $8a66e0cca9583743$var$escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
    return new RegExp(`${$8a66e0cca9583743$var$BOUNDARY_START}${pattern}${$8a66e0cca9583743$var$BOUNDARY_END}`, 'iu');
};
const $8a66e0cca9583743$var$matchesKeyword = (text, keyword)=>{
    if (!text) return false;
    const regExp = $8a66e0cca9583743$var$buildKeywordRegExp(keyword);
    return regExp ? regExp.test(text) : false;
};
const $8a66e0cca9583743$export$a6743727bac81426 = (text, keywords)=>{
    if (!text || keywords.length === 0) return false;
    return keywords.some((keyword)=>$8a66e0cca9583743$var$matchesKeyword(text, keyword));
};


/**
 * Template ID fragments for Confluence status update templates.
 *
 */ const $88b3979ada4b7131$var$STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS = [
    'eow-status-report',
    'status-update'
];
const $88b3979ada4b7131$export$bc8ca4ebff481bd2 = (templateId)=>{
    if (!templateId) return false;
    const normalised = templateId.toLowerCase();
    return $88b3979ada4b7131$var$STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS.some((fragment)=>normalised.includes(fragment));
};


const $ba98b4ec79a0d394$export$2ee80a92fd5fb770 = Object.freeze([
    'status update',
    'status report',
    'project update',
    'progress update',
    'team update',
    'week in review',
    'weekly recap'
]);
const $ba98b4ec79a0d394$export$ca7e8c37959a2440 = Object.freeze([
    'status updates',
    'weekly updates',
    'monthly',
    'updates',
    'weekly recaps',
    'monthly recaps'
]);
const $ba98b4ec79a0d394$export$8f9dca962eeb5fbc = Object.freeze({
    daily: [
        'daily'
    ],
    weekly: [
        'weekly'
    ],
    biweekly: [
        'biweekly',
        'bi-weekly',
        'fortnightly'
    ],
    monthly: [
        'monthly'
    ],
    quarterly: [
        'quarterly'
    ]
});
const $ba98b4ec79a0d394$export$d36c074c5bf1162b = Object.freeze(Object.values($ba98b4ec79a0d394$export$8f9dca962eeb5fbc).flat());
const $ba98b4ec79a0d394$export$d25b81fa1817a53b = 'week';
const $ba98b4ec79a0d394$export$8a2675cee5b59a91 = Object.freeze([
    $ba98b4ec79a0d394$export$d25b81fa1817a53b,
    'end of week'
]);
const $ba98b4ec79a0d394$export$35278965681ce09e = Object.freeze([
    'update',
    'status',
    'recap',
    'report'
]);
const $ba98b4ec79a0d394$var$buildMonthEntries = ()=>{
    const long = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        timeZone: 'UTC'
    });
    const short = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        timeZone: 'UTC'
    });
    const entries = [];
    for(let index = 0; index < 12; index++){
        const date = new Date(Date.UTC(2021, index, 1));
        entries.push({
            name: long.format(date),
            index: index
        });
        entries.push({
            name: short.format(date),
            index: index
        });
    }
    return entries;
};
const $ba98b4ec79a0d394$var$MONTH_ENTRIES = $ba98b4ec79a0d394$var$buildMonthEntries();
const $ba98b4ec79a0d394$export$90072b28f6344da9 = Object.freeze($ba98b4ec79a0d394$var$MONTH_ENTRIES.map((entry)=>entry.name));
const $ba98b4ec79a0d394$export$ac65c1d9a31bfa9d = new Map($ba98b4ec79a0d394$var$MONTH_ENTRIES.map((entry)=>[
        entry.name.toLowerCase(),
        entry.index
    ]));
const $ba98b4ec79a0d394$export$9a673300d96e605 = Object.freeze([
    ...$ba98b4ec79a0d394$export$d36c074c5bf1162b,
    ...$ba98b4ec79a0d394$export$8a2675cee5b59a91,
    ...$ba98b4ec79a0d394$export$90072b28f6344da9
]);


const $ee79dd299f11a151$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $ee79dd299f11a151$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $ee79dd299f11a151$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $ee79dd299f11a151$var$MS_PER_DAY = 86400000;
/**
 * Year assumed for title dates that omit one ("17/06", "Aug 11", "W24").
 */ const $ee79dd299f11a151$var$ASSUMED_YEAR = 2000;
const $ee79dd299f11a151$var$isValidMonthDay = (month, day)=>month >= 1 && month <= 12 && day >= 1 && day <= 31;
/** ISO date, e.g. "2026-08-12". */ const $ee79dd299f11a151$var$parseIso = (text)=>{
    const match = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{4})-(\\d{2})-(\\d{2})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'u').exec(text);
    if (!match) return undefined;
    const month = Number(match[2]);
    const day = Number(match[3]);
    return $ee79dd299f11a151$var$isValidMonthDay(month, day) ? Date.UTC(Number(match[1]), month - 1, day) : undefined;
};
/** Numeric slash date, e.g. "17/06", "08/12", "12/08/2026". Interpreted as day/month. */ const $ee79dd299f11a151$var$parseSlash = (text)=>{
    const match = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{1,2})/(\\d{1,2})(?:/(\\d{2,4}))?${$ee79dd299f11a151$var$BOUNDARY_END}`, 'u').exec(text);
    if (!match) return undefined;
    const first = Number(match[1]);
    const second = Number(match[2]);
    // Day/month by default; only flip when the numbers make month/day unambiguous.
    let day = first;
    let month = second;
    if (first <= 12 && second > 12) {
        month = first;
        day = second;
    }
    if (!$ee79dd299f11a151$var$isValidMonthDay(month, day)) return undefined;
    let year = $ee79dd299f11a151$var$ASSUMED_YEAR;
    if (match[3] !== undefined) {
        const parsed = Number(match[3]);
        year = parsed < 100 ? 2000 + parsed : parsed;
    }
    return Date.UTC(year, month - 1, day);
};
/**
 * Week number, e.g. "W24" or "Week 24". Consecutive week numbers resolve exactly
 * seven days apart, which is all cadence detection needs.
 */ const $ee79dd299f11a151$var$parseWeek = (text)=>{
    const weekWord = $ee79dd299f11a151$var$escapeRegExp((0, $ba98b4ec79a0d394$export$d25b81fa1817a53b).trim());
    const patterns = [
        `${$ee79dd299f11a151$var$BOUNDARY_START}W(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`
    ];
    if (weekWord) patterns.push(`${$ee79dd299f11a151$var$BOUNDARY_START}${weekWord}\\s+(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`);
    for (const pattern of patterns){
        const match = new RegExp(pattern, 'iu').exec(text);
        if (match) {
            const week = Number(match[1]);
            if (week >= 1 && week <= 53) return Date.UTC($ee79dd299f11a151$var$ASSUMED_YEAR, 0, 1) + (week - 1) * 7 * $ee79dd299f11a151$var$MS_PER_DAY;
        }
    }
    return undefined;
};
/** Month name next to a day in either order, e.g. "Aug 11", "12 Aug", "Week of Aug 11". */ const $ee79dd299f11a151$var$parseMonthDay = (text)=>{
    const monthIndexByName = (0, $ba98b4ec79a0d394$export$ac65c1d9a31bfa9d);
    const monthNamePatterns = [];
    for (const name of monthIndexByName.keys()){
        const escaped = $ee79dd299f11a151$var$escapeRegExp(name);
        if (escaped.length > 0) monthNamePatterns.push(escaped);
    }
    const alternation = monthNamePatterns.join('|');
    if (!alternation) return undefined;
    const monthFirst = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(${alternation})\\s+(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'iu').exec(text);
    const dayFirst = monthFirst ? null : new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{1,2})\\s+(${alternation})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'iu').exec(text);
    const match = monthFirst ?? dayFirst;
    if (!match) return undefined;
    const monthName = (monthFirst ? match[1] : match[2]).toLowerCase();
    const day = Number(monthFirst ? match[2] : match[1]);
    const monthIndex = monthIndexByName.get(monthName);
    if (monthIndex === undefined || day < 1 || day > 31) return undefined;
    return Date.UTC($ee79dd299f11a151$var$ASSUMED_YEAR, monthIndex, day);
};
const $ee79dd299f11a151$export$a62abe7e6e176c03 = (text)=>{
    if (!text) return undefined;
    return $ee79dd299f11a151$var$parseIso(text) ?? $ee79dd299f11a151$var$parseSlash(text) ?? $ee79dd299f11a151$var$parseWeek(text) ?? $ee79dd299f11a151$var$parseMonthDay(text);
};



/**
 * A recurring status-update title pairs a recurrence indicator (a cadence word,
 * "weekly", "monthly", "quarterly", "yearly") with an update word ("update",
 * "status", "recap", "report") — e.g. "Aug update", "weekly report".
 */ const $47817d5b3794d616$var$isRecurringUpdateTitle = (title)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$9a673300d96e605)) && (0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$35278965681ce09e));
/**
 * Signals a recurring status-update series from a set of children.
 * A child only counts when its title uses an update word ("update", "status",
 * "recap", "report")
 */ const $47817d5b3794d616$var$doesChildrenLookLikeSeries = (children)=>{
    if (!children || children.length === 0) return false;
    // Only consider children with an update-related keyword in their title.
    const statusUpdateRelatedKeywords = (0, $ba98b4ec79a0d394$export$35278965681ce09e);
    const childrenWithUpdateRelatedKeyword = children.filter((child)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(child.title, statusUpdateRelatedKeywords));
    if (childrenWithUpdateRelatedKeyword.length === 0) return false;
    const titleDates = [];
    const creationDates = [];
    for (const child of childrenWithUpdateRelatedKeyword){
        creationDates.push(child.createdAt);
        const titleDate = (0, $ee79dd299f11a151$export$a62abe7e6e176c03)(child.title);
        if (titleDate !== undefined) titleDates.push(titleDate);
    }
    return Boolean((0, $4d932fb0466bb92f$export$ab851cffe4f65379)(creationDates)) || Boolean((0, $4d932fb0466bb92f$export$ab851cffe4f65379)(titleDates));
};
const $47817d5b3794d616$export$7c124a2235c0e7d1 = (input)=>{
    const { title: title, parentTitle: parentTitle } = input;
    const matchedTitle = (0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$2ee80a92fd5fb770)) || $47817d5b3794d616$var$isRecurringUpdateTitle(title);
    const matchedChildren = $47817d5b3794d616$var$doesChildrenLookLikeSeries(input.children);
    const matchedTemplate = (0, $88b3979ada4b7131$export$bc8ca4ebff481bd2)(input.templateId);
    const matchedParentTitle = (0, $8a66e0cca9583743$export$a6743727bac81426)(parentTitle, (0, $ba98b4ec79a0d394$export$ca7e8c37959a2440));
    return {
        matches: matchedTitle || matchedChildren || matchedTemplate || matchedParentTitle,
        matchedTitle: matchedTitle,
        matchedChildren: matchedChildren,
        matchedTemplate: matchedTemplate,
        matchedParentTitle: matchedParentTitle
    };
};





/**
 * Order in which cadences are tested. More specific cadences are checked
 * first so that overlapping text resolves deterministically.
 */ const $4b0b7f83b74c9d28$var$CADENCE_PRECEDENCE = [
    'quarterly',
    'monthly',
    'biweekly',
    'weekly',
    'daily'
];
const $4b0b7f83b74c9d28$export$485e4010a68f9292 = (text)=>{
    if (!text) return undefined;
    for (const cadence of $4b0b7f83b74c9d28$var$CADENCE_PRECEDENCE){
        if ((0, $8a66e0cca9583743$export$a6743727bac81426)(text, (0, $ba98b4ec79a0d394$export$8f9dca962eeb5fbc)[cadence])) return cadence;
    }
    return undefined;
};





const $3929127c2007f269$export$91b745d209412614 = 'weekly';
/**
 * Detects the cadence of a status-update series from its children by looking at
 * the rhythm of their dates. Only children whose title carries an update word
 * ("update", "status", "recap", "report") are considered, mirroring
 * `getStatusUpdateSignalMatch`. Title dates are preferred over creation dates
 * because an author-controlled title date ("Update 17/06") is a stronger cadence
 * signal than when the page happened to be created.
 */ const $3929127c2007f269$var$detectChildrenCadence = (children)=>{
    if (!children || children.length === 0) return undefined;
    const statusUpdateKeywords = (0, $ba98b4ec79a0d394$export$35278965681ce09e);
    const relevantChildren = children.filter((child)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(child.title, statusUpdateKeywords));
    if (relevantChildren.length === 0) return undefined;
    const titleDates = [];
    const creationDates = [];
    for (const child of relevantChildren){
        creationDates.push(child.createdAt);
        const titleDate = (0, $ee79dd299f11a151$export$a62abe7e6e176c03)(child.title);
        if (titleDate !== undefined) titleDates.push(titleDate);
    }
    return (0, $4d932fb0466bb92f$export$ab851cffe4f65379)(titleDates) ?? (0, $4d932fb0466bb92f$export$ab851cffe4f65379)(creationDates);
};
const $3929127c2007f269$export$aaea763fe2a58871 = (input)=>{
    const { title: title, parentTitle: parentTitle, children: children } = input;
    const titleCadence = title ? (0, $4b0b7f83b74c9d28$export$485e4010a68f9292)(title) : undefined;
    if (titleCadence) return titleCadence;
    const childrenCadence = $3929127c2007f269$var$detectChildrenCadence(children);
    if (childrenCadence) return childrenCadence;
    const parentCadence = parentTitle ? (0, $4b0b7f83b74c9d28$export$485e4010a68f9292)(parentTitle) : undefined;
    if (parentCadence) return parentCadence;
    return $3929127c2007f269$export$91b745d209412614;
};


const $13bd41970a846636$export$d547eb960ffae1ac = ({ title: title, parentTitle: parentTitle, sourceTemplateEntityId: sourceTemplateEntityId, children: children })=>{
    return (0, $cozmU.useMemo)(()=>{
        const input = {
            title: title ?? undefined,
            parentTitle: parentTitle ?? null,
            templateId: sourceTemplateEntityId ?? null,
            children: children
        };
        return {
            ...(0, $47817d5b3794d616$export$7c124a2235c0e7d1)(input),
            cadence: (0, $3929127c2007f269$export$aaea763fe2a58871)(input)
        };
    }, [
        title,
        parentTitle,
        sourceTemplateEntityId,
        children
    ]);
};


const $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID = 'automation-discovery-status-updates-nudge';
const $743450a0eca9e493$var$ROVO_CHAT_SOURCE = 'automation-discovery-status-updates-nudge';
const $743450a0eca9e493$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.status-updates-automation-discovery-nudge-action.title",
        defaultMessage: "Automate this status update"
    },
    iconLabel: {
        id: "automation-discovery.status-updates-automation-discovery-nudge-action.icon-label",
        defaultMessage: "Automation icon"
    }
});
/**
 * Per-cadence copy used to shape the automation prompt so the generated report,
 * its lookback window and its schedule all match the detected cadence.
 */ const $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG = {
    daily: {
        reportLabel: 'Daily',
        lookbackDays: 1,
        schedule: 'Run every weekday at 9am'
    },
    weekly: {
        reportLabel: 'Weekly',
        lookbackDays: 7,
        schedule: 'Run every Monday at 9am'
    },
    biweekly: {
        reportLabel: 'Biweekly',
        lookbackDays: 14,
        schedule: 'Run every second Monday at 9am'
    },
    monthly: {
        reportLabel: 'Monthly',
        lookbackDays: 30,
        schedule: 'Run on the 1st of every month at 9am'
    },
    quarterly: {
        reportLabel: 'Quarterly',
        lookbackDays: 90,
        schedule: 'Run on the 1st of every quarter at 9am'
    }
};
const $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT = `/build-automation

### Trigger: Scheduled
- {{CADENCE_SCHEDULE}}
### Action: Send this prompt to the "Jira Work Agent"

\`\`\`\`text
# {{CADENCE_LABEL}} team and workstream report

Research the teams and workstreams connected to one seed user, publish a Confluence status page, then return an HTML email announcing it.

The seed user is a discovery seed, not the subject. Never put their name in the page title, headings, or executive summary. This is a scheduled run with no active Jira work item; never pass an identity ARI to **Get work item**.

**Reporting window:** the {{REPORT_LOOKBACK_DAYS}} days ending now. Compute both bounds in UTC and use the same pair everywhere.

**Empty results:** an empty or near-empty tool result is an answer, not a failure. Never repeat a call with the same arguments, and never chase the same object through a different tool. Record it as a coverage gap and move on. Research is never a reason to skip publishing.

## Stage 1 \u{2014} Inventory

Call each of these exactly once, with \`startTime\` and \`endTime\` set to the reporting window:

- **Get Work Summary For Given User in Twg** \u{2014} \`userId = {{SEED_USER_ARI}}\`
- **Get Ranked Work Summary for User** \u{2014} \`person = {{SEED_USER_ARI}}\`

Treat the first as the inventory and the second as the ranking. Inspect every facet, count, timestamp, status, URL, and pagination marker.

Classify each returned item:

**Strong** \u{2014} authored PR created or materially updated in window; Confluence page created in window; Loom created in window; Atlas project or goal returned directly.

**Conditional** \u{2014} contributed Confluence page (needs a native page read confirming relevance); assigned Jira issue (needs current activity or a linked strong artifact); reviewed PR (only to reinforce an anchor already established by strong evidence).

**Ineligible** \u{2014} anything outside the window, archived content, previously generated weekly reports, Automation test output, personal account requests, dependency-bot activity, mechanical notifications.

Record for each eligible item: exact URL or ARI, product, source host, timestamp, container, and candidate anchor.

Atlas projects arrive here already carrying state, start and due dates, last-updated time, update and watcher counts, and linked goals. That is reportable evidence on its own \u{2014} keep it, and do not treat a project as thin just because a later hydration call adds nothing.

## Stage 2 \u{2014} Anchors

Cluster eligible artifacts by workstream, not by product. Pick **at most 5** anchors, preferring: Atlas project or goal > Jira epic/initiative/parent > repository or service with authored PRs > current Confluence planning or decision page > named program with two independent current signals.

Each anchor needs either one strong artifact or two independent current signals joined by an exact key, URL, repository, project, or explicit link. Never anchor on an isolated review, comment, feature flag, or cleanup ticket when a stable parent exists.

## Stage 3 \u{2014} Owning teams

Call **Get user's teams** once with the seed user ARI. Membership is a candidate list only, never proof of ownership.

Discard teams whose name or description signals test data, generated data, scorecards, samples, or "ignore me". Discard any team you cannot connect to a selected anchor.

For **at most 3** survivors call **Get team information** with the exact team ARI, requesting members, active projects and spaces. A team is reportable only when its canonical metadata or explicit anchor ownership ties it to a selected anchor.

## Stage 4 \u{2014} Hydrate

Finish Stage 3 before you begin Stage 4. The rows below depend on identifiers that Stage 3 returns, and running them early is why a hydration call comes back empty.

Hydrate only what could change an anchor's status, ownership, progress, decisions, milestones, risks, dependencies, or confidence. Skip any row below whose artifact type did not appear in Stage 1 \u{2014} do not go looking for it.

| Anchor artifact | Tool and constraint |
| --- | --- |
| Jira issue or epic | **Get work item** with an exact key, ARI or URL from a verified result, read against the site that result came from. Plus **Get Work-Item Context in Teamwork Graph** for at most 2 central Jira anchors. **Get Related Repos for Work-Item in TwG** only if a Jira anchor still needs repository resolution. |
| Pull request or repo | Use the PR and repo metadata already returned by Stage 1. There is no provider-native PR-detail tool; do not invent one. |
| Confluence page | **Get page** with the exact numeric content ID, for at most 3 evidence pages. Verify title, author, created date, version, relevance. |
| Atlas project or goal | **Get project context**, but only with an ARI you have literally seen in an \`ari=\` field of a tool result \u{2014} in practice the \`active_projects\` entries returned by **Get team information** in Stage 3. A valid Atlas project ARI ends in a UUID, as in \`ari:cloud:townsquare:<cloudId>:project/f5138818-0875-42aa-a890-e79333564598\`. The \`ATLAS-nnnnn\` at the end of a project URL is a display key, not an ARI segment: never paste it into an ARI, and never assemble an ARI from a URL. No \`ari=\` field for a project means no call \u{2014} report it from its Stage 1 fields instead. |
| Loom | Use only videos returned in the window, and only when they explain a selected anchor. |

Never call **Get work item** for an identity ARI, for a key inferred from a PR title or branch name, or for a key whose Jira site is unknown. A failed cross-site read is a coverage gap \u{2014} do not retry elsewhere or substitute a similar key. An empty typed result is a coverage gap. Never use raw Teamwork Graph Cypher.

If contributor context is still missing, call **Get Ranked Collaboration Summary Between Users in Twg, V2** at most once, with the seed user, one already-verified collaborator, and the same window.

## Stage 5 \u{2014} Search fallback

If a selected anchor returned empty from Stage 4 and still lacks one named fact that would change the report, you **must** attempt exactly one **Search** call for it. Otherwise make no Search calls. Hard cap: 1 call for the whole run, and it belongs to report evidence only \u{2014} never spend it locating a destination, a parent, or a previous report.

The query must carry an exact full URL, repository name, canonical project name, exact Confluence title, or distinctive workstream name, plus the reporting dates. Never search a bare Jira key. Reject hits that match only on an acronym or keyword, and reject the parent page and any previously generated summary. Open an accepted hit with its product-native tool before using it. If Search also comes back empty, record a coverage gap and move on.

## Stage 6 \u{2014} Gate

Do not draft until all of these hold: every Stage 1 facet and pagination marker inspected; timestamps rechecked against the window; ineligible items removed; every anchor meets the evidence threshold; every reportable team has ownership evidence beyond membership; every Jira read used its source site; Confluence evidence pages read natively and none of them generated reports; Atlas ARIs copied not constructed; Search candidates hydrated or discarded; every claim, status, owner, milestone, decision, risk and URL traceable to a named source; coverage gaps stated honestly.

Resolve any check that fails by dropping the anchor or recording a coverage gap, never by making more tool calls. Then stop gathering and go to Stage 7.

## Report content

Every item must trace: eligible seed-user artifact \u{2192} selected anchor \u{2192} verified owning team. Once an anchor is selected, include material work by other contributors that advances it, but do not go mining their unrelated activity.

Build only the sections you have evidence for. Never invent metrics, owners, statuses, dates, relationships, or URLs, and never force an empty section.

Never emit a placeholder. No \`[Add Owner]\`, no \`TBD\`, no \`TODO\`, no square-bracketed prompt to fill something in later. A field you have a verified value for gets that value; a field you do not gets its line dropped entirely.

**Owners:** the owner or DRI of an Atlas project is in that project's \`Get project context\` result. Extract the name during Stage 4 and carry it through to the page.

1. **Executive summary** \u{2014} information panel: selected teams and anchors, momentum, milestones and decisions, material risks.
2. **Evidence coverage** \u{2014} the window dates and only the source categories that returned usable evidence. Name every gap; never claim complete coverage.
3. **Teams at a glance** \u{2014} wide table: Team, Relevant anchors, Current status, What changed, Evidence. Canonical team names, status lozenges.
4. **Workstream updates** \u{2014} one section per anchor: canonical name and link, status, verified owner or DRI, progress across contributors, decisions and milestones, dependencies and risks, sources.
5. **Completed work and decisions** \u{2014} source-backed outcomes closed inside the window only. Do not promote a review, comment, or cleanup ticket into a team outcome.
6. **Risks and blockers** \u{2014} warning panels, verified current risks only: affected anchor, consequence, sourced mitigation, evidence.

Every link must be copied verbatim from a tool result. Never build a URL from a title, key, ARI, or content ID. Never link to the publishing destination \`{{PARENT_PAGE_ID}}\`, to anything already filed under it, or to a previously generated summary.

## Visual specification

Executive status report, not a chat transcript or a bullet dump.

- Full-width information panel for the executive summary.
- Clear heading levels for each section and each workstream.
- Wide table for the team overview so it spans the content area.
- Native status lozenges for every status value: green on track or shipped, yellow at risk, red blocked, blue in progress, grey unknown.
- Two-column layout only where two short blocks genuinely sit side by side.
- Warning panels for risks, note panel for coverage caveats.
- Dividers between major sections.
- Short paragraphs, scannable bullets, bold leading label on each bullet.
- Evidence as inline Smart Links, never a raw URL or a raw ARI in body text. ARIs are tool arguments and must never be visible to a reader; cite the thing by its name, linked.
- No emoji, decorative icons, prose in code blocks, or nested tables.

## Stage 7 \u{2014} Publish

Publishing is the point of this run. You must reach 7.1 and you must call it exactly once. Never abandon the run with no page created.

**7.1** Call **Create content** exactly once, with exactly these arguments:

- \`spaceId\` = \`{{OUTPUT_SPACE_ID}}\`
- \`parentId\` = \`{{PARENT_PAGE_ID}}\`
- \`semanticQuery\` = the text described below

All three are required. A call missing \`parentId\` is malformed and publishes to the wrong place; if you are about to send this call without \`parentId\`, add it. If the tool exposes \`title\`, \`contentType\` or \`shouldAutoExecute\`, also pass \`title\` verbatim as specified, \`contentType\` = \`page\`, \`shouldAutoExecute\` = \`true\`.

\`{{PARENT_PAGE_ID}}\` is the destination parent. Pass the value exactly as given and let the tool resolve what kind of content it is: do not reason about whether it is a page, a folder or anything else, do not add a parent-type argument, and do not vary any other argument based on it. Otherwise leave it alone entirely \u{2014} never call **Get page**, **Search** or any read tool on it, never treat it as evidence, and never mention it inside \`semanticQuery\` or in the report body.

The \`semanticQuery\` must be self-contained and must begin with exactly these two lines:

\`\`\`
Use this exact page title, verbatim, unchanged: {{CADENCE_LABEL}} Team and Workstream Status Update \u{2014} {{now.format("MMM d, yyyy")}}
Preserve every fact and URL below exactly as given. Do not rediscover, re-research, re-word, or re-title anything.
\`\`\`

Then, in this order: the visual specification restated in full; the reporting window dates; the executive summary; the selected teams with ARIs; each anchor with its status, verified owner or DRI, progress, decisions, milestones and risks; contributor attribution; and every allowed source URL.

\`semanticQuery\` is the only thing the page generator can see. Anything the report is supposed to contain but that you leave out here will be missing from the page or filled in with an invented placeholder. Walk the six report sections and confirm every field each one requires is present before you send the call. Use native Confluence markup for status lozenges, panels and inline Smart Links so the formatting survives. These IDs belong in the tool's arguments only, so keep them out of the prose. Do not emit literal ADF JSON.

Do not call the legacy Create page or Edit page actions, Copy page, Rename page, or any move action.

**7.2** Read the result of 7.1. It returns the new page's URL, title and content ID. Record all three verbatim \u{2014} these are the only values Stage 8 may use.

Publishing is now final. Whatever 7.1 returned, do not call it again, and never move, copy, rename, reparent, delete or recreate the page. If the returned title differs from the title you specified, leave the page alone and say so in the email.

## Stage 8 \u{2014} Email

Your entire final response is the email body and nothing else. No preamble, no "I have created", no coverage notes, no closing question, no generated-by footer, no code fences.

Emit exactly this HTML, substituting the real title, URL and one-sentence summary:

\`\`\`html
<p>The weekly team and workstream status update has been published.</p>
<p><a href="PAGE_URL">PAGE_TITLE</a></p>
<p>ONE_SENTENCE_SUMMARY</p>
\`\`\`

\`PAGE_URL\` and \`PAGE_TITLE\` must be copied verbatim from the Stage 7.1 result and from nowhere else. A URL that came from a work summary, a search hit, an evidence page, or the parent page is never valid here. If you did not create a page, you have no URL, and you must not supply one.

\`ONE_SENTENCE_SUMMARY\` is a single plain sentence naming the teams covered and the headline of the week. If the title came back different from the one you specified, append one further \`<p>\` stating that plainly.

If Stage 7.1 did not return a page, emit exactly this instead, with no link:

\`\`\`html
<p>The weekly team and workstream status update could not be published this week.</p>
<p>REASON</p>
\`\`\`
\`\`\`\`
`;
// https://switcheroo.atlassian.com/ui/configurations/ecf5f0c8-e57a-4054-a74f-b75444e2c4ea/key/confluence-status-update-discovery-prompt
const $743450a0eca9e493$var$STATUS_UPDATE_DISCOVERY_PROMPT_CONFIG = 'confluence-status-update-discovery-prompt';
const $743450a0eca9e493$var$STATUS_UPDATE_PROMPT_TOKEN_PATTERN = /\{\{[A-Z0-9_]+\}\}/gu;
const $743450a0eca9e493$var$getStatusUpdatesAutomationPrompt = (input)=>{
    const template = (0, $1xpoY.default).getString($743450a0eca9e493$var$STATUS_UPDATE_DISCOVERY_PROMPT_CONFIG, $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT) || $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT;
    const { publishParentId: publishParentId, spaceId: spaceId, userId: userId, userEmail: userEmail, contentId: contentId, cadence: cadence } = input;
    const cadenceConfig = $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG[cadence] ?? $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG.weekly;
    const replacements = {
        '{{SEED_USER_ARI}}': userId ? `ari:cloud:identity::user/${userId}` : `${null}`,
        '{{PARENT_PAGE_ID}}': `${publishParentId ?? null}`,
        '{{NUDGE_PAGE_ID}}': `${contentId ?? null}`,
        '{{OUTPUT_SPACE_ID}}': `${spaceId ?? null}`,
        '{{CADENCE_LABEL}}': cadenceConfig.reportLabel,
        '{{CADENCE_SCHEDULE}}': cadenceConfig.schedule,
        '{{REPORT_LOOKBACK_DAYS}}': `${cadenceConfig.lookbackDays}`,
        '{{USER_EMAIL}}': `${userEmail ?? null}`
    };
    return template.replace($743450a0eca9e493$var$STATUS_UPDATE_PROMPT_TOKEN_PATTERN, (token)=>replacements[token] ?? token);
};
const $743450a0eca9e493$export$f18a9b6dd3f73a8 = ({ content: content, user: user })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publishRovoChat = (0, $hdBxM.usePublish)('ai-mate');
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const hasUserSeenAutomationDiscoveryMessage = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    const contentId = content?.id ?? '';
    const ancestors = content?.ancestors;
    const parent = ancestors?.[ancestors.length - 1];
    const spaceId = content?.space?.id;
    const ownerId = content?.history?.ownedBy?.accountId;
    const isDocOwner = Boolean(userId) && Boolean(ownerId) && userId === ownerId;
    const emails = user?.emails;
    const userEmail = (0, $cozmU.useMemo)(()=>{
        const candidates = emails?.filter((email)=>Boolean(email?.value)) ?? [];
        return candidates.find((email)=>email?.isPrimary)?.value ?? candidates[0]?.value ?? null;
    }, [
        emails
    ]);
    const children = (0, $cozmU.useMemo)(()=>content?.children?.nodes?.flatMap((child)=>child?.title && child.metadata?.createdDate ? [
                {
                    title: child.title,
                    createdAt: child.metadata.createdDate
                }
            ] : []) ?? [], [
        content?.children?.nodes
    ]);
    const { matches: matchesStatusUpdate, matchedChildren: matchedChildren, cadence: cadence } = (0, $13bd41970a846636$export$d547eb960ffae1ac)({
        title: content?.title,
        parentTitle: parent?.title,
        sourceTemplateEntityId: content?.metadata?.sourceTemplateEntityId,
        children: children
    });
    const handleLocalStorageUpdate = (0, $cozmU.useCallback)(()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    }, []);
    return (0, $cozmU.useMemo)(()=>matchesStatusUpdate && isDocOwner && !hasUserSeenAutomationDiscoveryMessage && (0, $9wGTI.fg)('cc_automations_discovery_nudges') ? {
            id: $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID,
            title: formatMessage($743450a0eca9e493$var$i18n.title),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    size: "small",
                    label: formatMessage($743450a0eca9e493$var$i18n.iconLabel)
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            onClick: ()=>{
                publishRovoChat({
                    type: 'chat-new',
                    source: $743450a0eca9e493$var$ROVO_CHAT_SOURCE,
                    openChat: true,
                    openChatMode: 'sidebar',
                    data: {
                        dialogues: [],
                        prompt: $743450a0eca9e493$var$getStatusUpdatesAutomationPrompt({
                            publishParentId: matchedChildren ? contentId : parent?.id,
                            spaceId: spaceId,
                            userId: userId,
                            userEmail: userEmail,
                            contentId: contentId,
                            cadence: cadence
                        }),
                        placeholderType: 'skill',
                        resultAttributionContext: {
                            launchSource: $743450a0eca9e493$var$ROVO_CHAT_SOURCE
                        }
                    }
                });
            },
            nudgeContext: {
                id: $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID,
                selfEligible: true,
                onAccept: handleLocalStorageUpdate,
                onDismiss: (reason)=>{
                    if (reason?.dismissedMethod === 'manual') handleLocalStorageUpdate();
                }
            }
        } : null, [
        formatMessage,
        handleLocalStorageUpdate,
        matchesStatusUpdate,
        isDocOwner,
        publishRovoChat,
        spaceId,
        userId,
        userEmail,
        cadence,
        parent?.id,
        matchedChildren,
        contentId,
        hasUserSeenAutomationDiscoveryMessage
    ]);
};








const $7c0ff345a5acb74a$export$fb3671a0eecaec42 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && isRovoLLMEnabled && (edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM);
};



var $lpWis = parcelRequire("lpWis");

/**
 * Runs the nudge-actions query and returns ONLY settled, content-matched entities — never the raw
 * `useQueryInterop` result.
 *
 * IMPORTANT: DO NOT USE FRAGMENT SPREADS HERE
 *
 * Every field the sub-hooks need is selected DIRECTLY on this query (no colocated fragments), so the
 * reactive `useQueryInterop` data can be passed straight down as plain props. That keeps the whole
 * subtree suspense-free — there are no fragment reads left to suspend on a torn-down record — while
 * staying fully reactive.
 */ const $7277a9bb4afcec4a$var$useConfluenceAutomationNudgeActionsQuery = ({ contentId: contentId, skipStatusUpdatesAutomation: skipStatusUpdatesAutomation, skipContentReviewerNudge: skipContentReviewerNudge, isDraft: isDraft, skip: skip })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $86cb04399e002e13$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            skipStatusUpdatesAutomation: skipStatusUpdatesAutomation,
            skipContentReviewerNudge: skipContentReviewerNudge,
            isDraft: isDraft
        },
        skip: skip,
        __callerPackage__: "automation-discovery"
    });
    if (loading || !data) return {
        singleContent: undefined,
        user: undefined
    };
    const settledContent = data.singleContent && data.singleContent.id === contentId ? data.singleContent : undefined;
    return {
        singleContent: settledContent,
        user: data.user ?? undefined
    };
};
const $7277a9bb4afcec4a$export$2a2b9e9c33e1951e = (contentId)=>{
    const hasBaseEligibility = (0, $7c0ff345a5acb74a$export$fb3671a0eecaec42)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasUserSeenStatusUpdatesAutomationNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    const includeStatusUpdatesAutomation = !hasUserSeenStatusUpdatesAutomationNudge && (0, $9wGTI.fg)('cc_automations_discovery_nudges');
    const includeContentReviewerNudge = (0, $d58deec0f5f8c3d0$export$4ce9149b14868c81)();
    const isAnyNudgeEligible = includeStatusUpdatesAutomation || includeContentReviewerNudge;
    const isDraft = pageMode === (0, $cD1qu.PageMode).EDIT;
    const { singleContent: singleContent, user: user } = $7277a9bb4afcec4a$var$useConfluenceAutomationNudgeActionsQuery({
        contentId: contentId,
        skipStatusUpdatesAutomation: !includeStatusUpdatesAutomation,
        skipContentReviewerNudge: !includeContentReviewerNudge,
        isDraft: isDraft,
        skip: !hasBaseEligibility || !contentId || !isAnyNudgeEligible || !(0, $9wGTI.fg)('automations-integration-to-rovo-button-nudges')
    });
    const contentReviewerNudgeAction = (0, $70bf4384341b00a6$export$616a7f72e384ce8e)({
        content: singleContent,
        contentId: contentId
    });
    const statusUpdatesAutomationNudgeAction = (0, $743450a0eca9e493$export$f18a9b6dd3f73a8)({
        content: singleContent,
        user: user
    });
    const matchedActions = (0, $cozmU.useMemo)(()=>[
            {
                actionId: 'status-updates-automation',
                action: statusUpdatesAutomationNudgeAction
            },
            {
                actionId: 'content-reviewer-nudge',
                action: contentReviewerNudgeAction
            }
        ].filter((entry)=>entry.action != null), [
        statusUpdatesAutomationNudgeAction,
        contentReviewerNudgeAction
    ]);
    // Defer the Studio permission check until at least one nudge has matched, so
    // the permission query never runs for the common case where nothing matches —
    // while still only running it once for all nudges.
    const { canCreateStudioAutomation: canCreateStudioAutomation } = (0, $lpWis.useStudioPermissions)({
        skip: matchedActions.length === 0
    });
    return (0, $cozmU.useMemo)(()=>canCreateStudioAutomation && hasBaseEligibility ? matchedActions : [], [
        matchedActions,
        canCreateStudioAutomation,
        hasBaseEligibility
    ]);
};



var $dWpd3 = parcelRequire("dWpd3");






































const $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS = [
    'project',
    'overview',
    'poster',
    'brief',
    'scope',
    'plan',
    'launch',
    'strategy'
];
const $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword = (contentTitle)=>{
    const lowerTitle = contentTitle.toLowerCase();
    return $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS.some((keyword)=>lowerTitle.includes(keyword));
};
const $7dab2f8a87f7b6ba$export$f2eec944fba9428e = ({ contentType: contentType, contentTitle: contentTitle })=>{
    if (contentType !== 'page') return false;
    return Boolean(contentTitle && $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword(contentTitle));
};


const $a6bade25d3c467cc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    pageCatchupMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup-subheader",
        defaultMessage: "See what's changed since your last visit"
    },
    summarizeSectionLabel: {
        id: "page-rovo-config-common.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    audioBriefingMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing",
        defaultMessage: "Listen to page"
    },
    audioBriefingMenuItemLabelWithContentType: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-with-content-type",
        defaultMessage: "Listen to {contentType}"
    },
    audioBriefingContentTypePage: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-page",
        defaultMessage: "page"
    },
    audioBriefingContentTypeBlogPost: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-blogpost",
        defaultMessage: "blogpost"
    },
    audioBriefingContentTypeLiveDoc: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-live-doc",
        defaultMessage: "live doc"
    },
    audioBriefingMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-subheader",
        defaultMessage: "Get a brief audio summary"
    },
    getProjectOverviewMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.get-project-overview",
        defaultMessage: "Get Project Overview"
    },
    draftCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.draft-comments",
        defaultMessage: "Draft a comment"
    },
    draftCommentsPrompt: {
        id: "page-rovo-config-common.menu.item.prompt.draft-comments",
        defaultMessage: "Suggest a few comments I could leave on this page, then offer to post my chosen one."
    }
});
const $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES = {
    live: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeLiveDoc,
    page: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypePage,
    blogpost: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeBlogPost
};
const $a6bade25d3c467cc$var$isValidAudioContentTye = (key)=>key in $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES;
const $a6bade25d3c467cc$export$e0c34800d984dab2 = ()=>{
    const { contentId: contentId, contentType: contentType, contentTitle: contentTitle, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty } = (0, $amW67.useRovoConfigProviderProps)();
    const { mode: rovoUiMode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const automationNudgeActions = (0, $7277a9bb4afcec4a$export$2a2b9e9c33e1951e)(contentId);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    // Page Catchup action
    const pageCatchupAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_content_catchup_as_a_rovo_skill', 'isEnabled', true)) return {
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            type: 'skill-action',
            handleType: (0, $6iWVH.HandleActionType).Skill,
            staticPrompt: '/content-catchup',
            nudgeContext: {
                id: 'content-catchup'
            }
        };
        return {
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'content-catchup'
            }
        };
    }, [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Summarize page action
    const quickSummaryAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_quick_summary_as_a_skill', 'isEnabled', true)) return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            type: 'skill-action',
            handleType: (0, $6iWVH.HandleActionType).Skill,
            staticPrompt: '/quick-summary',
            nudgeContext: {
                id: 'page-summaries'
            }
        };
        return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate ?? '',
                        source: "view-page",
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'page-summaries'
            }
        };
    }, [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        lastModifiedDate
    ]);
    // Summarize comments action
    const commentSummaryAction = (0, $cozmU.useCallback)(()=>({
            id: 'summarize-comments-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.inlineCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false
                    }))
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Create Jira bulk issues action
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content,
        useRovoWidth: true
    });
    const onBulkIssueCreate = (0, $cozmU.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
        else handleBulkIssueCreate();
    }, [
        isSidePanelOpen,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const bulkIssueCreateAction = (0, $cozmU.useCallback)(()=>({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $a6bade25d3c467cc$export$defe85febe8b728c.bulkWorkItemsCreateMenuItemLabel : $a6bade25d3c467cc$export$defe85febe8b728c.bulkIssueCreateMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    // Audio briefing action
    const { openAudioPlayer: openAudioPlayer } = (0, $bqcqm.useAudioPlayerStore)();
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { activeContent: activeContent } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState } = (0, $JTIzG.useAudioFeatureFlags)();
    const playBriefingImmediately = audioBriefingNudgeExperimentState === (0, $JTIzG.BriefingNudgeExperimentState).NUDGE_AUTOPLAY;
    const onAudioBriefingAction = (0, $cozmU.useCallback)(()=>{
        if (!!activeContent) {
            openAudioPlayer(activeContent, {
                playImmediately: playBriefingImmediately
            });
            // Close the Rovo popup or sidebar after clicking
            const isSidebarOrMiniModalOpen = rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR || rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
            if (isSidebarOrMiniModalOpen) // Close sidebar
            toggleConversationAssistantUIMode({
                targetMode: undefined,
                sidebarApi: sidebarApi
            });
        }
    }, [
        activeContent,
        openAudioPlayer,
        playBriefingImmediately,
        rovoUiMode,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const audioBriefingAction = (0, $cozmU.useCallback)(()=>{
        const key = activeContent?.subType || activeContent?.contentType;
        const contentTypeMessage = key && $a6bade25d3c467cc$var$isValidAudioContentTye(key) ? $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES[key] : undefined;
        const contentTypeLabel = contentTypeMessage ? formatMessage(contentTypeMessage) : '';
        const title = contentTypeLabel ? formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabelWithContentType, {
            contentType: contentTypeLabel
        }) : formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabel);
        return {
            id: 'audio-briefing-ai-action',
            title: title,
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58cpY))), {
                    label: ""
                }),
            onClick: onAudioBriefingAction,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'proactive-audio-briefing',
                // PROACTIVE_AI_AUDIO_BRIEFING in convo-ai
                suppressionKey: activeContent?.contentId
            }
        };
    }, [
        formatMessage,
        onAudioBriefingAction,
        activeContent
    ]);
    const shouldShowAudioBriefingAction = (0, $cozmU.useMemo)(()=>!!activeContent && audioBriefingNudgeExperimentState !== (0, $JTIzG.BriefingNudgeExperimentState).CONTROL, [
        activeContent,
        audioBriefingNudgeExperimentState
    ]);
    // Get Project Overview skill action
    const getProjectOverviewAction = (0, $cozmU.useCallback)(()=>({
            id: 'get-project-overview-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.getProjectOverviewMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))), {
                    label: ""
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            staticPrompt: '/get-project-details'
        }), [
        formatMessage
    ]);
    // Draft comment action
    const draftCommentAction = (0, $cozmU.useCallback)(()=>({
            id: 'draft-comment-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsPrompt)
        }), [
        formatMessage
    ]);
    // Final actions list
    const getViewPageRovoActions = (0, $cozmU.useCallback)(()=>{
        const actions = [];
        const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
        // Remove this const and use isEditorEmpty directly on experiment cleanup
        const isGatedEditorEmpty = isEditorEmpty && (0, $6mKj3.expValEquals)('platform_editor_remove_summarise_from_empty_doc', 'isEnabled', true);
        // needed for space overview since it doesn't have content type
        // also skip for unpublished drafts and empty live docs)
        if (!isPageOrBlogpost || isUnpublishedDraft || isGatedEditorEmpty) return actions;
        // Get Project Overview action (top of the list for published pages with project-related title)
        if ((0, $7dab2f8a87f7b6ba$export$f2eec944fba9428e)({
            contentType: contentType,
            contentTitle: contentTitle
        }) && (0, $6mKj3.expVal)('rovo_connie_empty_state_get_project_details_skill', 'isEnabled', false)) actions.push({
            actionId: 'get-project-overview',
            action: getProjectOverviewAction()
        });
        actions.push({
            actionId: 'page-catchup',
            action: pageCatchupAction()
        }, {
            actionId: 'quick-summary',
            action: quickSummaryAction()
        });
        actions.push(...automationNudgeActions);
        if ((0, $6mKj3.expValEquals)('confluence_rovo_draft_comments', 'isEnabled', true)) actions.push({
            actionId: 'draft-comment',
            action: draftCommentAction()
        });
        if (shouldShowAudioBriefingAction) actions.push({
            actionId: 'audio-briefing',
            action: audioBriefingAction()
        });
        // Only show comment summary in Rovo button when proactive_comment_summary experiment is disabled
        if ((unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) && !(0, $6mKj3.expValEquals)('proactive_comment_summary', 'isEnabled', true)) actions.push({
            actionId: 'comment-summary',
            action: commentSummaryAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) actions.push({
            actionId: 'bulk-issue-create',
            action: bulkIssueCreateAction()
        });
        return actions;
    }, [
        contentType,
        contentTitle,
        bulkIssueCreateAction,
        commentSummaryAction,
        draftCommentAction,
        footerCommentsCount,
        getProjectOverviewAction,
        isUnpublishedDraft,
        isEditorEmpty,
        pageCatchupAction,
        pageMode,
        quickSummaryAction,
        automationNudgeActions,
        unresolvedInlineCommentsCount,
        audioBriefingAction,
        shouldShowAudioBriefingAction
    ]);
    const actions = (0, $cozmU.useMemo)(()=>getViewPageRovoActions(), [
        getViewPageRovoActions
    ]);
    return actions;
};





/**
 * @generated SignedSource<<b4310f301c256ea95275f5723888b05a>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7
const $e82e32b99e59f54f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
            "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
            "metadata": {},
            "name": "useNudgeContributorFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$e82e32b99e59f54f$var$node.hash = "427fb0db9de3e615035eab567b67ccf0";
var $e82e32b99e59f54f$export$2e2bcd8739ae039 = $e82e32b99e59f54f$var$node;








const $fc07d009da21f8b9$var$useNudgeContributorFilterQuery = (0, $e82e32b99e59f54f$export$2e2bcd8739ae039);
function $fc07d009da21f8b9$export$cb9bdc967aae1b21(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($fc07d009da21f8b9$var$useNudgeContributorFilterQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? false;
    return (0, $cozmU.useMemo)(()=>({
            isCurrentUserContributor: isCurrentUserContributor,
            loading: loading
        }), [
        isCurrentUserContributor,
        loading
    ]);
}


/**
 * @generated SignedSource<<7aa3d54126f9597e716056a7eefea026>>
 * @relayHash a0dc0a296d152cfbd6c0ca2a59e55c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e
const $d9c45cee0d598413$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a0dc0a296d152cfbd6c0ca2a59e55c8b",
            "id": "80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e",
            "metadata": {},
            "name": "useNudgeFirstVisitFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeFirstVisitFilterQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$d9c45cee0d598413$var$node.hash = "1e734053e31505b911fcc40be543fe6e";
var $d9c45cee0d598413$export$2e2bcd8739ae039 = $d9c45cee0d598413$var$node;








const $4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery = (0, $d9c45cee0d598413$export$2e2bcd8739ae039);
function $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO) {
    if (!lastViewedTimeISO) return true;
    // Strip timezone bracket suffixes (e.g. "[America/New_York]") that cause NaN on Date.parse
    const cleaned = lastViewedTimeISO.replace(/\[.*?\]$/, '');
    return !cleaned || Number.isNaN(Date.parse(cleaned));
}
function $4a8709f90f4edadd$export$2e8f1aa0f8ab1526(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery, {
        variables: {
            contentId: contentId,
            contentType: 'PAGE'
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const lastViewedTimeISO = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    const isFirstVisit = $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO);
    return (0, $cozmU.useMemo)(()=>({
            isFirstVisit: isFirstVisit,
            loading: loading
        }), [
        isFirstVisit,
        loading
    ]);
}









var $gXKuh = parcelRequire("gXKuh");

function $97654e51bdd5d39b$export$5985165b88d806e9() {
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const handleAgentMentionSaved = (0, $cozmU.useCallback)((event)=>{
        const detail = event.detail;
        if (!detail || detail.openSidebar === false) return;
        sidebarApi.openSidebar();
    }, [
        sidebarApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        };
    }, [
        handleAgentMentionSaved
    ]);
}


















var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const readTimeMinutes = readTimeLoading ? null : Number(readTime);
    const minReadTimeMinutes = (0, $9wGTI.fg)('rovo_button_proactive_nudge_min_read_time_increase') ? 1.0 : 0.5;
    /**
   * Base eligibility checks (page-level, shared across all nudges):
   * 1. Rovo Button must be enabled
   * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
   * 3. Page must not be in edit mode
   * 4. Read time query must be completed
   * 5. Read time must exceed the minimum threshold (1 min with gate on, 30s with gate off)
   */ const isBaseEligible = isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && readTimeMinutes !== null && readTimeMinutes > minReadTimeMinutes;
    return {
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes
    };
};






















var $jXbuX = parcelRequire("jXbuX");







const $b985b864a3dfeb42$export$560e3a8567843c82 = 'daily-brief-nudge';
const $b985b864a3dfeb42$export$98808fd4b2dc119e = 300000;
const $b985b864a3dfeb42$var$messages = (0, $kSwu1.defineMessages)({
    dailyBriefNudgeTitle: {
        id: "page-rovo-config-common.daily-brief-nudge-title",
        defaultMessage: "Review your daily brief"
    },
    dailyBriefNudgeSubtitle: {
        id: "page-rovo-config-common.daily-brief-nudge-subtitle",
        defaultMessage: "See today's highlights at a glance"
    },
    dailyBriefNudgeIconLabel: {
        id: "page-rovo-config-common.daily-brief-nudge-icon-label",
        defaultMessage: "Daily brief"
    }
});
function $b985b864a3dfeb42$export$9c69eb1d10bb0a06(conversationId) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (conversationId) publish({
            type: 'chat-open',
            data: {
                channelId: conversationId
            },
            openChatMode: 'mini-modal',
            source: 'daily-brief-nudge'
        });
    }, [
        conversationId,
        publish
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: $b985b864a3dfeb42$export$560e3a8567843c82,
            title: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeTitle),
            secondaryTitle: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeSubtitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))), {
                    size: "small",
                    label: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $b985b864a3dfeb42$export$560e3a8567843c82,
                selfEligible: true,
                suppressionKey: conversationId ?? undefined
            }
        }), [
        onClick,
        formatMessage,
        conversationId
    ]);
}









var $9Ke0t = parcelRequire("9Ke0t");


var $bGNkz = parcelRequire("bGNkz");





var $1AJi3 = parcelRequire("1AJi3");

function $c81b38e83d47b2f2$export$efc596861aea1477() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch  {
        return 'UTC';
    }
}
function $c81b38e83d47b2f2$export$a7ad45fa39bda500(date, timeZone) {
    try {
        return $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, timeZone);
    } catch  {
        return $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, 'UTC');
    }
}
function $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, timeZone) {
    const dateParts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(date);
    let year = 0;
    let month = 0;
    let day = 0;
    for (const part of dateParts){
        if (part.type === 'year') year = Number(part.value);
        else if (part.type === 'month') month = Number(part.value);
        else if (part.type === 'day') day = Number(part.value);
    }
    const localDate = new Date(Date.UTC(year, month - 1, day));
    const isoDay = localDate.getUTCDay() || 7;
    localDate.setUTCDate(localDate.getUTCDate() + 4 - isoDay);
    const isoYear = localDate.getUTCFullYear();
    const firstDayOfIsoYear = new Date(Date.UTC(isoYear, 0, 1));
    const week = Math.ceil(((localDate.getTime() - firstDayOfIsoYear.getTime()) / 86400000 + 1) / 7);
    return `${isoYear}-W${String(week).padStart(2, '0')}`;
}


const $c3e3eb1b5def3766$var$messages = (0, $kSwu1.defineMessages)({
    insightsNudgeTitle: {
        id: "page-rovo-config-common.digest-nudge-title.v2",
        defaultMessage: "Explore your Rovo digest"
    },
    insightsNudgeIconLabel: {
        id: "page-rovo-config-common.digest-nudge-icon-label",
        defaultMessage: "Digest icon"
    },
    insightsNudgeSecondaryTitle: {
        id: "page-rovo-config-common.digest-nudge-secondary-title",
        defaultMessage: "See this week's highlights at a glance"
    }
});
function $c3e3eb1b5def3766$export$efd7aeb42217b406() {
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStore)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const [analyticsAttributes, setAnalyticsAttributes] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const localTimeZone = (0, $c81b38e83d47b2f2$export$efc596861aea1477)();
        setAnalyticsAttributes({
            localTimeZone: localTimeZone,
            localIsoWeekKey: (0, $c81b38e83d47b2f2$export$a7ad45fa39bda500)(new Date(), localTimeZone)
        });
    }, []);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!mode) toggleConversationAssistant();
        setActiveMenu('pulse');
    }, [
        mode,
        toggleConversationAssistant,
        setActiveMenu
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: 'rovo-insights-nudge',
            title: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeTitle),
            secondaryTitle: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeSecondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))), {
                    size: "small",
                    label: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'rovo-insights',
                ...analyticsAttributes ? {
                    analyticsAttributes: analyticsAttributes
                } : {}
            }
        }), [
        analyticsAttributes,
        onClick,
        formatMessage
    ]);
}









var $4nhQC = parcelRequire("4nhQC");


var $TTB05 = parcelRequire("TTB05");




const $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID = 'convo-starter';
/**
 * Checks whether the user has consented to Functional storage.
 * The convo starter nudge uses sessionStorage for suppression, which requires
 * Functional cookie consent per Atlassian policy.
 * Returns null while pending, true if granted, false if denied.
 */ function $c07f2db40a5a574b$var$useCanShowConvoStarterNudge() {
    const [hasFunctionalConsent, setHasFunctionalConsent] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('rovo_button_convostarter_nudge_cookie_policy_check')) {
            setHasFunctionalConsent(true);
            return;
        }
        (0, $4nhQC.getPreferences)().then((preferences)=>{
            setHasFunctionalConsent(Boolean(preferences?.[(0, $TTB05.PreferenceCategory).Functional]));
        }).catch(()=>{
            setHasFunctionalConsent(false);
        });
    }, []);
    return hasFunctionalConsent;
}
function $c07f2db40a5a574b$export$26385239543be8d2() {
    const hasFunctionalConsent = $c07f2db40a5a574b$var$useCanShowConvoStarterNudge();
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')) return null;
        if (hasFunctionalConsent !== true) return null;
        return {
            id: $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID,
            title: '',
            type: 'convo-starter-action',
            handleType: (0, $6iWVH.HandleActionType).Chat,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
            staticPrompt: '',
            starterType: 'static'
        };
    }, [
        hasFunctionalConsent
    ]);
}


const $fa24c3761347e030$export$5d0421d6a355c531 = (entry)=>'action' in entry;


/** Minimum read time (in minutes) required for the convo starter nudge. */ const $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES = 2;
function $8bdd9ea855fe08b8$export$730669e74cd8a0c9(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus) {
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const dailyBriefNudgeAction = (0, $b985b864a3dfeb42$export$9c69eb1d10bb0a06)(dailyBriefStatus?.conversationId ?? null);
    const insightsNudgeAction = (0, $c3e3eb1b5def3766$export$efd7aeb42217b406)();
    const convoStartersNudgeAction = (0, $c07f2db40a5a574b$export$26385239543be8d2)();
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isBaseEligible) return [];
        const nudgeEntries = [
            {
                actionId: 'page-catchup',
                enabled: true
            },
            {
                actionId: 'audio-briefing',
                enabled: !eligibleForChangeboarding
            },
            {
                action: dailyBriefNudgeAction,
                enabled: !!dailyBriefStatus?.conversationId && !!dailyBriefStatus?.completedAt && Date.now() - new Date(dailyBriefStatus.completedAt).getTime() < (0, $b985b864a3dfeb42$export$98808fd4b2dc119e) && (0, $9wGTI.fg)('rovo_button_daily_brief_nudge')
            },
            // Insights nudge — 1 min read time threshold covered by isBaseEligible
            {
                action: insightsNudgeAction,
                enabled: (0, $6mKj3.expVal)('rovo_growth_chat_pulse', 'isEnabled', false)
            },
            // Convo starter nudge — requires higher read time than the base threshold
            // Excluded for contributors and first-time visitors
            {
                action: convoStartersNudgeAction,
                enabled: !isCurrentUserContributor && !isFirstVisit && readTimeMinutes !== null && readTimeMinutes > $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES && (0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')
            },
            // Action items nudge — eligibility gated in useViewPageRovoActions
            {
                actionId: 'action-items-nudge',
                enabled: true
            },
            {
                actionId: 'status-updates-automation',
                enabled: (0, $9wGTI.fg)('cc_automations_discovery_nudges')
            },
            {
                actionId: 'content-reviewer-nudge',
                enabled: true
            }
        ];
        return nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
    }, [
        isBaseEligible,
        readTimeMinutes,
        eligibleForChangeboarding,
        isCurrentUserContributor,
        isFirstVisit,
        dailyBriefStatus,
        dailyBriefNudgeAction,
        insightsNudgeAction,
        convoStartersNudgeAction,
        actionsById
    ]);
}


const $2b7ed8ae830eb95a$var$AgentMentionSidebarListener = ()=>{
    (0, $97654e51bdd5d39b$export$5985165b88d806e9)();
    return null;
};
const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const { contentType: contentType, contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSessionReady = isLoggedIn && isLicensed && !!cloudId;
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const { isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes } = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !isBaseEligible || !isSessionReady || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const { isFirstVisit: isFirstVisit } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !isBaseEligible || !isSessionReady || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const dailyBriefStatus = (0, $k9SyR.useDailyBriefUnread)();
    const nudges = (0, $8bdd9ea855fe08b8$export$730669e74cd8a0c9)(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
    }, [
        viewPageRovoActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(rovoConfiguration);
        setNudges(nudges);
    }, [
        rovoConfiguration,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$AgentMentionSidebarListener, null) : null;
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};









var $4u3xL = parcelRequire("4u3xL");








var $as9lu = parcelRequire("as9lu");


var $bm4Et = parcelRequire("bm4Et");


var $eDWhq = parcelRequire("eDWhq");


var $9lHB9 = parcelRequire("9lHB9");




var $ZKswU = parcelRequire("ZKswU");






















var $mfdwv = parcelRequire("mfdwv");


var $6gGPb = parcelRequire("6gGPb");


var $dStyd = parcelRequire("dStyd");



















const $8732973ed376fa07$var$messages = (0, $kSwu1.defineMessages)({
    agentMentionNudgeTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-title",
        defaultMessage: "Start chatting with agent"
    },
    agentMentionNudgeTitleWithAgentName: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final",
        defaultMessage: "Start chatting with {agentName}"
    },
    agentMentionNudgeTitle2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-2",
        defaultMessage: "Give agent a task?"
    },
    agentMentionNudgeTitleWithAgentName2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final-2",
        defaultMessage: "Give {agentName} a task?"
    },
    agentMentionNudgeIconLabel: {
        id: "page-rovo-config-common.agent-mention-nudge-icon-label",
        defaultMessage: "Agent icon"
    },
    agentMentionNudgeSecondaryTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-secondary-title",
        defaultMessage: "Start a conversation using this agent"
    }
});
const $8732973ed376fa07$export$d8e8e9b085d2396e = 'agent-mention-nudge';
const $8732973ed376fa07$export$969a8c78a138b693 = 'taskItem';
/** Defined outside the hook so React keeps the same DOM node across re-renders. */ const $8732973ed376fa07$var$AgentMentionIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        size: "small",
        label: label
    });
/**
 * Fallback avatar for the mentioned agent, used when `ResolvedAgentAvatar` has no real account
 * picture to show (no account id, nothing on file, or the fetch failed). Keyed by the agent's
 * Atlassian account id (AAID), from which AgentAvatar derives a stable generated image. Decorative:
 * the nudge title already names the agent, so the avatar is not separately labelled (a label would
 * put aria-label on a role-less element). Defined outside the hook for a stable component identity.
 */ const $8732973ed376fa07$var$AgentMentionAvatar = ({ agentIdentityAccountId: agentIdentityAccountId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentIdentityAccountId: agentIdentityAccountId,
        size: "small",
        showBorder: false
    });
/**
 * Returns true only when the active element is inside the main page editor,
 * excluding comment editors, AI modals and the Rovo prompt screen.
 *
 * Mirrors isMainEditorContent from @confluence/editor-presets — kept local to
 * avoid adding editor-presets as a dependency of this package.
 */ const $8732973ed376fa07$var$isMainEditorContent = (target)=>{
    if (!(target instanceof HTMLElement)) return false;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return false;
    if (target.closest('[data-testid="ak-editor-plugin-ai-modal"]')) return false;
    if (target.closest('[data-testid^="ak-editor-ai"]')) return false;
    if (target.closest('[data-testid="rovo-prompt-session-screen"]')) return false;
    if (target.closest('[data-testid="chromeless-editor"]')) return false;
    return target.closest('.ProseMirror') !== null;
};
function $8732973ed376fa07$export$3e06c63ab8775ee2(agentId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentIdentityAccountId, invokedByNodeLocalId) {
    const resolvedAgentId = agentId ?? null;
    // Convert bare AAID to full IdentityUserAri
    const resolvedAgentIdentityAccountId = agentIdentityAccountId ? (0, $as9lu.IdentityUserAri).create({
        userId: agentIdentityAccountId
    }).toString() : null;
    const resolvedPrompt = agentMentionPrompt ?? '';
    const resolvedPromptAdf = agentMentionContext ?? null;
    const resolvedAgentMentionName = agentMentionName?.trim() || null;
    // With platform_editor_agent_mentions_no_task_autofire on, task-item mentions reach this nudge
    // and draft like every other block (auto-send/seeded-conversation behaviour removed), so treat
    // them as non-task here.
    const isTaskItem = agentMentionParentNodeType === $8732973ed376fa07$export$969a8c78a138b693 && !(0, $9wGTI.fg)('platform_editor_agent_mentions_no_task_autofire');
    const nudgeId = agentMentionInsertionCount && agentMentionInsertionCount > 0 ? `${$8732973ed376fa07$export$d8e8e9b085d2396e}-${agentMentionInsertionCount}` : $8732973ed376fa07$export$d8e8e9b085d2396e;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen } = (0, $93Gae.useRovoExperienceAPIStore)();
    // Keep a ref to the latest prompt so onClick doesn't need it as a dep.
    // agentMentionContext changes on every keystroke; without this, onClick would
    // recreate on each keystroke → cascading memo invalidations → setNudges on every keystroke.
    const resolvedPromptRef = (0, $cozmU.useRef)(resolvedPrompt);
    resolvedPromptRef.current = resolvedPrompt;
    const resolvedPromptAdfRef = (0, $cozmU.useRef)(resolvedPromptAdf);
    resolvedPromptAdfRef.current = resolvedPromptAdf;
    // Keep a ref to the latest agentId so onClick doesn't capture a stale null.
    // agentId resolves asynchronously; without this, the callback created before
    // resolution would permanently close over null.
    const resolvedAgentIdRef = (0, $cozmU.useRef)(resolvedAgentId);
    resolvedAgentIdRef.current = resolvedAgentId;
    const resolvedAgentIdentityAccountIdRef = (0, $cozmU.useRef)(resolvedAgentIdentityAccountId);
    resolvedAgentIdentityAccountIdRef.current = resolvedAgentIdentityAccountId;
    const invokedByNodeLocalIdRef = (0, $cozmU.useRef)(invokedByNodeLocalId ?? null);
    invokedByNodeLocalIdRef.current = invokedByNodeLocalId ?? null;
    const iconLabel = formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeIconLabel);
    // We capture focus on mousedown so we have the correct pre-click value.
    // The handler is bound directly to the nudge button via the action's onMouseDown prop
    const editorHadFocusAtMouseDownRef = (0, $cozmU.useRef)(false);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) return;
        editorHadFocusAtMouseDownRef.current = typeof document !== 'undefined' && $8732973ed376fa07$var$isMainEditorContent(document.activeElement);
    }, []);
    const onClick = (0, $cozmU.useCallback)(()=>{
        // Use the mousedown snapshot — focus has already moved to the nudge button
        // by the time this click handler runs.
        if ((0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            const editorHadFocus = editorHadFocusAtMouseDownRef.current;
            setEditorHadFocusBeforeChatOpen?.(editorHadFocus);
        }
        publish({
            type: 'chat-new',
            source: 'agentMentionEditorNudge',
            openChatMode: 'mini-modal',
            data: {
                prompt: resolvedPromptAdfRef.current ?? resolvedPromptRef.current,
                // Non-task blocks pre-fill as a draft and skip creating a seeded conversation, so
                // the manual send creates and names the conversation instead of leaving a
                // date-named one. With platform_editor_agent_mentions_no_task_autofire off, task-item
                // mentions never reach this nudge (their presence is gated off in
                // EditPageRovoConfigProvider, so they use the auto-fire path instead). With it on,
                // isTaskItem is false so they draft like every other block.
                // This nudge is only surfaced under the platform_editor_agent_mentions experiment
                // (EditPageRovoConfigProvider gates its presence), so the gate below is effectively
                // double-gated without preconditioning it on the experiment here.
                ...isTaskItem ? {} : {
                    overrideAutoSend: true
                },
                ...!isTaskItem && (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
                    skipCreatingSeededConversation: true
                } : {},
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...resolvedAgentIdRef.current ? {
                    agentId: resolvedAgentIdRef.current
                } : {},
                ...resolvedAgentIdentityAccountIdRef.current ? {
                    agentIdentityAccountId: resolvedAgentIdentityAccountIdRef.current
                } : {},
                // Seed the agent-run-state bridge with the invoking node, behind its experiment.
                // Consumed on the manual send via the stash in the pubsub listener.
                ...invokedByNodeLocalIdRef.current && (0, $6mKj3.expValEquals)('platform_editor_agent_state_bridge', 'isEnabled', true) ? {
                    invokedByNodeLocalId: invokedByNodeLocalIdRef.current
                } : {}
            }
        });
    }, [
        publish,
        isTaskItem,
        setEditorHadFocusBeforeChatOpen
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const title = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle);
        const title2 = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName2, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle2);
        // platform_editor_agent_mentions_cta_redesign is what put an agent avatar on this nudge in
        // place of the plain chat icon; it's fully rolled out, so it no longer gives this change a
        // safe off switch on its own. platform_editor_mention_rovo enhances that avatar with a real
        // account picture, so it's nested inside the redesign's branch rather than checked as a
        // sibling: on, the mentioned agent's real picture replaces the avatar (falling back to the
        // specialist agent avatar when unavailable); off, the avatar renders exactly as it does in
        // production today.
        return {
            id: nudgeId,
            title: (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? title2 : title,
            secondaryTitle: formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeSecondaryTitle),
            icon: (0, $9wGTI.fg)('platform_editor_agent_mentions_cta_redesign') ? (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true) ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dStyd.ResolvedAgentAvatar), {
                    agentIdentityAccountId: resolvedAgentIdentityAccountId,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionAvatar, {
                        agentIdentityAccountId: agentIdentityAccountId
                    }),
                    size: "small"
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionAvatar, {
                    agentIdentityAccountId: agentIdentityAccountId
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionIcon, {
                    label: iconLabel
                }),
            onClick: onClick,
            onMouseDown: onMouseDown,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $8732973ed376fa07$export$d8e8e9b085d2396e,
                selfEligible: true,
                experimentName: 'platform_editor_agent_mentions'
            }
        };
    }, [
        formatMessage,
        iconLabel,
        nudgeId,
        onClick,
        onMouseDown,
        resolvedAgentMentionName,
        agentIdentityAccountId,
        resolvedAgentIdentityAccountId
    ]);
}
















var $3z1p5 = parcelRequire("3z1p5");




const $5f4baace2595030e$export$eab6f356b10dc881 = 'content_reviewer_agent';
/** Identifies this touchpoint to the assistance service for the agent lookup. */ const $5f4baace2595030e$var$TOUCHPOINT_SOURCE = 'confluence-edit-page-rovo-chat';
const $5f4baace2595030e$export$38f8263f72e6f3e7 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference } = (0, $3z1p5.usePaginatedAgentByConfigReference)({
        assistanceServiceParams: {
            experienceId: 'ai-mate',
            product: 'confluence',
            siteId: cloudId,
            touchpointSource: $5f4baace2595030e$var$TOUCHPOINT_SOURCE
        }
    });
    const [agent, setAgent] = (0, $cozmU.useState)(undefined);
    // Resolver returns undefined (never rejects) on failure; depend on it to reflect the latest config.
    (0, $cozmU.useEffect)(()=>{
        getAndStoreAgentByExternalConfigReference({
            externalConfigReference: $5f4baace2595030e$export$eab6f356b10dc881
        }).then((resolvedAgent)=>{
            setAgent(resolvedAgent ?? undefined);
        });
    }, [
        getAndStoreAgentByExternalConfigReference
    ]);
    return agent;
};

















const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};











const $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES = 5;
function $1dc1702d58bb7989$export$60835107d4b45e85(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, /**
	 * controls nudge *presence* (truthy = mention exists). Presence also requires
	 * `resolvedAgentMentionId` below, so the nudge never renders (and can't be clicked) before
	 * the Agent Studio UUID has resolved — clicking before resolution would fire `chat-new`
	 * without a routable agentId.
	 */ agentMentionId, /** control nudge *presence* (see above) and *payload* (forwarded to useAgentMentionNudgeAction). */ resolvedAgentMentionId, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionContext, /** control nudge fallback prompt (forwarded to useAgentMentionNudgeAction). */ agentMentionPrompt, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionParentNodeType, /** controls the nudge action id so each inserted mention is treated as a new nudge. */ agentMentionInsertionCount, /** control nudge title (forwarded to useAgentMentionNudgeAction). */ agentMentionName, /** invoking mention node localId (forwarded to seed the agent-run-state bridge). */ invokedByNodeLocalId) {
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const agentMentionNudgeAction = (0, $8732973ed376fa07$export$3e06c63ab8775ee2)(resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentMentionId, invokedByNodeLocalId);
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $cozmU.useMemo)(()=>{
        // Require resolvedAgentMentionId too: without it, a click fired before the AAID→UUID
        // resolution completes would publish `chat-new` with no agentId, silently routing to
        // the default/current conversation agent instead of the mentioned one.
        const alwaysOnNudges = agentMentionId && resolvedAgentMentionId ? [
            agentMentionNudgeAction
        ] : [];
        const contentReviewerNudge = actionsById.get('content-reviewer-nudge');
        if (contentReviewerNudge) alwaysOnNudges.push(contentReviewerNudge);
        if (!enableLiveDocNudges) return alwaysOnNudges;
        const isAudioBriefingEligible = !isEligibilityLoading && !eligibleForChangeboarding && isFirstVisit && !isCurrentUserContributor && readTimeMinutes !== null && readTimeMinutes >= $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES;
        const nudgeEntries = [
            {
                actionId: 'status-updates-automation',
                enabled: (0, $9wGTI.fg)('cc_automations_discovery_nudges')
            },
            {
                actionId: 'audio-briefing',
                enabled: isAudioBriefingEligible
            }
        ];
        const liveDocNudges = nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
        return [
            ...alwaysOnNudges,
            ...liveDocNudges
        ];
    }, [
        agentMentionId,
        // resolvedAgentMentionId now also gates presence (see above), so it must be a dep.
        // agentMentionContext/agentMentionParentNodeType/agentMentionName remain payload-only:
        // agentMentionNudgeAction already invalidates on those values.
        resolvedAgentMentionId,
        agentMentionNudgeAction,
        enableLiveDocNudges,
        isEligibilityLoading,
        eligibleForChangeboarding,
        isFirstVisit,
        isCurrentUserContributor,
        readTimeMinutes,
        actionsById
    ]);
}



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $4ez2K = parcelRequire("4ez2K");


var $jQDPt = parcelRequire("jQDPt");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
]; /* istanbul ignore next */ 
const $efb362169c233167$var$styles = {
    iconContainer: "_4FKVYEgVvo"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6iWVH.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $jQDPt.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $4c762b6d974e46d5$exports = {};
$4c762b6d974e46d5$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $kSwu1.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    },
    copiedPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.copied-page-greeting-title",
        defaultMessage: "Need help editing your copied page?"
    },
    suggestEditsMenuItemLabel: {
        id: "edit-page-rovo-config-provider.menu.item.label.suggest-edits",
        defaultMessage: "Review with suggestions"
    },
    suggestEditsMenuItemPrompt: {
        id: "edit-page-rovo-config-provider.menu.item.prompt.suggest-edits-agent",
        defaultMessage: "Review my content and suggest improvements"
    }
});
/** Max length for the prompt-derived chat history title (matches other Rovo chat channels). */ const $7e583ad86f1e8aa8$var$AGENT_MENTION_CHAT_TITLE_MAX_LENGTH = 30;
const $7e583ad86f1e8aa8$var$AGENT_MENTION_BRIDGE_CLIENT_PREFIX = 'confluence-editor-agent-mention-';
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const copiedPageContentId = (0, $02cx8.useEditorRovoButtonCopiedPageContentId)();
    const copiedPageActions = (0, $02cx8.useEditorRovoButtonCopiedPageActions)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Resolve the OOTB Content Reviewer agent that backs the "Review with suggestions" entry point.
    // Existence check only (no provisioning); if the agent isn't provisioned the entry point is
    // hidden.
    const contentReviewerAgent = (0, $5f4baace2595030e$export$38f8263f72e6f3e7)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { promptCards: promptCards } = (0, $ZKswU.usePromptCards)();
    const isEmptyPageWithPromptCards = isEditorEmpty && Array.isArray(promptCards);
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const readTimeMinutes = pageProps?.readTime ?? null;
    const readTimeLoading = pageProps?.readTimeLoading ?? false;
    const suggestEditsActionIcon = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))), {
            label: ""
        }), []);
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType);
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { isFirstVisit: isFirstVisit, loading: isFirstVisitLoading } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !enableLiveDocNudges);
    const { isCurrentUserContributor: isCurrentUserContributor, loading: isContributorLoading } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !enableLiveDocNudges);
    const isEligibilityLoading = isFirstVisitLoading || isContributorLoading || readTimeLoading;
    const agentMentionId = (0, $02cx8.useEditorRovoButtonAgentMentionId)();
    const agentMentionInsertionCount = (0, $02cx8.useEditorRovoButtonAgentMentionInsertionCount)();
    const resolvedAgentMentionId = (0, $02cx8.useEditorRovoButtonResolvedAgentMentionId)();
    const agentMentionContext = (0, $02cx8.useEditorRovoButtonAgentMentionContext)();
    const agentMentionPrompt = (0, $02cx8.useEditorRovoButtonAgentMentionPrompt)();
    const agentMentionName = (0, $02cx8.useEditorRovoButtonAgentMentionName)();
    const agentMentionParentNodeType = (0, $02cx8.useEditorRovoButtonAgentMentionParentNodeType)();
    const agentMentionNodeLocalId = (0, $02cx8.useEditorRovoButtonAgentMentionNodeLocalId)();
    // When platform_editor_agent_mentions_no_task_autofire is on, task-item mentions drop their
    // auto-fire special case and follow the same nudge path as every other block, so treat them as
    // non-task items here. This one flag flips both the nudge-presence arg below and the (now
    // legacy) auto-fire effect.
    const isTaskItemMention = agentMentionParentNodeType === (0, $8732973ed376fa07$export$969a8c78a138b693) && !(0, $9wGTI.fg)('platform_editor_agent_mentions_no_task_autofire');
    const nudges = (0, $1dc1702d58bb7989$export$60835107d4b45e85)(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, // Legacy task-item auto-fire keeps them out of the nudge. With
    // platform_editor_agent_mentions_no_task_autofire on, isTaskItemMention is false so task
    // items show the nudge like any block. expValEquals last ensures exposure is tracked.
    !isTaskItemMention && (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) ? agentMentionId : null, resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentMentionNodeLocalId);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const agentMentionBridgeClientId = (0, $cozmU.useMemo)(()=>(0, $bm4Et.client)(`${$7e583ad86f1e8aa8$var$AGENT_MENTION_BRIDGE_CLIENT_PREFIX}${contentId || 'fallback'}`), [
        contentId
    ]);
    const { send: sendBridgeMessage, ready: readyBridgeClient } = (0, $eDWhq.useRovoContentBridgeAPI)(agentMentionBridgeClientId);
    const hasCalledBridgeReadyRef = (0, $cozmU.useRef)(false);
    // Keep refs so the auto-fire effect can read the latest agent mention prompt/context without
    // them being reactive dependencies. Adding them to the dep array would cause the effect to
    // re-fire on every keystroke in the task item without agentMentionInsertionCount changing.
    const agentMentionPromptRef = (0, $cozmU.useRef)(agentMentionPrompt);
    agentMentionPromptRef.current = agentMentionPrompt;
    const agentMentionContextRef = (0, $cozmU.useRef)(agentMentionContext);
    agentMentionContextRef.current = agentMentionContext;
    // Keep the invoking node localId in a ref so the auto-fire effect can read the latest value
    // without it being a reactive dependency (matching the prompt/context refs above).
    const agentMentionNodeLocalIdRef = (0, $cozmU.useRef)(agentMentionNodeLocalId);
    agentMentionNodeLocalIdRef.current = agentMentionNodeLocalId;
    // Legacy auto-fire when an agent is @mentioned inside a task item. The inline-Rovo treatment
    // runs through the content bridge without opening chat, and the control retains the existing
    // mini-modal flow. Both remain gated by platform_editor_agent_mentions. This whole effect is
    // disabled once platform_editor_agent_mentions_no_task_autofire is on: isTaskItemMention is
    // false, so the guard below returns early and task items fall back to the shared nudge path.
    (0, $cozmU.useEffect)(()=>{
        if (!isTaskItemMention || !resolvedAgentMentionId || !agentMentionInsertionCount || !(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return;
        const promptText = agentMentionPromptRef.current?.trim();
        if ((0, $6mKj3.expValEquals)('platform_editor_agent_mentions_nudge_indication', 'isEnabled', true)) {
            if (!contentId || !promptText) return;
            if (!hasCalledBridgeReadyRef.current) {
                readyBridgeClient();
                hasCalledBridgeReadyRef.current = true;
            }
            sendBridgeMessage((0, $9lHB9.InlineInputBoxSendMessageCommand), {
                receiverId: (0, $9lHB9.ROVO_CHAT_CLIENT_ID),
                prompt: promptText,
                source: 'agentMentionTaskItemAutoFire',
                productKey: 'confluence',
                contentId: contentId,
                agentId: resolvedAgentMentionId,
                ...agentMentionName ? {
                    agentName: agentMentionName
                } : {},
                ...agentMentionId ? {
                    agentIdentityAccountId: (0, $as9lu.IdentityUserAri).create({
                        userId: agentMentionId
                    }).toString()
                } : {},
                deepResearchEnabled: false,
                webSearchEnabled: false,
                openChat: false,
                openChatOnError: false,
                addCurrentPageAsContextUserPreference: true,
                contentContext: 'global'
            });
            return;
        }
        const prompt = agentMentionContextRef.current ?? agentMentionPromptRef.current;
        // Plain-text title for the chat history entry, derived from the task text. Inline-atom
        // nodes (the agent mention, custom/reaction emoji, etc.) are dropped by ProseMirror's
        // textContent; plain typed text is kept. Truncate by code point rather than UTF-16 unit
        // so an astral character (e.g. a typed Unicode emoji) on the boundary isn't split into an
        // unpaired surrogate. Without a title the auto-sent, seeded conversation shows only a date.
        const conversationName = promptText ? Array.from(promptText).slice(0, $7e583ad86f1e8aa8$var$AGENT_MENTION_CHAT_TITLE_MAX_LENGTH).join('') : undefined;
        publish({
            type: 'chat-new',
            source: 'agentMentionTaskItemAutoFire',
            openChatMode: 'mini-modal',
            autoFocusInput: false,
            data: {
                ...prompt ? {
                    prompt: prompt
                } : {},
                ...conversationName && (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
                    name: conversationName
                } : {},
                isPromptPlaceholder: false,
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                agentId: resolvedAgentMentionId,
                ...agentMentionName ? {
                    agentName: agentMentionName
                } : {},
                // Reconstruct the full identity ARI from the bare accountId stored in the ADF mention node.
                // agentMentionId is "712020:..." (bare), but downstream consumers (TelepointerAvatar,
                // sendMessageActionProvider) expect the full "ari:cloud:identity::user/712020:..." ARI.
                ...agentMentionId ? {
                    agentIdentityAccountId: (0, $as9lu.IdentityUserAri).create({
                        userId: agentMentionId
                    }).toString()
                } : {},
                // Seed the agent-run-state bridge with the invoking node, behind its experiment.
                ...agentMentionNodeLocalIdRef.current && (0, $6mKj3.expValEquals)('platform_editor_agent_state_bridge', 'isEnabled', true) ? {
                    invokedByNodeLocalId: agentMentionNodeLocalIdRef.current
                } : {}
            }
        });
    }, [
        agentMentionId,
        agentMentionInsertionCount,
        agentMentionName,
        contentId,
        readyBridgeClient,
        resolvedAgentMentionId,
        sendBridgeMessage,
        isTaskItemMention,
        // agentMentionPrompt/agentMentionContext intentionally omitted — read via refs above to avoid
        // re-firing on every keystroke after the mention is inserted.
        publish
    ]);
    const config = (0, $cozmU.useMemo)(()=>{
        // The copied-page slice is the only copy signal — never infer it from `editorActions`, which
        // the editor's smart-button plugin fills (with no selection reference) on every edit page.
        // Experiment evaluated last so exposure only fires for a genuine copied page.
        const isCopiedPageRovoChat = !!contentId && copiedPageContentId === contentId && copiedPageActions.length > 0 && !editorActionsContext?.reference && (0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat');
        const getCustomGreeting = ()=>{
            if (isEmptyPageWithPromptCards && !isCopiedPageRovoChat) return {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4c762b6d974e46d5$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            };
            if (isCopiedPageRovoChat) return {
                title: formatMessage($7e583ad86f1e8aa8$var$messages.copiedPageGreetingTitle)
            };
            return undefined;
        };
        const customGreeting = getCustomGreeting();
        const suggestEditsAction = {
            id: 'suggest-edits-ai-action',
            title: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemLabel),
            icon: suggestEditsActionIcon,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemPrompt),
            agent: contentReviewerAgent
        };
        // Show the suggest-edits action (chat with the OOTB Content Reviewer agent) only when the
        // gate is on and the agent is provisioned — no skill fallback, no provisioning on click.
        // The experiment is evaluated in its own statement (not chained with the gate) to satisfy
        // the no-preconditioning rule; the agent is only resolved when the gate is on.
        const isSuggestEditsExperimentEnabled = isRovoLLMEnabled && !!contentReviewerAgent && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true);
        const isSuggestEditsActionEnabled = isSuggestEditsExperimentEnabled && (0, $9wGTI.fg)('content_reviewer_agent');
        const combinedEditorActions = isSuggestEditsActionEnabled ? [
            suggestEditsAction,
            ...editorActions
        ] : editorActions;
        const baseConfig = {
            getActions: async ()=>{
                // Only the copied-page action(s), so nothing sits above copy-with-rovo. Paired with
                // `prioritizeCustomActionResults` below.
                if (isCopiedPageRovoChat) return Promise.resolve(copiedPageActions);
                if (isEmptyPageWithPromptCards) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(combinedEditorActions);
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...combinedEditorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: customGreeting,
            shouldShowGreeting: customGreeting !== undefined || undefined,
            prioritizeCustomActionResults: isCopiedPageRovoChat || isEmptyPageWithPromptCards ? true : undefined
        };
        return baseConfig;
    }, [
        editorActions,
        editorActionsContext,
        contentId,
        copiedPageContentId,
        copiedPageActions,
        viewPageRovoActions,
        isEmptyPageWithPromptCards,
        isRovoLLMEnabled,
        contentReviewerAgent,
        promptCards,
        formatMessage,
        suggestEditsActionIcon
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
        setNudges(nudges);
    }, [
        config,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return null;
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};









var $NHD0A = parcelRequire("NHD0A");
































var $dF5G8 = parcelRequire("dF5G8");

const $f7deda53c4334bac$export$a15e5171a3cb34f2 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ReviewButtonPlaceholder() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $dF5G8.reviewButtonMessages).suggestionsLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const label = t0;
    const t1 = isRovoButtonEnabled ? "default" : "circle";
    let t2;
    if ($[2] !== label || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))),
            label: label,
            shape: t1,
            isDisabled: true,
            testId: "object-sidebar-review-button"
        });
        $[2] = label;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== label || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: label,
            position: "left",
            delay: 0
        }, t2);
        $[5] = label;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function ReviewButtonPlaceholder() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const label = formatMessage((0, $dF5G8.reviewButtonMessages).suggestionsLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label,
        position: "left",
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))),
        label: label,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        isDisabled: true,
        testId: "object-sidebar-review-button"
    }));
};

const $f7deda53c4334bac$export$ff0e0e22e0001f5b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fnpd8",
    name: "ReviewButtonLoader",
    loading: ()=>(0, $9wGTI.fg)('confluence_sidebar_buttons_initial_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7deda53c4334bac$export$a15e5171a3cb34f2, null) : null,
    loader: async ()=>(await (parcelRequire("5Uf3U"))).ReviewButton
});












var $5qQdB = parcelRequire("5qQdB");


const $c0d001f61b78e98b$export$41c46dd9735e3599 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y3Elg",
    name: "TableOfContentsPopupButtonLoader",
    loading: ()=>(0, $9wGTI.fg)('confluence_sidebar_buttons_initial_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5qQdB.TableOfContentsButtonPlaceholder), null) : null,
    loader: async ()=>(await (parcelRequire("kKSyI"))).TableOfContentsPopupButton
});


















var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("cYXKf"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("cYXKf"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $cozmU.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled || !renderServerPlaceholder && !audioSupportedByBrowser;
    const t5 = audioSupportedByBrowser ?? true;
    let t6;
    if ($[4] !== t5) {
        t6 = {
            audioSupportedByBrowserFromWrapper: t5
        };
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const wrapperProps = t6;
    let t7;
    if ($[6] !== contentId || $[7] !== contentTitle || $[8] !== contentType || $[9] !== immediateActivationCondition || $[10] !== isButtonDisabled || $[11] !== spaceKey || $[12] !== wrapperProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[6] = contentId;
        $[7] = contentTitle;
        $[8] = contentType;
        $[9] = immediateActivationCondition;
        $[10] = isButtonDisabled;
        $[11] = spaceKey;
        $[12] = wrapperProps;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $cozmU.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 2) user activates the button via keyboard focus
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};











/* HerButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $iMnC5 = parcelRequire("iMnC5");





var $gRv41 = parcelRequire("gRv41");


var $5xmyM = parcelRequire("5xmyM");

const $31e30a93afdc1384$var$styles = {
    icon: "_0jFU0VoWWg _39xV02oWWg"
};
const $31e30a93afdc1384$var$getAudioLevel = ()=>0;
function $31e30a93afdc1384$export$eca6b6ab857179f1({ contentId: contentId, cloudId: cloudId, contentType: contentType }) {
    const { isHerActive: isHerActive, toggleHer: toggleHer } = (0, $gRv41.useHerStore)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        toggleHer(contentId, cloudId, contentType);
    }, [
        toggleHer,
        contentId,
        cloudId,
        contentType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: "Rovo Voice",
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $31e30a93afdc1384$var$styles.icon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5xmyM.Constellation), {
                active: isHerActive,
                getAudioLevel: $31e30a93afdc1384$var$getAudioLevel,
                paused: false,
                pose: "still"
            })),
        label: "Rovo Voice",
        shape: "default",
        isSelected: isHerActive,
        onClick: handleClick,
        testId: "enterprise-her-button"
    }));
}





const $d34346cf549a725a$export$2501aa4690daf770 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== contentType) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ contentId: contentId, contentType: contentType })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId
    });
};



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar = [
    '--right',
    'PanelWidth'
].join('');

const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("kONYb"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("gN62b"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$AgentReceiptPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R8yoa",
    name: "AgentReceiptPanelButton",
    loader: async ()=>(await (parcelRequire("2sYsz"))).AgentReceiptPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("cv9SU"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("jyQuB"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$RemixPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CmH6Z",
    name: "RemixPanelButton",
    loader: async ()=>(await (parcelRequire("a02bs"))).RemixPanelButton
});

const $3265ee1fae39f7d6$var$AgentsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RyToS",
    name: "AgentsPanelButton",
    loader: async ()=>(await (parcelRequire("fmz8s"))).AgentsPanelButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("jzzzm"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("3R9tJ"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$markdownModeObjectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStyles = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $kSwu1.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$var$ObjectSidebarControlContent = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(221);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, hasReviewButton: hasReviewButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t1, pageCommentsSectionInView: pageCommentsSectionInView, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t2, isDatabasesStagingArea: t3, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments } = t0;
    const aiIsStreaming = t1 === undefined ? false : t1;
    const shouldDisableUndoRedo = t2 === undefined ? false : t2;
    const isDatabasesStagingArea = t3 === undefined ? false : t3;
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, showSidebarControlIfNoPanel: showSidebarControlIfNoPanel, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[2] = t6;
    } else t6 = $[2];
    const isOnPDFExportPageRouteArgs = t6;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t7] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t7;
    let t8;
    if ($[3] !== isAdminHubAIEnabled || $[4] !== isLiveViewMode || $[5] !== isRovoButtonEnabled || $[6] !== pageMode) {
        t8 = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)("confluence_rovo_live_doc_nudges");
        $[3] = isAdminHubAIEnabled;
        $[4] = isLiveViewMode;
        $[5] = isRovoButtonEnabled;
        $[6] = pageMode;
        $[7] = t8;
    } else t8 = $[7];
    const skipReadTime = t8;
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const objectSidebarRemixLifecycleAdapter = (0, $eCmUm.useObjectSidebarRemixLifecycleAdapter)();
    let t9;
    if ($[8] !== setSidebarControlExpandCollapsedState) {
        t9 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[8] = setSidebarControlExpandCollapsedState;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== contentId || $[11] !== setSidebarControlExpandCollapsedState) {
        t10 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[10] = contentId;
        $[11] = setSidebarControlExpandCollapsedState;
        $[12] = t10;
    } else t10 = $[12];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[13] !== isObjectSidebarShown || $[14] !== setSidebarControlExpandCollapsedState || $[15] !== setSidebarControlState || $[16] !== showSidebarControlIfNoPanel) {
        t11 = ()=>{
            if ((0, $6mKj3.expValEquals)("cc_comments_detached_in_open_view", "isEnabled", true)) showSidebarControlIfNoPanel();
            else if (!isObjectSidebarShown) setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t12 = [
            showSidebarControlIfNoPanel,
            setSidebarControlState,
            setSidebarControlExpandCollapsedState,
            isObjectSidebarShown
        ];
        $[13] = isObjectSidebarShown;
        $[14] = setSidebarControlExpandCollapsedState;
        $[15] = setSidebarControlState;
        $[16] = showSidebarControlIfNoPanel;
        $[17] = t11;
        $[18] = t12;
    } else {
        t11 = $[17];
        t12 = $[18];
    }
    (0, $cozmU.useEffect)(t11, t12);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let primaryActions;
    let secondaryActionsTeam25;
    let shouldRenderFloatingTableOfContents;
    if ($[19] !== agentTrustReceipt || $[20] !== aiIsStreaming || $[21] !== aiSuggestionsButtonActions || $[22] !== contentBodyDynamic?.value || $[23] !== contentId || $[24] !== contentTitle || $[25] !== contentType || $[26] !== disabled || $[27] !== editorAIActions || $[28] !== editorApi || $[29] !== getAdfDocument || $[30] !== hasAgentReceiptButton || $[31] !== hasAudioButton || $[32] !== hasCommentsButton || $[33] !== hasDetailsButton || $[34] !== hasLoomButton || $[35] !== hasRemixButton || $[36] !== hasReviewButton || $[37] !== hasUndoRedoButton || $[38] !== isAudioV3Enabled || $[39] !== isDatabasesStagingArea || $[40] !== isEditorEmpty || $[41] !== isLivePage || $[42] !== isLiveViewMode || $[43] !== isLoomDisabled || $[44] !== isNetworkDisabled || $[45] !== isRovoButtonEnabled || $[46] !== pageMode || $[47] !== preloadedCanAddComments || $[48] !== scrollToEditorHeading || $[49] !== shouldDisableUndoRedo || $[50] !== showDiffButtonActions || $[51] !== sidebarIsExpanded || $[52] !== spaceKey || $[53] !== undoRedoButtonActions) {
        collapsedActions = [];
        if ($[58] !== aiIsStreaming || $[59] !== hasUndoRedoButton || $[60] !== isDatabasesStagingArea || $[61] !== isLiveViewMode || $[62] !== shouldDisableUndoRedo || $[63] !== showDiffButtonActions || $[64] !== undoRedoButtonActions) {
            primaryActions = [];
            if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
                if (undo && canUndo !== undefined) {
                    const t13 = aiIsStreaming || shouldDisableUndoRedo;
                    let t14;
                    if ($[66] !== canUndo || $[67] !== t13 || $[68] !== undo) {
                        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                            canUndo: canUndo,
                            undo: undo,
                            isDisabled: t13
                        });
                        $[66] = canUndo;
                        $[67] = t13;
                        $[68] = undo;
                        $[69] = t14;
                    } else t14 = $[69];
                    primaryActions.push(t14);
                }
                if (redo && canRedo !== undefined) {
                    const t13 = aiIsStreaming || shouldDisableUndoRedo;
                    let t14;
                    if ($[70] !== canRedo || $[71] !== redo || $[72] !== t13) {
                        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                            canRedo: canRedo,
                            redo: redo,
                            isDisabled: t13
                        });
                        $[70] = canRedo;
                        $[71] = redo;
                        $[72] = t13;
                        $[73] = t14;
                    } else t14 = $[73];
                    primaryActions.push(t14);
                }
            }
            if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
                const t13 = isShowDiffEnabled && !aiIsStreaming;
                let t14;
                if ($[74] !== isShowDiffSelected || $[75] !== onShowDiff || $[76] !== t13) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                        isShowDiffSelected: isShowDiffSelected,
                        isShowDiffEnabled: t13,
                        onShowDiff: onShowDiff
                    });
                    $[74] = isShowDiffSelected;
                    $[75] = onShowDiff;
                    $[76] = t13;
                    $[77] = t14;
                } else t14 = $[77];
                primaryActions.push(t14);
            }
            $[58] = aiIsStreaming;
            $[59] = hasUndoRedoButton;
            $[60] = isDatabasesStagingArea;
            $[61] = isLiveViewMode;
            $[62] = shouldDisableUndoRedo;
            $[63] = showDiffButtonActions;
            $[64] = undoRedoButtonActions;
            $[65] = primaryActions;
        } else primaryActions = $[65];
        secondaryActionsTeam25 = [];
        if (hasCommentsButton) {
            let t13;
            if ($[78] !== contentId || $[79] !== isNetworkDisabled || $[80] !== preloadedCanAddComments) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                    key: "comment-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled,
                    preloadedCanAddComments: preloadedCanAddComments
                });
                $[78] = contentId;
                $[79] = isNetworkDisabled;
                $[80] = preloadedCanAddComments;
                $[81] = t13;
            } else t13 = $[81];
            secondaryActionsTeam25.push(t13);
            if (!sidebarIsExpanded) {
                let t14;
                if ($[82] !== contentId || $[83] !== isNetworkDisabled || $[84] !== preloadedCanAddComments) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button-collapsed",
                        contentId: contentId,
                        collapsed: true,
                        isDisabled: isNetworkDisabled,
                        preloadedCanAddComments: preloadedCanAddComments
                    });
                    $[82] = contentId;
                    $[83] = isNetworkDisabled;
                    $[84] = preloadedCanAddComments;
                    $[85] = t14;
                } else t14 = $[85];
                collapsedActions.push(t14);
            }
        }
        if (hasDetailsButton) {
            let t13;
            if ($[86] !== contentId || $[87] !== isNetworkDisabled) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                    key: "details-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled
                });
                $[86] = contentId;
                $[87] = isNetworkDisabled;
                $[88] = t13;
            } else t13 = $[88];
            secondaryActionsTeam25.push(t13);
            if (!sidebarIsExpanded) {
                let t14;
                if ($[89] !== contentId || $[90] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button-collapsed",
                        contentId: contentId,
                        collapsed: true,
                        isDisabled: isNetworkDisabled
                    });
                    $[89] = contentId;
                    $[90] = isNetworkDisabled;
                    $[91] = t14;
                } else t14 = $[91];
                collapsedActions.push(t14);
            }
        }
        if (hasAgentReceiptButton && agentTrustReceipt) {
            let t13;
            if ($[92] !== agentTrustReceipt || $[93] !== isNetworkDisabled) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
                    key: "agent-receipt-panel-button",
                    receipt: agentTrustReceipt,
                    isDisabled: isNetworkDisabled
                });
                $[92] = agentTrustReceipt;
                $[93] = isNetworkDisabled;
                $[94] = t13;
            } else t13 = $[94];
            secondaryActionsTeam25.push(t13);
        }
        if ((0, $6mKj3.isExperimentEnabled)("enterprise_her")) {
            const t13 = contentType ?? "";
            let t14;
            if ($[95] !== contentId || $[96] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
                    key: "enterprise-her-button-wrapper",
                    contentId: contentId,
                    contentType: t13
                });
                $[95] = contentId;
                $[96] = t13;
                $[97] = t14;
            } else t14 = $[97];
            secondaryActionsTeam25.push(t14);
        }
        if (hasAudioButton) {
            if (isAudioV3Enabled) {
                const t13 = contentType ?? "";
                const t14 = spaceKey ?? "";
                const t15 = contentTitle ?? "";
                let t16;
                if ($[98] !== contentId || $[99] !== disabled || $[100] !== isLivePage || $[101] !== isRovoButtonEnabled || $[102] !== t13 || $[103] !== t14 || $[104] !== t15) {
                    t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                        key: "audio-listen-button-wrapper",
                        isRovoButtonEnabled: isRovoButtonEnabled,
                        contentId: contentId,
                        contentType: t13,
                        isLivePage: isLivePage,
                        spaceKey: t14,
                        title: t15,
                        isAutoOpenDisabled: disabled
                    });
                    $[98] = contentId;
                    $[99] = disabled;
                    $[100] = isLivePage;
                    $[101] = isRovoButtonEnabled;
                    $[102] = t13;
                    $[103] = t14;
                    $[104] = t15;
                    $[105] = t16;
                } else t16 = $[105];
                secondaryActionsTeam25.push(t16);
            } else {
                const t13 = pageMode === (0, $cD1qu.PageMode).VIEW;
                let t14;
                if ($[106] !== contentId || $[107] !== contentTitle || $[108] !== contentType || $[109] !== isNetworkDisabled || $[110] !== spaceKey || $[111] !== t13) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                        key: "audio-button-loader-wrapper",
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        contentTitle: contentTitle,
                        isDisabled: isNetworkDisabled,
                        isView: t13
                    });
                    $[106] = contentId;
                    $[107] = contentTitle;
                    $[108] = contentType;
                    $[109] = isNetworkDisabled;
                    $[110] = spaceKey;
                    $[111] = t13;
                    $[112] = t14;
                } else t14 = $[112];
                secondaryActionsTeam25.push(t14);
            }
        }
        if (hasLoomButton && !isLoomDisabled) {
            const t13 = spaceKey ?? "";
            const t14 = contentType ?? "";
            const t15 = !isRovoButtonEnabled;
            let t16;
            if ($[113] !== contentId || $[114] !== isNetworkDisabled || $[115] !== t13 || $[116] !== t14 || $[117] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                    key: "page-header-loom-entry-point",
                    contentId: contentId,
                    crossSellPopupPlacement: "left-end",
                    crossSellSpotlightPlacement: "left-start",
                    spaceKey: t13,
                    contentType: t14,
                    isCircle: t15,
                    testId: "sidebar-loom-button",
                    source: "contentWrapper",
                    isDisabled: isNetworkDisabled
                });
                $[113] = contentId;
                $[114] = isNetworkDisabled;
                $[115] = t13;
                $[116] = t14;
                $[117] = t15;
                $[118] = t16;
            } else t16 = $[118];
            secondaryActionsTeam25.push(t16);
        }
        if (editorAIActions) {
            let t13;
            if ($[119] !== aiIsStreaming || $[120] !== editorAIActions) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                    key: "editor-ai-actions",
                    editorAIActions: editorAIActions,
                    isDisabled: aiIsStreaming
                });
                $[119] = aiIsStreaming;
                $[120] = editorAIActions;
                $[121] = t13;
            } else t13 = $[121];
            secondaryActionsTeam25.push(t13);
        }
        if (hasRemixButton && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.expValEquals)("cc-maui-object-level-remix-experiment", "isEnabled", true)) {
            const t13 = contentBodyDynamic?.value;
            let t14;
            if ($[122] !== getAdfDocument || $[123] !== isEditorEmpty || $[124] !== isNetworkDisabled || $[125] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                    key: "remix-panel-button",
                    contentBodyValue: t13,
                    getAdfDocument: getAdfDocument,
                    isEditorEmpty: isEditorEmpty,
                    isDisabled: isNetworkDisabled
                });
                $[122] = getAdfDocument;
                $[123] = isEditorEmpty;
                $[124] = isNetworkDisabled;
                $[125] = t13;
                $[126] = t14;
            } else t14 = $[126];
            const remixButton = t14;
            secondaryActionsTeam25.push(remixButton);
        }
        let t13;
        if ($[127] !== contentType || $[128] !== editorApi || $[129] !== pageMode) {
            t13 = (contentType === "page" || contentType === "blogpost") && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi || (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) && (0, $9wGTI.fg)("confluence_sidebar_buttons_initial_render")) && (0, $6mKj3.expValEquals)("platform_editor_floating_toc", "isEnabled", true);
            $[127] = contentType;
            $[128] = editorApi;
            $[129] = pageMode;
            $[130] = t13;
        } else t13 = $[130];
        shouldRenderFloatingTableOfContents = t13;
        if (shouldRenderFloatingTableOfContents) {
            let t14;
            if ($[131] !== editorApi || $[132] !== pageMode) {
                t14 = pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi && (0, $9wGTI.fg)("confluence_sidebar_buttons_initial_render");
                $[131] = editorApi;
                $[132] = pageMode;
                $[133] = t14;
            } else t14 = $[133];
            const t15 = contentBodyDynamic?.value;
            let t16;
            if ($[134] !== contentType || $[135] !== editorApi || $[136] !== pageMode || $[137] !== scrollToEditorHeading || $[138] !== t14 || $[139] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0d001f61b78e98b$export$41c46dd9735e3599), {
                    key: "table-of-contents-popup-button",
                    isDisabled: t14,
                    contentBodyValue: t15,
                    contentType: contentType,
                    editorApi: editorApi,
                    pageMode: pageMode,
                    popupPositioningRef: objectSidebarControlRef,
                    scrollToEditorHeading: scrollToEditorHeading
                });
                $[134] = contentType;
                $[135] = editorApi;
                $[136] = pageMode;
                $[137] = scrollToEditorHeading;
                $[138] = t14;
                $[139] = t15;
                $[140] = t16;
            } else t16 = $[140];
            secondaryActionsTeam25.unshift(t16);
        }
        const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
        if ((aiSuggestionsButtonActions || hasReviewButton && (0, $9wGTI.fg)("confluence_sidebar_buttons_initial_render")) && isEditingPage && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true)) {
            const t14 = aiSuggestionsButtonActions?.onStartThinking;
            const t15 = !aiSuggestionsButtonActions || isNetworkDisabled;
            const t16 = aiSuggestionsButtonActions?.showNotificationDot;
            let t17;
            if ($[141] !== t14 || $[142] !== t15 || $[143] !== t16) {
                t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7deda53c4334bac$export$ff0e0e22e0001f5b), {
                    key: "review-button",
                    onStartThinking: t14,
                    isDisabled: t15,
                    showNotificationDot: t16
                });
                $[141] = t14;
                $[142] = t15;
                $[143] = t16;
                $[144] = t17;
            } else t17 = $[144];
            secondaryActionsTeam25.push(t17);
        }
        if ((0, $9wGTI.fg)("confluence_ai_agents_sidebar_button")) {
            let t14;
            if ($[145] !== contentId || $[146] !== isNetworkDisabled) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
                    key: "agents-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled
                });
                $[145] = contentId;
                $[146] = isNetworkDisabled;
                $[147] = t14;
            } else t14 = $[147];
            secondaryActionsTeam25.push(t14);
        }
        $[19] = agentTrustReceipt;
        $[20] = aiIsStreaming;
        $[21] = aiSuggestionsButtonActions;
        $[22] = contentBodyDynamic?.value;
        $[23] = contentId;
        $[24] = contentTitle;
        $[25] = contentType;
        $[26] = disabled;
        $[27] = editorAIActions;
        $[28] = editorApi;
        $[29] = getAdfDocument;
        $[30] = hasAgentReceiptButton;
        $[31] = hasAudioButton;
        $[32] = hasCommentsButton;
        $[33] = hasDetailsButton;
        $[34] = hasLoomButton;
        $[35] = hasRemixButton;
        $[36] = hasReviewButton;
        $[37] = hasUndoRedoButton;
        $[38] = isAudioV3Enabled;
        $[39] = isDatabasesStagingArea;
        $[40] = isEditorEmpty;
        $[41] = isLivePage;
        $[42] = isLiveViewMode;
        $[43] = isLoomDisabled;
        $[44] = isNetworkDisabled;
        $[45] = isRovoButtonEnabled;
        $[46] = pageMode;
        $[47] = preloadedCanAddComments;
        $[48] = scrollToEditorHeading;
        $[49] = shouldDisableUndoRedo;
        $[50] = showDiffButtonActions;
        $[51] = sidebarIsExpanded;
        $[52] = spaceKey;
        $[53] = undoRedoButtonActions;
        $[54] = collapsedActions;
        $[55] = primaryActions;
        $[56] = secondaryActionsTeam25;
        $[57] = shouldRenderFloatingTableOfContents;
    } else {
        collapsedActions = $[54];
        primaryActions = $[55];
        secondaryActionsTeam25 = $[56];
        shouldRenderFloatingTableOfContents = $[57];
    }
    let t13;
    bb0: {
        if (contentType === "folder") {
            let t14;
            if ($[148] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).FOLDER,
                    provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
                };
                $[148] = t14;
            } else t14 = $[148];
            t13 = t14;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t14;
            if ($[149] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[149] = t14;
            } else t14 = $[149];
            t13 = t14;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t14;
            if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[150] = t14;
            } else t14 = $[150];
            t13 = t14;
            break bb0;
        }
        t13 = undefined;
    }
    const rovoConfiguration = t13;
    if (isOnPDFExportPageRoute) return null;
    let t14;
    if ($[151] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
        $[151] = t14;
    } else t14 = $[151];
    const isEmbeddedConfluence = t14;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    let t15;
    if ($[152] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setActionBarIsHovered(true);
        };
        $[152] = t15;
    } else t15 = $[152];
    const handleMouseEnter = t15;
    let t16;
    if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(false);
        };
        $[153] = t16;
    } else t16 = $[153];
    const handleMouseLeave = t16;
    let t17;
    if ($[154] !== sidebarIsExpanded || $[155] !== toggleObjectSidebarControl) {
        t17 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[154] = sidebarIsExpanded;
        $[155] = toggleObjectSidebarControl;
        $[156] = t17;
    } else t17 = $[156];
    const onToggleClick = t17;
    let t18;
    if ($[157] !== formatMessage || $[158] !== sidebarIsExpanded) {
        t18 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[157] = formatMessage;
        $[158] = sidebarIsExpanded;
        $[159] = t18;
    } else t18 = $[159];
    const toggleLabel = t18;
    let t19;
    if ($[160] !== formatMessage) {
        t19 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[160] = formatMessage;
        $[161] = t19;
    } else t19 = $[161];
    let t20;
    if ($[162] !== toggleLabel || $[163] !== toggleObjectSidebarControl) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[162] = toggleLabel;
        $[163] = toggleObjectSidebarControl;
        $[164] = t20;
    } else t20 = $[164];
    let t21;
    if ($[165] !== t19 || $[166] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: t19,
            hideTooltipOnClick: true
        }, t20);
        $[165] = t19;
        $[166] = t20;
        $[167] = t21;
    } else t21 = $[167];
    const integratedExpandButton = t21;
    let t22;
    if ($[168] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $6mKj3.UNSAFE_expValNoExposure)("cc_maui_remix_button_hover_corridor", "isEnabled", false) ? (0, $5YDZX.blockControlsSuppressionProps) : {};
        $[168] = t22;
    } else t22 = $[168];
    const t23 = "object-sidebar-container";
    const t24 = "object-sidebar-container";
    const t25 = pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : "0px";
    let t26;
    if ($[169] !== t25) {
        t26 = {
            right: t25,
            marginRight: 0
        };
        $[169] = t25;
        $[170] = t26;
    } else t26 = $[170];
    const t27 = (0, $hekY6.default)([
        "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
        isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
        (contentType === "database" || contentType === "slide") && "_1Znuxb2ADO _1wydGW2ADO",
        largeBottomPadding && "_1wydGWNHnM",
        isRovoMiniModalShown && "_42Yu6BFIQA",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_3iDTPbYbGa"
    ]);
    let t28;
    if ($[171] !== collapsedActions || $[172] !== contentId || $[173] !== integratedExpandButton || $[174] !== isMobileApp || $[175] !== isRovoButtonEnabled || $[176] !== onToggleClick || $[177] !== primaryActions || $[178] !== renderServerPlaceholder || $[179] !== secondaryActionsTeam25 || $[180] !== shouldDisplayHoverToggle || $[181] !== shouldRenderFloatingTableOfContents || $[182] !== shouldRenderIntegratedExpandButton || $[183] !== shouldRenderWhenEmbedded || $[184] !== sidebarIsExpanded || $[185] !== toggleLabel) {
        t28 = primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_1,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_1,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))))), (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton)) : null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[171] = collapsedActions;
        $[172] = contentId;
        $[173] = integratedExpandButton;
        $[174] = isMobileApp;
        $[175] = isRovoButtonEnabled;
        $[176] = onToggleClick;
        $[177] = primaryActions;
        $[178] = renderServerPlaceholder;
        $[179] = secondaryActionsTeam25;
        $[180] = shouldDisplayHoverToggle;
        $[181] = shouldRenderFloatingTableOfContents;
        $[182] = shouldRenderIntegratedExpandButton;
        $[183] = shouldRenderWhenEmbedded;
        $[184] = sidebarIsExpanded;
        $[185] = toggleLabel;
        $[186] = t28;
    } else t28 = $[186];
    let t29;
    if ($[187] !== actionsToRender || $[188] !== contentId || $[189] !== contentTitle || $[190] !== contentType || $[191] !== isEditorEmpty || $[192] !== isEmbeddedConfluence || $[193] !== isLivePage || $[194] !== isNetworkDisabled || $[195] !== isRovoButtonEnabled || $[196] !== isUnpublishedDraft || $[197] !== lastModifiedDate || $[198] !== pageCommentsSectionInView || $[199] !== pageMode || $[200] !== readTime || $[201] !== readTimeLoading || $[202] !== rovoConfiguration?.experience || $[203] !== rovoConfiguration?.provider || $[204] !== shouldRenderAISmartButton || $[205] !== spaceKey) {
        t29 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            readTime: readTime ?? undefined,
            readTimeLoading: readTimeLoading,
            actionsToRender: actionsToRender ?? []
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled,
            spaceKey: spaceKey,
            isSidebarAvailable: isEmbeddedConfluence ? false : undefined
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true
        })));
        $[187] = actionsToRender;
        $[188] = contentId;
        $[189] = contentTitle;
        $[190] = contentType;
        $[191] = isEditorEmpty;
        $[192] = isEmbeddedConfluence;
        $[193] = isLivePage;
        $[194] = isNetworkDisabled;
        $[195] = isRovoButtonEnabled;
        $[196] = isUnpublishedDraft;
        $[197] = lastModifiedDate;
        $[198] = pageCommentsSectionInView;
        $[199] = pageMode;
        $[200] = readTime;
        $[201] = readTimeLoading;
        $[202] = rovoConfiguration?.experience;
        $[203] = rovoConfiguration?.provider;
        $[204] = shouldRenderAISmartButton;
        $[205] = spaceKey;
        $[206] = t29;
    } else t29 = $[206];
    let t30;
    if ($[207] !== objectSidebarRemixLifecycleAdapter || $[208] !== t28 || $[209] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NHD0A.ObjectSidebarRemixLifecycleSessionProvider), {
            lifecycleAdapter: objectSidebarRemixLifecycleAdapter
        }, t28, t29);
        $[207] = objectSidebarRemixLifecycleAdapter;
        $[208] = t28;
        $[209] = t29;
        $[210] = t30;
    } else t30 = $[210];
    let t31;
    if ($[211] !== handleMouseEnter || $[212] !== handleMouseLeave || $[213] !== t22 || $[214] !== t26 || $[215] !== t27 || $[216] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...t22,
            "data-testid": t23,
            "data-vc": t24,
            style: t26,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave,
            className: t27
        }, t30);
        $[211] = handleMouseEnter;
        $[212] = handleMouseLeave;
        $[213] = t22;
        $[214] = t26;
        $[215] = t27;
        $[216] = t30;
        $[217] = t31;
    } else t31 = $[217];
    let t32;
    if ($[218] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[218] = t32;
    } else t32 = $[218];
    let t33;
    if ($[219] !== t31) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t31, t32);
        $[219] = t31;
        $[220] = t33;
    } else t33 = $[220];
    return t33;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, hasReviewButton: hasReviewButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, showSidebarControlIfNoPanel: showSidebarControlIfNoPanel, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const skipReadTime = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const objectSidebarRemixLifecycleAdapter = (0, $eCmUm.useObjectSidebarRemixLifecycleAdapter)(); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $cozmU.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true)) showSidebarControlIfNoPanel();
        else if (!isObjectSidebarShown) setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        showSidebarControlIfNoPanel,
        setSidebarControlState,
        setSidebarControlExpandCollapsedState,
        isObjectSidebarShown
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const secondaryActionsTeam25 = [];
    if (hasCommentsButton) {
        secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
            key: "comment-panel-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled,
            preloadedCanAddComments: preloadedCanAddComments
        }));
        if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
            key: "comment-panel-button-collapsed",
            contentId: contentId,
            collapsed: true,
            isDisabled: isNetworkDisabled,
            preloadedCanAddComments: preloadedCanAddComments
        }));
    }
    if (hasDetailsButton) {
        secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
            key: "details-panel-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled
        }));
        if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
            key: "details-panel-button-collapsed",
            contentId: contentId,
            collapsed: true,
            isDisabled: isNetworkDisabled
        }));
    }
    if (hasAgentReceiptButton && agentTrustReceipt) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
        key: "agent-receipt-panel-button",
        receipt: agentTrustReceipt,
        isDisabled: isNetworkDisabled
    }));
    if ((0, $6mKj3.isExperimentEnabled)('enterprise_her')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
        key: "enterprise-her-button-wrapper",
        contentId: contentId,
        contentType: contentType ?? ''
    }));
    if (hasAudioButton) {
        if (isAudioV3Enabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
            key: "audio-listen-button-wrapper",
            isRovoButtonEnabled: isRovoButtonEnabled,
            contentId: contentId,
            contentType: contentType ?? '',
            isLivePage: isLivePage,
            spaceKey: spaceKey ?? '',
            title: contentTitle ?? '',
            isAutoOpenDisabled: disabled
        }));
        else secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
            key: "audio-button-loader-wrapper",
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isNetworkDisabled,
            isView: pageMode === (0, $cD1qu.PageMode).VIEW
        }));
    }
    if (hasLoomButton && !isLoomDisabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
        key: "page-header-loom-entry-point",
        contentId: contentId,
        crossSellPopupPlacement: "left-end",
        crossSellSpotlightPlacement: "left-start",
        spaceKey: spaceKey ?? '',
        contentType: contentType ?? '',
        isCircle: !isRovoButtonEnabled,
        testId: "sidebar-loom-button",
        source: "contentWrapper",
        isDisabled: isNetworkDisabled
    }));
    if (editorAIActions) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
        key: "editor-ai-actions",
        editorAIActions: editorAIActions,
        isDisabled: aiIsStreaming
    }));
    if (hasRemixButton && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.expValEquals)('cc-maui-object-level-remix-experiment', 'isEnabled', true)) {
        const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
            key: "remix-panel-button",
            contentBodyValue: contentBodyDynamic?.value,
            getAdfDocument: getAdfDocument,
            isEditorEmpty: isEditorEmpty,
            isDisabled: isNetworkDisabled
        });
        secondaryActionsTeam25.push(remixButton);
    }
    const shouldRenderFloatingTableOfContents = (contentType === 'page' || contentType === 'blogpost') && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi || (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) && (0, $9wGTI.fg)('confluence_sidebar_buttons_initial_render')) && (0, $6mKj3.expValEquals)('platform_editor_floating_toc', 'isEnabled', true);
    if (shouldRenderFloatingTableOfContents) secondaryActionsTeam25.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0d001f61b78e98b$export$41c46dd9735e3599), {
        key: "table-of-contents-popup-button",
        isDisabled: pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi && (0, $9wGTI.fg)('confluence_sidebar_buttons_initial_render'),
        contentBodyValue: contentBodyDynamic?.value,
        contentType: contentType,
        editorApi: editorApi,
        pageMode: pageMode,
        popupPositioningRef: objectSidebarControlRef,
        scrollToEditorHeading: scrollToEditorHeading
    }));
    const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
    if ((aiSuggestionsButtonActions || hasReviewButton && (0, $9wGTI.fg)('confluence_sidebar_buttons_initial_render')) && isEditingPage && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true)) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7deda53c4334bac$export$ff0e0e22e0001f5b), {
        key: "review-button",
        onStartThinking: aiSuggestionsButtonActions?.onStartThinking,
        isDisabled: !aiSuggestionsButtonActions || isNetworkDisabled,
        showNotificationDot: aiSuggestionsButtonActions?.showNotificationDot
    }));
    if ((0, $9wGTI.fg)('confluence_ai_agents_sidebar_button')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
        key: "agents-panel-button",
        contentId: contentId,
        isDisabled: isNetworkDisabled
    }));
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        if (contentType === 'folder') return {
            experience: (0, $dppWL.RegisteredExperience).FOLDER,
            provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
        };
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        contentType,
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', false) ? (0, $5YDZX.blockControlsSuppressionProps) : {},
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: 0
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $hekY6.default)([
            "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
            isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
            (contentType === 'database' || contentType === 'slide') && "_1Znuxb2ADO _1wydGW2ADO",
            largeBottomPadding && "_1wydGWNHnM",
            isRovoMiniModalShown && "_42Yu6BFIQA",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_3iDTPbYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NHD0A.ObjectSidebarRemixLifecycleSessionProvider), {
        lifecycleAdapter: objectSidebarRemixLifecycleAdapter
    }, primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_1,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_1,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))))), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton)) : null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        readTime: readTime ?? undefined,
        readTimeLoading: readTimeLoading,
        actionsToRender: actionsToRender ?? []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled,
        spaceKey: spaceKey,
        isSidebarAvailable: isEmbeddedConfluence ? false : undefined
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $9wGTI.fg)("remix_state_rearchitecture_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCmUm.ObjectSidebarRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $9wGTI.fg)('remix_state_rearchitecture_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCmUm.ObjectSidebarRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props));
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("5YDZX", function(module, exports) {
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $d9d643acafd25457$export$7a4820babe675d08 = {
    [$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $d9d643acafd25457$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;
module.exports["blockControlsSuppressionProps"] = $d9d643acafd25457$export$7a4820babe675d08;
module.exports["isBlockControlsSuppressionTarget"] = $d9d643acafd25457$export$8d5d08f345eecbf1;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !isAtlassianHostedLLMOnlyEnabled && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2OUyjtGk8v _42Yu6B7dHp _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $kSwu1.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $5L7V6 = parcelRequire("5L7V6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$export$308bf82a9a0ad7d = (0, $5L7V6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only',
        __callerPackage__: "ai-floating-context-menu"
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<b18880c95a88e91ee675a5ab3e7a2f6a>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<6135257c8df94a440f547d327ee53e8c>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "ca230a2a5e683b85178d392f9c872c98";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("5L7V6", function(module, exports) {
/**
 * @generated SignedSource<<369f3309f8f6ec03427d92d39f832dab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $923ef1fe064db781$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useDynamicSplitButton_catchupLastViewedTime",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "lastViewedTimeISO"
        }
    ],
    "type": "CatchupLastViewedTimeResponse"
};
$923ef1fe064db781$var$node.hash = "297588dba1b1d203b8ad0275eaa0e0a8";
var $923ef1fe064db781$export$2e2bcd8739ae039 = $923ef1fe064db781$var$node;
module.exports["default"] = $923ef1fe064db781$export$2e2bcd8739ae039;

});

parcelRegister("8uM2K", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
    FLOATING_TABLE_OF_CONTENTS: 'onboarding-insights:hasFloatingTableOfContentsBeenInteractedWith'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2);
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("cGlMo", function(module, exports) {

let $93ba4d3888fcc884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93ba4d3888fcc884$var$load("5lfr5").then(()=>parcelRequire('ebALC'));

});

parcelRegister("9VC5k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $7akNQ = parcelRequire("7akNQ");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $cFVPs = parcelRequire("cFVPs");















var $a9aSv = parcelRequire("a9aSv");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $96aaefbcbab4ea71$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4473 7.99998C11.4473 7.63179 11.7457 7.33331 12.1139 7.33331H13.3339C13.7021 7.33331 14.0006 7.63179 14.0006 7.99998C14.0006 8.36817 13.7021 8.66665 13.3339 8.66665H12.1139C11.7457 8.66665 11.4473 8.36817 11.4473 7.99998Z",
        fill: "url(#paint0_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V3.88667C8.66732 4.25486 8.36884 4.55333 8.00065 4.55333C7.63246 4.55333 7.33398 4.25486 7.33398 3.88667V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
        fill: "url(#paint1_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 7.99998C2 7.63179 2.29848 7.33331 2.66667 7.33331H3.88667C4.25486 7.33331 4.55333 7.63179 4.55333 7.99998C4.55333 8.36817 4.25486 8.66665 3.88667 8.66665H2.66667C2.29848 8.66665 2 8.36817 2 7.99998Z",
        fill: "url(#paint2_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 11.4467C8.36884 11.4467 8.66732 11.7451 8.66732 12.1133V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V12.1133C7.33398 11.7451 7.63246 11.4467 8.00065 11.4467Z",
        fill: "url(#paint3_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.52925 9.52858C9.7896 9.26823 10.2117 9.26823 10.4721 9.52858L13.1387 12.1952C13.3991 12.4556 13.3991 12.8777 13.1387 13.1381C12.8784 13.3984 12.4563 13.3984 12.1959 13.1381L9.52925 10.4714C9.2689 10.211 9.2689 9.78892 9.52925 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.1387 2.86195C13.3991 3.1223 13.3991 3.54441 13.1387 3.80476L10.4721 6.47142C10.2117 6.73177 9.7896 6.73177 9.52925 6.47142C9.2689 6.21108 9.2689 5.78897 9.52925 5.52862L12.1959 2.86195C12.4563 2.6016 12.8784 2.6016 13.1387 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.86128 2.86195C3.12163 2.6016 3.54374 2.6016 3.80409 2.86195L6.47075 5.52862C6.7311 5.78897 6.7311 6.21108 6.47075 6.47142C6.2104 6.73177 5.78829 6.73177 5.52794 6.47142L2.86128 3.80476C2.60093 3.54441 2.60093 3.1223 2.86128 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.47075 9.52858C6.7311 9.78892 6.7311 10.211 6.47075 10.4714L3.80409 13.1381C3.54374 13.3984 3.12163 13.3984 2.86128 13.1381C2.60093 12.8777 2.60093 12.4556 2.86128 12.1952L5.52794 9.52858C5.78829 9.26823 6.2104 9.26823 6.47075 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_2378_7139",
        x1: "14.0006",
        y1: "7.99998",
        x2: "11.6672",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.270833",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_2378_7139",
        x1: "8.33398",
        y1: "2",
        x2: "8.33398",
        y2: "4.33333",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1875",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_2378_7139",
        x1: "4.5533",
        y1: "7.99998",
        x2: "2.21997",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.791667",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_2378_7139",
        x1: "8.33398",
        y1: "11.3333",
        x2: "8.33398",
        y2: "14",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.802083",
        stopColor: "#2684FF"
    }))));


const $333270f2f5cd2de3$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummary: {
        id: "ai-skeleton-loading.title",
        defaultMessage: "Atlassian Intelligence is generating a summary..."
    },
    logoAltText: {
        id: "ai-skeleton-loading.logo-alt",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
const $333270f2f5cd2de3$var$loadingTextContainer = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.200',
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $333270f2f5cd2de3$export$e93f99a4d30f6d75 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $333270f2f5cd2de3$var$loadingTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96aaefbcbab4ea71$export$b58d43d92d088553), {
        alt: intl.formatMessage($333270f2f5cd2de3$var$i18n.logoAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, intl.formatMessage($333270f2f5cd2de3$var$i18n.generatingSummary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })));
};



var $lpJCW = parcelRequire("lpJCW");















var $7m1U4 = parcelRequire("7m1U4");

const $82345f9002994123$var$BoxStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: 'radius.large',
    borderBottomLeftRadius: 'radius.small'
});
const $82345f9002994123$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $82345f9002994123$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82345f9002994123$var$BoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82345f9002994123$var$i18n.generatingSummaryText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($82345f9002994123$var$i18n.generatingSummaryAnimationAlt)
    })));
};



var $5GgqH = parcelRequire("5GgqH");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $3Am3T = parcelRequire("3Am3T");


var $8jP1I = parcelRequire("8jP1I");

var $161368acfff8028f$export$ec72d0267c37019f = /*#__PURE__*/ function(CommentsSummaryAnalyticsType) {
    CommentsSummaryAnalyticsType["FOOTER"] = "FOOTER";
    CommentsSummaryAnalyticsType["INLINE"] = "INLINE";
    return CommentsSummaryAnalyticsType;
}({});



var $dchHi = parcelRequire("dchHi");


var $bbNJt = parcelRequire("bbNJt");


var $jhwJP = parcelRequire("jhwJP");

/**
 * @generated SignedSource<<29553362f1cef877309db445c48df90d>>
 * @relayHash 53eb9fa8cec0a522c06e9697c10f440b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33
const $24226cfbd28917e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "53eb9fa8cec0a522c06e9697c10f440b",
            "id": "0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$24226cfbd28917e5$var$node.hash = "6db2d91039b90f64f08e4e052c0a32d7";
var $24226cfbd28917e5$export$2e2bcd8739ae039 = $24226cfbd28917e5$var$node;


/**
 * @generated SignedSource<<c4777a9cf5f8e5b40c54145fa6f43328>>
 * @relayHash dc798cc8cc74b72655c7a19090058c0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb
const $050fce5e42c00d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "dc798cc8cc74b72655c7a19090058c0e",
            "id": "436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$050fce5e42c00d97$var$node.hash = "ffce51d12c39ccd238d2cb848107c61a";
var $050fce5e42c00d97$export$2e2bcd8739ae039 = $050fce5e42c00d97$var$node;



var $jMyy4 = parcelRequire("jMyy4");

/**
 * @generated SignedSource<<1f05a50a15753c67b4b42e99a5cdfd85>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $ac5fc6262abb25ff$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $ac5fc6262abb25ff$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["PAGE"] = "PAGE";
    SummaryType["BLOGPOST"] = "BLOGPOST";
    return SummaryType;
}({});


const $0edd62bded09ab4f$export$7bdbf0c72871fa1f = ({ contentId: contentId, contentType: contentType, shouldSkipFooterCommentsQuery: shouldSkipFooterCommentsQuery = false, shouldSkipInlineCommentsQuery: shouldSkipInlineCommentsQuery = false })=>{
    const { data: footerCommentsSummaryData, loading: footerCommentsQueryLoading, error: footerCommentsSummaryError, refetch: footerCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $050fce5e42c00d97$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).FOOTER
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipFooterCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const { data: inlineCommentsSummaryData, loading: inlineCommentsQueryLoading, error: inlineCommentsSummaryError, refetch: inlineCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $24226cfbd28917e5$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).INLINE
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipInlineCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const refetch = ()=>{
        footerCommentsRefetch();
        inlineCommentsRefetch();
    };
    return {
        data: {
            footerCommentsSummaryData: footerCommentsSummaryData,
            inlineCommentsSummaryData: inlineCommentsSummaryData
        },
        loading: footerCommentsQueryLoading || inlineCommentsQueryLoading,
        errors: {
            footerCommentsSummaryError: footerCommentsSummaryError,
            inlineCommentsSummaryError: inlineCommentsSummaryError
        },
        refetch: refetch
    };
};


const $ea0c56ea9695a839$export$2f5736e19049ec78 = '775fa156-8bed-4310-af75-c6d1148b88fb';


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $17fd4a0f0d6084c8$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $17fd4a0f0d6084c8$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["BLOGPOST"] = "BLOGPOST";
    SummaryType["PAGE"] = "PAGE";
    return SummaryType;
}({});



var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $f6bfaf9677f19070$export$9ad53c330569860e = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.COMMENTS_SUMMARY_COMPONENT_INTERACTION)
});


// eslint-disable-next-line import/order







var $i1t43 = parcelRequire("i1t43");











var $6Pqow = parcelRequire("6Pqow");





var $b3j2Y = parcelRequire("b3j2Y");


var $dL3KX = parcelRequire("dL3KX");


var $53ZHq = parcelRequire("53ZHq");

















var $7Sm4c = parcelRequire("7Sm4c");








const $883f6dcc92761560$export$37675c48b66aa091 = (contentId, source, footerCommentsError, inlineCommentsError)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { errorType: footerCommentsErrorType, isExpectedError: footerCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), footerCommentsError);
    const { errorType: inlineCommentsErrorType, isExpectedError: inlineCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), inlineCommentsError);
    const { errorType: errorType, commentsType: commentsType } = (0, $cozmU.useMemo)(()=>{
        let memoErrorType;
        let memoCommentsType = [];
        if (footerCommentsError && inlineCommentsError) {
            if (footerCommentsErrorType === inlineCommentsErrorType) memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER,
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        } else if (footerCommentsError) {
            memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER
            ];
        } else if (inlineCommentsError) {
            memoErrorType = inlineCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        }
        return {
            errorType: memoErrorType || (0, $dL3KX.HandledErrorType).GeneralError,
            commentsType: memoCommentsType
        };
    }, [
        inlineCommentsError,
        inlineCommentsErrorType,
        footerCommentsError,
        footerCommentsErrorType
    ]);
    if (footerCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(footerCommentsError);
    if (inlineCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(inlineCommentsError);
    // Experience should only be a failure if both queries have erred
    // OR either query has failed when the other query was skipped due to 0 comments
    const isExperienceFailure = footerCommentsError && (inlineCommentsError || unresolvedInlineCommentsCount === 0) || inlineCommentsError && footerCommentsCount === 0;
    const isExpectedError = footerCommentsIsExpectedError && (inlineCommentsIsExpectedError || unresolvedInlineCommentsCount === 0) || inlineCommentsIsExpectedError && footerCommentsCount === 0;
    if (isExperienceFailure) {
        if (isExpectedError) experienceTracker.abort({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            reason: `Can not generate summary due to ${errorType}`,
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        else // Experience tracker can only fail with a single error. Since both queries have failed we will use the footer
        // comments failure to end the experience and pass both types of failures as attributes for further debugging
        experienceTracker.fail({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            // TS does not interpret the isExperienceFailure logic above correctly. Letting the compiler know
            error: footerCommentsError || inlineCommentsError,
            attributes: {
                footerCommentsErrorType: footerCommentsErrorType,
                inlineCommentsErrorType: inlineCommentsErrorType
            }
        });
    }
    return {
        erredQueries: commentsType,
        errorType: errorType,
        shouldCallErrorDisplayForFooterComments: !!footerCommentsError && !footerCommentsIsExpectedError,
        shouldCallErrorDisplayForInlineComments: !!inlineCommentsError && !inlineCommentsIsExpectedError
    };
};


const $6a674942f4f35f24$var$textStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $6a674942f4f35f24$var$i18nBase = (0, $kSwu1.defineMessages)({
    combinedErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-general",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a summary right now. You can try again later or read more <a>in our support documentation</a>."
    },
    combinedErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-much-content",
        defaultMessage: "There are too many comments for Atlassian Intelligence (AI) to summarize. Try again on content with fewer comments."
    },
    combinedErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-little-content",
        defaultMessage: "There aren\u2019t enough comments for Atlassian Intelligence (AI) to summarize. Try again when more comments have been added."
    },
    combinedErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-rate-limit",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    combinedErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-aup-violation",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of the comments on this content, as some comments may not comply with our <a>Acceptable Use Policy</a>."
    },
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general",
        defaultMessage: "There is no summary of page comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content",
        defaultMessage: "This summary only includes inline comments, as there are too many page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many page comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation",
        defaultMessage: "This summary only includes inline comments, as some page comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-general",
        defaultMessage: "There is no summary of inline comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content",
        defaultMessage: "This summary only includes page comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content",
        defaultMessage: "This summary only includes page comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit",
        defaultMessage: "This summary only includes page comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation",
        defaultMessage: "This summary only includes page comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs",
        defaultMessage: "There is no summary of general comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there are too many general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many general comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes inline comments, as some general comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes general comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes general comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($6a674942f4f35f24$var$i18nBase, $6a674942f4f35f24$var$i18nLiveDocs);
const $6a674942f4f35f24$export$b0cd94004126f4ff = ({ contentId: contentId, footerCommentsError: footerCommentsError, inlineCommentsError: inlineCommentsError, source: source })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { erredQueries: erredQueries, errorType: errorType, shouldCallErrorDisplayForFooterComments: shouldCallErrorDisplayForFooterComments, shouldCallErrorDisplayForInlineComments: shouldCallErrorDisplayForInlineComments } = (0, $883f6dcc92761560$export$37675c48b66aa091)(contentId, source, footerCommentsError, inlineCommentsError);
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    (0, $cozmU.useEffect)(()=>{
        trackAIResultError({
            aiErrorMessage: errorType,
            // TODO Ideally we should pass the real code from the response
            aiErrorCode: 400
        }, {
            attributes: {
                contentId: contentId,
                errorType: errorType,
                commentsType: erredQueries,
                source: source
            }
        });
    }, [
        erredQueries,
        contentId,
        trackAIResultError,
        errorType,
        source
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'commentsSummaryError',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    errorType: errorType,
                    commentsType: erredQueries,
                    source: source
                }
            }
        }).fire();
    };
    const errorMessage = ()=>{
        let i18nPrefix = "combined";
        if (footerCommentsError && !inlineCommentsError && unresolvedInlineCommentsCount > 0) i18nPrefix = "footerComments";
        if (inlineCommentsError && !footerCommentsError && footerCommentsCount > 0) i18nPrefix = "inlineComments";
        switch(errorType){
            case (0, $dL3KX.HandledErrorType).TooMuchContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorTooMuchContent`]);
            case (0, $dL3KX.HandledErrorType).NotEnoughContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorNotEnoughContent`]);
            case (0, $dL3KX.HandledErrorType).AUPViolation:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorAUPViolation`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks)
                });
            case (0, $dL3KX.HandledErrorType).RateLimit:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorRateLimit`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks)
                });
            default:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorGeneral`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks)
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6a674942f4f35f24$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, errorMessage()), footerCommentsError && shouldCallErrorDisplayForFooterComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: footerCommentsError
    }), inlineCommentsError && shouldCallErrorDisplayForInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: inlineCommentsError
    }));
};


const $28602bba7ed7c957$var$styles = (0, $buxP3.xcss)({
    height: '100%',
    font: 'font.body.large'
});
const $28602bba7ed7c957$var$FooterObjectSidebarStyles = (0, $buxP3.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $28602bba7ed7c957$var$i18nBase = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header",
        defaultMessage: "Page comments"
    },
    inlineCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.inline-comments-header",
        defaultMessage: "Inline comments"
    }
});
const $28602bba7ed7c957$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs",
        defaultMessage: "General comments"
    }
});
const $28602bba7ed7c957$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($28602bba7ed7c957$var$i18nBase, $28602bba7ed7c957$var$i18nLiveDocs);
var $28602bba7ed7c957$export$92985523ee81b88c = /*#__PURE__*/ function(CommentsSummarySource) {
    CommentsSummarySource["Footer"] = "footer";
    CommentsSummarySource["Header"] = "header";
    CommentsSummarySource["Feed"] = "feed";
    return CommentsSummarySource;
}({});
const $28602bba7ed7c957$export$dd076aaa63869f66 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, onRefresh: onRefresh, shouldRefetchCommentsSummary: shouldRefetchCommentsSummary = false, source: source, isInObjectSidebar: isInObjectSidebar, showAIDisclaimer: showAIDisclaimer = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const containerRef = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(containerRef);
    const contentTypeEnum = contentType === 'page' ? (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).PAGE : (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).BLOGPOST;
    const { data: data, errors: errors, loading: loading, refetch: refetch } = (0, $0edd62bded09ab4f$export$7bdbf0c72871fa1f)({
        contentId: contentId,
        contentType: contentTypeEnum,
        shouldSkipFooterCommentsQuery: footerCommentsCount === 0,
        shouldSkipInlineCommentsQuery: unresolvedInlineCommentsCount === 0
    });
    const refreshHandler = ()=>{
        if (!loading) {
            refetch();
            onRefresh?.();
        }
    };
    const startExperienceTracking = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        (0, $f6bfaf9677f19070$export$9ad53c330569860e).start();
    }, [
        contentId,
        experienceTracker,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (loading) startExperienceTracking();
        if (!loading) (0, $f6bfaf9677f19070$export$9ad53c330569860e).stop();
    }, [
        loading,
        startExperienceTracking
    ]);
    const footerCommentsSummary = data.footerCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const inlineCommentsSummary = data.inlineCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const loadingRef = (0, $cozmU.useRef)(loading);
    (0, $cozmU.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
        if (shouldRefetchCommentsSummary) {
            refetch();
            onRefresh?.();
        }
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'commentsSummary',
                    source: 'commentsSummary',
                    actionSubjectId: 'commentsSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime()
                    }
                }
            }).fire();
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only check auto refetch on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const summaryLocale = (0, $cozmU.useMemo)(()=>{
        // Ok to just choose first of whichever is available from data team
        return data.footerCommentsSummaryData?.getCommentsSummary?.language || data.inlineCommentsSummaryData?.getCommentsSummary?.language;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const commentsType = (0, $cozmU.useMemo)(()=>{
        const commentsTypeCollection = [];
        if (data.footerCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).FOOTER);
        if (data.inlineCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).INLINE);
        return commentsTypeCollection;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const feedbackContext = {
        commentsType: commentsType,
        source: source
    };
    const analyticsProperties = {
        source: 'commentsSummary',
        additionalAnalyticsAttributes: {
            commentsType: commentsType
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (!loading) {
            if (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'commentsSummaryContainer',
                        attributes: {
                            contentId: contentId,
                            edition: edition,
                            commentsType: commentsType,
                            summaryLocale: summaryLocale,
                            numPageCommentsSummarized: footerCommentsCount,
                            numInlineCommentsSummarized: unresolvedInlineCommentsCount
                        }
                    }
                }).fire();
                trackAIResultView();
            }
        }
    }, [
        createAnalyticsEvent,
        contentId,
        edition,
        loading,
        commentsType,
        summaryLocale,
        errors.footerCommentsSummaryError,
        errors.inlineCommentsSummaryError,
        footerCommentsCount,
        trackAIResultView,
        unresolvedInlineCommentsCount
    ]);
    const fullTextToCopy = ()=>{
        return `${footerCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)}\n${footerCommentsSummary}`}\n\n${inlineCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)}\n${inlineCommentsSummary}`}`;
    };
    const renderContentBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.200"
        }, inlineCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, inlineCommentsSummary)), footerCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, footerCommentsSummary)), (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        }), (errors.footerCommentsSummaryError || errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a674942f4f35f24$export$b0cd94004126f4ff), {
            contentId: contentId,
            footerCommentsError: errors.footerCommentsSummaryError,
            inlineCommentsError: errors.inlineCommentsSummaryError,
            source: source
        }));
    };
    const renderContent = ()=>{
        if (loading) return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82345f9002994123$export$dd8c26521b6a2fec), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $333270f2f5cd2de3$export$e93f99a4d30f6d75), null);
        const shouldShowFooterError = !!errors.footerCommentsSummaryError && !!errors.inlineCommentsSummaryError || !!errors.footerCommentsSummaryError && inlineCommentsSummary.length === 0 || !!errors.inlineCommentsSummaryError && footerCommentsSummary.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: $28602bba7ed7c957$var$styles,
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: isInObjectSidebar ? 'space.100' : 'space.250'
        }, source !== "footer" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
            "data-testid": "scrollable-comments-summary"
        }, renderContentBody()) : renderContentBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: isInObjectSidebar && $28602bba7ed7c957$var$FooterObjectSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jP1I.AISummaryFooter), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            error: shouldShowFooterError,
            summaryText: fullTextToCopy(),
            showBetaLozenge: true,
            shouldHighlightRefresh: shouldRefetchCommentsSummary,
            refreshHandler: refreshHandler,
            showAIDisclaimer: showAIDisclaimer
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: (0, $ea0c56ea9695a839$export$2f5736e19049ec78),
        feedbackContext: feedbackContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "comments-summary-content",
        hold: loading
    }), isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
        loading: loading
    }, renderContent()))));
};
module.exports["CommentsSummarySource"] = $28602bba7ed7c957$export$92985523ee81b88c;
module.exports["CommentsSummaryContent"] = $28602bba7ed7c957$export$dd076aaa63869f66;

});

parcelRegister("lpJCW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8jQuQ = parcelRequire("8jQuQ");


var $9ivsj = parcelRequire("9ivsj");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5e4f95acdf8fc4d$var$GradientPropertyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _0NUa3rOLYo",
            __cmplp.className
        ])
    });
});
const $f5e4f95acdf8fc4d$var$outerContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $8jQuQ.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f5e4f95acdf8fc4d$var$animationStyles = (0, $buxP3.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f5e4f95acdf8fc4d$var$baseGlowStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $f5e4f95acdf8fc4d$var$innerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f5e4f95acdf8fc4d$var$outerContainerStyles,
        $f5e4f95acdf8fc4d$var$animationStyles
    ] : [
        $f5e4f95acdf8fc4d$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f5e4f95acdf8fc4d$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f5e4f95acdf8fc4d$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles : $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5e4f95acdf8fc4d$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.025",
        xcss: [
            $f5e4f95acdf8fc4d$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf;

});

parcelRegister("8jQuQ", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $cfd6e6a22c7a51c3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $cfd6e6a22c7a51c3$export$f0f789643ba5a83c;

});

parcelRegister("8jP1I", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc609ae5f11b40a5$export$409c83e49353f3fb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0IK46",
    name: "AISummaryFooter",
    loader: async ()=>(await (parcelRequire("3lbVi"))).AISummaryFooter
});
module.exports["AISummaryFooter"] = $fc609ae5f11b40a5$export$409c83e49353f3fb;

});

parcelRegister("3lbVi", function(module, exports) {

let $26ec94f2c48c166a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $26ec94f2c48c166a$var$load("6wr18"),
    $26ec94f2c48c166a$var$load("i3R6S"),
    $26ec94f2c48c166a$var$load("ffEVr"),
    $26ec94f2c48c166a$var$load("kUbT8")
]).then(()=>parcelRequire('4KbgO'));

});

parcelRegister("dchHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $cozmU.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("bbNJt", function(module, exports) {
/* SummaryPopupScrollableBody.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d3be62f9dcca5536$export$8fdeb1797011aead = 358;
const $d3be62f9dcca5536$export$3b687fa050c6eb18 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useMaxHeight: useMaxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg20Hp _2WAcuGIZbP _3zvHkHwPeg _1ANEUSzUZr _4ho0wCjOvk _3ILZpPRi7C _2Ins1S8fU6 _0Gam4UDMqu _3ZpBalKcZT",
            __cmplp.useMaxHeight ? "_0NUa3rO3MJ" : "_0NUa3rZqHV",
            __cmplp.className
        ])
    });
});
module.exports["MAX_SUMMARY_HEIGHT"] = $d3be62f9dcca5536$export$8fdeb1797011aead;
module.exports["SummaryPopupScrollableBody"] = $d3be62f9dcca5536$export$3b687fa050c6eb18;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("dL3KX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6ahXt = parcelRequire("6ahXt");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");

const $926c216e16fb1b0c$export$64cc6b1b62510d3 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize.";
const $926c216e16fb1b0c$export$1403052b2e306597 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is not enough content to summarize. You can try again later if more is added!";
var $926c216e16fb1b0c$export$6841b1da468d3071 = /*#__PURE__*/ function(HandledErrorType) {
    HandledErrorType["TooMuchContent"] = "tooMuchContent";
    HandledErrorType["NotEnoughContent"] = "notEnoughContent";
    HandledErrorType["RateLimit"] = "rateLimit";
    HandledErrorType["AUPViolation"] = "aupViolation";
    HandledErrorType["GeneralError"] = "generalError";
    return HandledErrorType;
}({});
const $926c216e16fb1b0c$var$ERROR_MAP = {
    [$926c216e16fb1b0c$export$64cc6b1b62510d3]: "tooMuchContent",
    [$926c216e16fb1b0c$export$1403052b2e306597]: "notEnoughContent",
    TOO_MANY_REQUEST: "rateLimit",
    AUP_VIOLATION: "aupViolation"
};
const $926c216e16fb1b0c$var$STREAM_ERROR_MAP = {
    [(0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).RATE_LIMIT]: "rateLimit",
    [(0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS]: "aupViolation"
};
const $926c216e16fb1b0c$var$expectedErrorTypes = [
    "tooMuchContent",
    "notEnoughContent",
    "aupViolation"
];
const $926c216e16fb1b0c$export$628a9b3d5b2b9729 = (experienceName, errorFromApolloOrStream)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { errorType: errorType, isExpectedError: isExpectedError, error: error } = (0, $cozmU.useMemo)(()=>{
        if (!errorFromApolloOrStream) return {
            isExpectedError: false,
            stopExperienceTracking: ()=>{},
            errorType: undefined,
            error: new Error('[useSummaryErrorHelper]: error instance is missing')
        };
        let errorMessageFromGQLorStream = '';
        let errorTypeFromGQLorStream = '';
        if ('graphQLErrors' in errorFromApolloOrStream) {
            // The BE only returns one error (the first that it encounters).
            // Therefore, we don't need to loop through the array, and can just rely on index 0
            errorMessageFromGQLorStream = errorFromApolloOrStream.graphQLErrors[0].message;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: errorFromApolloOrStream,
                errorType: errorTypeFromGQLorStream
            };
        } else {
            errorMessageFromGQLorStream = errorFromApolloOrStream.message.message_template;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$STREAM_ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: new Error(errorFromApolloOrStream.message.content),
                errorType: errorTypeFromGQLorStream
            };
        }
    }, [
        errorFromApolloOrStream
    ]);
    const stopExperienceTracking = ()=>{
        if (isExpectedError) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: experienceName,
                reason: `Can not generate summary due to ${errorType}`
            });
        } else experienceTracker.fail({
            name: experienceName,
            error: error
        });
    };
    return {
        isExpectedError: isExpectedError,
        stopExperienceTracking: stopExperienceTracking,
        error: error,
        errorType: errorType
    };
};
module.exports["HandledErrorType"] = $926c216e16fb1b0c$export$6841b1da468d3071;
module.exports["useSummaryErrorHelper"] = $926c216e16fb1b0c$export$628a9b3d5b2b9729;

});

parcelRegister("53ZHq", function(module, exports) {
const $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
module.exports["TROUBLE_SHOOTING_DOCS_URL"] = $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1;
module.exports["USAGE_LIMITS_DOCS_URL"] = $ddccf0ae2c3101d9$export$b4fefae0b724683f;
module.exports["ACCEPTABLE_USE_POLICY_URL"] = $ddccf0ae2c3101d9$export$2876254020381b5e;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("3ji1v"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("3ji1v", function(module, exports) {

let $26912083ea2b8851$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $26912083ea2b8851$var$load("avoXg"),
    $26912083ea2b8851$var$load("3pHps"),
    $26912083ea2b8851$var$load("hGSc9"),
    $26912083ea2b8851$var$load("b0ARW"),
    $26912083ea2b8851$var$load("7EorR"),
    $26912083ea2b8851$var$load("ariuh"),
    $26912083ea2b8851$var$load("hhss7"),
    $26912083ea2b8851$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("27VhD"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("27VhD", function(module, exports) {

let $18c8ab7d9701a9e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $18c8ab7d9701a9e6$var$load("52ZTT"),
    $18c8ab7d9701a9e6$var$load("6zCMk"),
    $18c8ab7d9701a9e6$var$load("hcY7w"),
    $18c8ab7d9701a9e6$var$load("6wr18"),
    $18c8ab7d9701a9e6$var$load("i3R6S"),
    $18c8ab7d9701a9e6$var$load("kUbT8"),
    $18c8ab7d9701a9e6$var$load("b0ARW"),
    $18c8ab7d9701a9e6$var$load("4nZ85"),
    $18c8ab7d9701a9e6$var$load("ariuh"),
    $18c8ab7d9701a9e6$var$load("hhss7"),
    $18c8ab7d9701a9e6$var$load("kHXvF"),
    $18c8ab7d9701a9e6$var$load("ffEVr"),
    $18c8ab7d9701a9e6$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});

parcelRegister("brrvF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $ffOSw = parcelRequire("ffOSw");


var $fvOg5 = parcelRequire("fvOg5");

const $a68160926e693700$var$i18n = (0, $kSwu1.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $cozmU.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $cozmU.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($ffOSw))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($fvOg5)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("ffOSw", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("fvOg5", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("fjeDY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Pvub = parcelRequire("2Pvub");


var $bWlOZ = parcelRequire("bWlOZ");


var $gZHXx = parcelRequire("gZHXx");

const $af70fdcc8d818788$export$9f9aa2084eecc634 = ({ adapter: adapter, owner: owner, request: request })=>{
    // Every producer funnels through here, so this is the one place that sees a flow start regardless
    // of how it was triggered. Forgetting first means a flow that is disabled, rejected or fails open
    // runs as legacy even when the previous flow was machine-backed.
    //
    // Safe to call unconditionally: a start attempted against a live flow is refused below, and
    // `forgetMachineAuthority` leaves that flow's authority alone because it is still the active one.
    owner?.forgetMachineAuthority();
    if (!adapter) return {
        status: 'legacy'
    };
    let admission;
    try {
        admission = adapter.startFlow(request);
    } catch  {
        return {
            status: 'infrastructure-failure'
        };
    }
    if (admission.status === 'active-flow-rejected') return {
        status: 'active-flow-rejected'
    };
    if (admission.status !== 'admitted') return admission.status === 'shadow-infrastructure-failure' ? {
        status: 'infrastructure-failure'
    } : {
        status: 'legacy'
    };
    if (!owner) {
        admission.handle.rollback();
        return {
            status: 'infrastructure-failure'
        };
    }
    let retained;
    try {
        retained = owner.retain(admission.handle);
    } catch  {
        admission.handle.rollback();
        return {
            status: 'infrastructure-failure'
        };
    }
    if (!retained) {
        admission.handle.rollback();
        return {
            status: 'active-flow-rejected'
        };
    }
    return {
        status: 'retained',
        lifecycle: retained
    };
};
/** Empty read model before admission, after a non-terminal release, or after terminal dismissal. */ const $af70fdcc8d818788$var$NO_EDITOR_REMIX_LIFECYCLE = Object.freeze({
    remixId: undefined,
    isAdmitted: false,
    phase: 'inactive',
    terminalPhase: undefined,
    dismissTerminal: ()=>{},
    hasMachineAuthority: false
});
const $af70fdcc8d818788$var$EditorRemixLifecycleOwnerContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
/**
 * Separate from the owner context so machine transitions do not re-render producers holding owner
 * actions, and retention does not re-render read consumers.
 */ const $af70fdcc8d818788$var$EditorRemixLifecycleReadContext = /*#__PURE__*/ (0, $cozmU.createContext)($af70fdcc8d818788$var$NO_EDITOR_REMIX_LIFECYCLE);
const $af70fdcc8d818788$export$da4e522b888aba8e = ()=>(0, $cozmU.useContext)($af70fdcc8d818788$var$EditorRemixLifecycleOwnerContext);
const $af70fdcc8d818788$export$c082f0c88efbbb1f = ()=>(0, $cozmU.useContext)($af70fdcc8d818788$var$EditorRemixLifecycleReadContext);
const $af70fdcc8d818788$export$c2e62aa710f578c4 = ({ children: children })=>{
    const activeRef = (0, $cozmU.useRef)(undefined);
    const terminalEntryRef = (0, $cozmU.useRef)(undefined);
    const [active, setActive] = (0, $cozmU.useState)(undefined);
    /**
   * The read session, mirrored into a ref so the observer can judge staleness synchronously on a
   * machine transition rather than a commit later.
   */ const sessionRef = (0, $cozmU.useRef)(undefined);
    const [session, setSession] = (0, $cozmU.useState)(undefined);
    /**
   * Machine authority for the current flow, outliving the session the way the registry's
   * `terminal-latched` write-authority lease does. Mirrored into a ref so `retain` can set it in the
   * same synchronous turn it seeds the session, before `observe` can settle a terminal outcome.
   */ const hasMachineAuthorityRef = (0, $cozmU.useRef)(false);
    const [hasMachineAuthority, setHasMachineAuthority] = (0, $cozmU.useState)(false);
    const forgetMachineAuthority = (0, $cozmU.useCallback)(()=>{
        if (!hasMachineAuthorityRef.current) return;
        // A live flow keeps its authority. Forgetting is for a flow that has finished: a start
        // attempted against a live flow is refused, and that flow goes on owning its terminal effects,
        // so dropping its authority here would unfence the legacy effects it owns and settle twice.
        //
        // Judged on the ref rather than `active`, which is state and so lags by a commit. `retain`
        // refuses on this same ref, so enforcing it here keeps the two decisions from disagreeing
        // inside a single turn, and means no caller can get this wrong.
        if (activeRef.current) return;
        hasMachineAuthorityRef.current = false;
        setHasMachineAuthority(false);
    }, []);
    const writeSession = (0, $cozmU.useCallback)((token, update)=>{
        const current = sessionRef.current;
        // A stale flow cannot alter a newer session, or revive a dismissed one.
        if (current?.token !== token) return;
        const next = {
            ...current,
            ...update
        };
        if (next.isAdmitted === current.isAdmitted && next.phase === current.phase && next.terminalPhase === current.terminalPhase) return;
        sessionRef.current = next;
        setSession(next);
    }, []);
    const dismissTerminal = (0, $cozmU.useCallback)((token)=>{
        const current = sessionRef.current;
        // Only a latched outcome is dismissible. Clearing a session whose flow is still running would
        // blind the observer to that flow's own terminal phase and strand machine ownership.
        if (current?.token !== token || current.terminalPhase === undefined) return;
        sessionRef.current = undefined;
        setSession(undefined);
    }, []);
    /**
   * The lifecycle observer: the only caller of `end('error')` and `end('aborted')`.
   *
   * Runs synchronously on the machine's transition, and latches a terminal phase into the session
   * before releasing machine ownership — the release destroys the machine, so an outcome not
   * captured here is lost. Repeat and late observations are absorbed by the owner's release guard,
   * so a terminal `end()` happens exactly once.
   */ const observe = (0, $cozmU.useCallback)((entry)=>{
        const { actions: actions, token: token } = entry;
        if (sessionRef.current?.token !== token) return;
        const phase = (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(actions.remixId)?.state());
        if (!(0, $gZHXx.isTerminalEditorRemixPhase)(phase)) {
            writeSession(token, {
                phase: phase
            });
            return;
        }
        // This must happen before `end()` releases machine ownership. The product callback keeps
        // lifecycle writes fenced while the existing terminal UX cleanup runs.
        entry.terminalLatched = true;
        terminalEntryRef.current = entry;
        try {
            entry.onRelease.latchTerminalAuthority?.();
        } catch  {
        // Product presentation cleanup must not strand the machine on a terminal transition.
        }
        writeSession(token, {
            isAdmitted: false,
            phase: phase,
            terminalPhase: phase
        });
        // Releasing here destroys the machine part-way through the very notification that is
        // still fanning out. `machineBridge` snapshots its subscriber set before iterating, so
        // subscribers registered after this one still run — but they will read no machine and
        // project `inactive` rather than the terminal phase.
        //
        // Any observer that needs to see the terminal phase must therefore subscribe *before*
        // the owner retains the flow. M2 shadow parity relies on this: the product adapter
        // subscribes inside `startFlow`, which runs before `admitAndRetainEditorRemixLifecycle`
        // calls `retain`, so it observes the outcome first. Reordering those two would silently
        // downgrade every terminal parity comparison to `machine-not-tracking`.
        actions.end(phase);
    }, [
        writeSession
    ]);
    const retain = (0, $cozmU.useCallback)((handle)=>{
        if (activeRef.current) return undefined;
        const token = Symbol('editor-remix-lifecycle');
        let hasAcceptedPreview = false;
        let entry;
        const isCurrent = ()=>activeRef.current?.token === token;
        const settleTerminal = ()=>{
            if (terminalEntryRef.current !== entry || !entry.terminalLatched || !entry.machineEnded || entry.terminalSettled) return false;
            let released = true;
            try {
                released = entry.onRelease.settleTerminalAuthority?.() ?? true;
            } catch  {
                return false;
            }
            if (!released) return false;
            entry.terminalSettled = true;
            terminalEntryRef.current = undefined;
            return true;
        };
        const release = ()=>{
            if (!isCurrent()) return false;
            const retained = activeRef.current;
            if (retained?.terminalLatched) retained.machineEnded = true;
            try {
                retained?.onRelease();
            } catch  {
            // Product-local cleanup must not prevent lifecycle release or leave ownership stuck.
            }
            activeRef.current = undefined;
            if (!retained?.terminalLatched && terminalEntryRef.current === retained) terminalEntryRef.current = undefined;
            retained?.unsubscribe();
            setActive(undefined);
            const currentSession = sessionRef.current;
            if (currentSession?.token === token && currentSession.terminalPhase === undefined) {
                sessionRef.current = undefined;
                setSession(undefined);
            } else writeSession(token, {
                isAdmitted: false
            });
            return true;
        };
        const actions = {
            conversationId: handle.conversationId,
            remixId: handle.remixId,
            token: token,
            rollback: ()=>{
                if (!release()) return false;
                handle.rollback();
                return true;
            },
            transition: (event)=>{
                if (!isCurrent()) return false;
                const accepted = handle.transition?.(event) ?? false;
                if (accepted && event.type === 'PREVIEW_OPENED') hasAcceptedPreview = true;
                if (accepted && event.type === 'INSERTED') release();
                return accepted;
            },
            hasAcceptedPreview: ()=>isCurrent() && hasAcceptedPreview,
            end: (reason)=>{
                if (!release()) return false;
                handle.end?.(reason);
                return true;
            },
            settleTerminal: settleTerminal,
            setOwnerDestructionEndReason: (reason)=>{
                if (isCurrent() && activeRef.current) activeRef.current.ownerDestructionEndReason = reason;
            }
        };
        entry = {
            actions: actions,
            handle: handle,
            onRelease: ()=>{},
            terminalLatched: false,
            terminalSettled: false,
            machineEnded: false,
            token: token,
            unsubscribe: ()=>{}
        };
        activeRef.current = entry;
        setActive(actions);
        // Before `observe`, which can settle a terminal outcome in this same turn for a flow
        // admitted into an already-terminal machine. Authority has to be readable in that commit,
        // or the legacy effects would run alongside the terminal commands exactly once.
        hasMachineAuthorityRef.current = true;
        setHasMachineAuthority(true);
        // Seeding replaces any prior session outright, settled or dismissed: the read model
        // describes the current flow, and there is only ever one.
        const seeded = {
            token: token,
            remixId: handle.remixId,
            isAdmitted: true,
            phase: (0, $gZHXx.deriveMachineEditorRemixPhase)((0, $bWlOZ.getRemixMachine)(handle.remixId)?.state()),
            terminalPhase: undefined,
            dismissTerminal: ()=>dismissTerminal(token)
        };
        sessionRef.current = seeded;
        setSession(seeded);
        try {
            entry.onRelease = handle.onRetained?.({
                remixId: handle.remixId,
                token: token
            }) ?? (()=>{});
            // A replacement owns the sole current-session slot once its product registration succeeds.
            // Keep an older terminal reference until this point so a failed registration cannot strand
            // that lease on provider destruction.
            terminalEntryRef.current = undefined;
        } catch (error) {
            // Leave no local owner behind; the caller will roll the admitted handle back and fail open.
            // If a terminal A was waiting for UX settlement, a replacement that cannot register must
            // settle A here; otherwise its terminal lease would remain fenced until provider teardown.
            terminalEntryRef.current?.actions.settleTerminal();
            activeRef.current = undefined;
            setActive(undefined);
            sessionRef.current = undefined;
            setSession(undefined);
            // The caller fails this flow open to legacy, so it must not keep machine authority.
            forgetMachineAuthority();
            throw error;
        }
        try {
            entry.unsubscribe = (0, $2Pvub.subscribeToMachine)(handle.remixId, ()=>observe(entry));
            // Admission is itself an observation point. A flow admitted into an already-terminal
            // machine has no transition left to wait for, so it must settle now.
            observe(entry);
        } catch (error) {
            release();
            // Same reason as above: a flow this provider could not subscribe runs as legacy.
            forgetMachineAuthority();
            throw error;
        }
        return actions;
    }, [
        dismissTerminal,
        forgetMachineAuthority,
        observe,
        writeSession
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            const retained = activeRef.current;
            const terminal = terminalEntryRef.current;
            activeRef.current = undefined;
            try {
                retained?.onRelease();
            } catch  {
            // Product-local cleanup must not prevent owner destruction from releasing lifecycle state.
            }
            retained?.unsubscribe();
            if (retained?.ownerDestructionEndReason) retained.handle.end?.(retained.ownerDestructionEndReason);
            else retained?.handle.rollback();
            if (terminal && terminal !== retained) terminal.actions.settleTerminal();
            else if (retained?.terminalLatched) retained.actions.settleTerminal();
        }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            active: active,
            retain: retain,
            forgetMachineAuthority: forgetMachineAuthority
        }), [
        active,
        forgetMachineAuthority,
        retain
    ]);
    /**
   * Authority is merged in rather than stored on the session, because it has to survive the
   * session's own dismissal — see {@link EditorRemixLifecycleRead.hasMachineAuthority}.
   */ const read = (0, $cozmU.useMemo)(()=>({
            ...session ?? $af70fdcc8d818788$var$NO_EDITOR_REMIX_LIFECYCLE,
            hasMachineAuthority: hasMachineAuthority
        }), [
        hasMachineAuthority,
        session
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af70fdcc8d818788$var$EditorRemixLifecycleOwnerContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af70fdcc8d818788$var$EditorRemixLifecycleReadContext.Provider, {
        value: read
    }, children));
};
module.exports["admitAndRetainEditorRemixLifecycle"] = $af70fdcc8d818788$export$9f9aa2084eecc634;
module.exports["useEditorRemixLifecycleOwner"] = $af70fdcc8d818788$export$da4e522b888aba8e;
module.exports["useEditorRemixLifecycle"] = $af70fdcc8d818788$export$c082f0c88efbbb1f;
module.exports["EditorRemixLifecycleOwnerProvider"] = $af70fdcc8d818788$export$c2e62aa710f578c4;

});

parcelRegister("gZHXx", function(module, exports) {
/**
 * Projections into the editor's single lifecycle vocabulary — one from the editor's own signals, one
 * from the lifecycle machine's phase.
 *
 * Nothing here reads or mutates runtime state, and nothing here is authoritative: callers pass what
 * they already know and get back the phase it describes. Keeping both projections in one module is
 * what guarantees the two sides share a vocabulary, so comparing them introduces no second
 * normalization of editor state.
 */ const $051a10f50e48ba45$export$ecdefdb6b9a25ee8 = ({ isThinking: isThinking, isReady: isReady, isPreviewVisible: isPreviewVisible, isInserting: isInserting, isError: isError, isAborted: isAborted, isCancelled: isCancelled })=>{
    if (isError) return 'error';
    if (isAborted || isCancelled) return 'aborted';
    // Insertion outranks the preview because the preview stays mounted while content is written
    // into the document, so both signals are true for the whole of insertion.
    if (isInserting) return 'inserting';
    if (isPreviewVisible) return 'previewing';
    if (isReady) return 'ready';
    if (isThinking) return 'thinking';
    return 'inactive';
};
/**
 * The machine's phases map one-to-one onto the editor's vocabulary. Unlike the renderer, the editor
 * has a real `inserting` phase of its own, so nothing is relabeled here.
 */ const $051a10f50e48ba45$var$MACHINE_TO_EDITOR_PHASE = {
    thinking: 'thinking',
    ready: 'ready',
    previewing: 'previewing',
    inserting: 'inserting',
    error: 'error',
    aborted: 'aborted'
};
const $051a10f50e48ba45$export$6ce62ec2a134b9e2 = (phase)=>{
    if (phase === undefined) return 'inactive';
    // Cast widens the key type only; `satisfies` above still requires every `RemixPhase` to be
    // mapped, so this cannot mask a genuinely missing entry for a declared phase.
    const mapped = $051a10f50e48ba45$var$MACHINE_TO_EDITOR_PHASE[phase];
    return mapped ?? 'inactive';
};
const $051a10f50e48ba45$export$d096159c377a567d = (phase)=>phase === 'error' || phase === 'aborted';
module.exports["deriveLegacyEditorRemixPhase"] = $051a10f50e48ba45$export$ecdefdb6b9a25ee8;
module.exports["deriveMachineEditorRemixPhase"] = $051a10f50e48ba45$export$6ce62ec2a134b9e2;
module.exports["isTerminalEditorRemixPhase"] = $051a10f50e48ba45$export$d096159c377a567d;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    RegisteredExperience["HOME"] = "home";
    RegisteredExperience["FOLDER"] = "folder";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$73c8d1f99070570a = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isFolderRovoConfigProviderProps"] = $56fbda2769629a59$export$73c8d1f99070570a;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("3tUdX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if (props.experience === (0, $dppWL.RegisteredExperience).FOLDER && !(0, $dppWL.isFolderRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("amW67", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $cozmU.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("bXh4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5251c9f91178493b$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $5251c9f91178493b$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $5251c9f91178493b$export$72552b26ebb37b2 = (0, $8s9DV.createStore)({
    initialState: $5251c9f91178493b$export$d4c72bab9d6cc13a,
    actions: $5251c9f91178493b$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $5251c9f91178493b$export$af36d029992e7a8c = (0, $kBr4q.createActionsHook)($5251c9f91178493b$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $5251c9f91178493b$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $5251c9f91178493b$export$af36d029992e7a8c;

});

parcelRegister("k9SyR", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bXh4X = parcelRequire("bXh4X");

const $4a243273df5696f3$export$b854997b7299d67f = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $4a243273df5696f3$export$9af0fbebebbfec35 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
const $4a243273df5696f3$export$2d43c7fdbd36cd6c = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.dailyBriefUnread
});
const $4a243273df5696f3$export$17170223ff11d032 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.isNudgeVisible
});
module.exports["useAINudges"] = $4a243273df5696f3$export$b854997b7299d67f;
module.exports["useDailyBriefUnread"] = $4a243273df5696f3$export$2d43c7fdbd36cd6c;
module.exports["useIsNudgeVisible"] = $4a243273df5696f3$export$17170223ff11d032;

});

parcelRegister("58cpY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c32f66999dc5247fcc5963be2762eee1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc7550dcb3a0996$var$_react = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3bc7550dcb3a0996$var$_iconNew = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3bc7550dcb3a0996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-audio-briefing
 * Usage guidance:
 * Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $3bc7550dcb3a0996$var$_react.default.createElement($3bc7550dcb3a0996$var$_iconNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $3bc7550dcb3a0996$var$_default = module.exports.default = $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'manage-user-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-permissions',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'saml-troubleshooting',
    'scim-troubleshooting',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["STUDIO_AGENT_BUILDER"] = "studio-agent-builder";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;

});

parcelRegister("hTxAd", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $tgs13 = parcelRequire("tgs13");

const $a5f7b05a2384a497$export$9f585226e9430b76 = (experienceKey)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem(experienceKey, true, (0, $tgs13.TWENTY_EIGHT_DAYS_IN_SECONDS));
};
module.exports["markDiscoveryExperienceAsSeen"] = $a5f7b05a2384a497$export$9f585226e9430b76;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("7IVHS", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $8128430585027637$export$2fdcc866a6c73972 = ({ configKey: configKey, fallback: fallback })=>(0, $1xpoY.default).getString(configKey, fallback) || fallback;
/**
 * Matches `{{VARIABLE}}` placeholders in a prompt template. The variable name is captured
 * so it can be swapped for a consumer-supplied value. Unknown tokens are left untouched.
 */ const $8128430585027637$var$PROMPT_TEMPLATE_TOKEN_PATTERN = /\{\{([A-Z0-9_]+)\}\}/gu;
const $8128430585027637$export$62be7f63b49db843 = (config, variables)=>{
    const template = $8128430585027637$export$2fdcc866a6c73972(config);
    return template.replace($8128430585027637$var$PROMPT_TEMPLATE_TOKEN_PATTERN, (token, name)=>Object.prototype.hasOwnProperty.call(variables, name) ? variables[name] : token);
};
module.exports["resolveDynamicConfigStringValue"] = $8128430585027637$export$2fdcc866a6c73972;
module.exports["resolvePromptTemplate"] = $8128430585027637$export$62be7f63b49db843;

});

parcelRegister("kv1hV", function(module, exports) {
const $66e5837ebdc1ee84$export$e65b3021b246816a = {
    contentId: null,
    title: null,
    adf: null
};
const $66e5837ebdc1ee84$export$84cec395ea080001 = (contentId, title, adf)=>{
    $66e5837ebdc1ee84$export$e65b3021b246816a.contentId = contentId;
    $66e5837ebdc1ee84$export$e65b3021b246816a.title = title;
    $66e5837ebdc1ee84$export$e65b3021b246816a.adf = adf;
};
module.exports["pageJustPublishedSignal"] = $66e5837ebdc1ee84$export$e65b3021b246816a;
module.exports["setPageJustPublishedSignal"] = $66e5837ebdc1ee84$export$84cec395ea080001;

});

parcelRegister("lpWis", function(module, exports) {

var $xxVn2 = parcelRequire("xxVn2");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $d9tcB = parcelRequire("d9tcB");


var $bQm3c = parcelRequire("bQm3c");


var $355fY = parcelRequire("355fY");


var $fuH8U = parcelRequire("fuH8U");

// Both must be granted on the linked Studio space to build an automation there:
// the workspace-scoped `manage-automation` and the space-scoped `create-element`.
const $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION = 'workspace/manage-automation';
const $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION = 'space/create-element';
const $312ad01cd65d8d36$var$isPermitted = (data, permissionId)=>data?.bulkPermitted?.some((row)=>row?.permissionId === permissionId && row?.permitted === true) ?? false;
const $312ad01cd65d8d36$export$4b7b5a9f45d10e8b = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const hasBaseEligibility = Boolean(isRovoLLMEnabled && !isAnonymousUser && cloudId);
    const { studioSpaceAri: studioSpaceAri, isLoading: isStudioSpaceLoading } = (0, $355fY.useStudioSpaceAri)({
        skip: skip || !hasBaseEligibility
    });
    const principalId = (0, $fuH8U.getUserAri)(userId)?.toString() ?? null;
    const resourceId = studioSpaceAri?.toString() ?? null;
    const canRunPermissionCheck = Boolean(!skip && hasBaseEligibility && principalId && resourceId);
    const { data: data, loading: isStudioPermissionsLoading } = (0, $jMyy4.useQueryInterop)((0, $xxVn2.default), {
        skip: !canRunPermissionCheck,
        variables: {
            principalIds: [
                principalId,
                principalId
            ],
            resourceIds: [
                resourceId,
                resourceId
            ],
            permissionIds: [
                $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION,
                $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION
            ],
            dontRequirePrincipalsInSite: [
                true,
                true
            ]
        },
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            if ((0, $aMcHK.isStatusCodeError)(error, '403') || (0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "automation-discovery"
    });
    const canCreateStudioAutomation = Boolean($312ad01cd65d8d36$var$isPermitted(data, $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION) && $312ad01cd65d8d36$var$isPermitted(data, $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION));
    return {
        canCreateStudioAutomation: canCreateStudioAutomation,
        isLoading: isStudioSpaceLoading || isStudioPermissionsLoading
    };
};
module.exports["useStudioPermissions"] = $312ad01cd65d8d36$export$4b7b5a9f45d10e8b;

});

parcelRegister("xxVn2", function(module, exports) {
/**
 * @generated SignedSource<<75695f3ffc9f48047b62dc69f3e57a8d>>
 * @relayHash 75ba97e12aabd0b01457d730b2d08e64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e
const $d01bdd659bebf77d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dontRequirePrincipalsInSite"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceIds"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "dontRequirePrincipalsInSite",
                    "variableName": "dontRequirePrincipalsInSite"
                },
                {
                    "kind": "Variable",
                    "name": "permissionIds",
                    "variableName": "permissionIds"
                },
                {
                    "kind": "Variable",
                    "name": "principalIds",
                    "variableName": "principalIds"
                },
                {
                    "kind": "Variable",
                    "name": "resourceIds",
                    "variableName": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useStudioPermissionsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useStudioPermissionsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "75ba97e12aabd0b01457d730b2d08e64",
            "id": "de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e",
            "metadata": {},
            "name": "useStudioPermissionsQuery",
            "operationKind": "query",
            "text": "query useStudioPermissionsQuery($principalIds:[String],$resourceIds:[String],$permissionIds:[String],$dontRequirePrincipalsInSite:[Boolean]){bulkPermitted(principalIds:$principalIds,resourceIds:$resourceIds,permissionIds:$permissionIds,dontRequirePrincipalsInSite:$dontRequirePrincipalsInSite){permissionId,permitted}}"
        }
    };
}();
$d01bdd659bebf77d$var$node.hash = "b0e4a1240e10b4a1d2d14d3f9cc8b8e3";
var $d01bdd659bebf77d$export$2e2bcd8739ae039 = $d01bdd659bebf77d$var$node;
module.exports["default"] = $d01bdd659bebf77d$export$2e2bcd8739ae039;

});

parcelRegister("355fY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7yndN = parcelRequire("7yndN");


var $dK51B = parcelRequire("dK51B");


var $bQm3c = parcelRequire("bQm3c");


var $9KNO1 = parcelRequire("9KNO1");

const $e7f6ba06f42fb231$export$d053c5e11724145b = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [automationStack, setAutomationStack] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        let cancelled = false;
        (0, $9KNO1.getAutomationStack)(environment).then((stack)=>{
            if (!cancelled) setAutomationStack(stack);
        }).catch(()=>{
            if (!cancelled) setAutomationStack(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        environment,
        skip
    ]);
    const shouldRunQuery = !skip && Boolean(cloudId) && Boolean(automationStack);
    const { data: data, loading: loading } = (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/v1/studioContext`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        parseResult: (response)=>{
            const spaceAri = response?.spaceARI;
            return {
                studioSpaceAri: typeof spaceAri === 'string' && (0, $7yndN.StudioSpaceAri).check(spaceAri) ? (0, $7yndN.StudioSpaceAri).parse(spaceAri) : null
            };
        },
        skip: !shouldRunQuery,
        fetchPolicy: 'cache-first'
    });
    return {
        studioSpaceAri: data?.studioSpaceAri ?? null,
        isLoading: shouldRunQuery && loading
    };
};
module.exports["useStudioSpaceAri"] = $e7f6ba06f42fb231$export$d053c5e11724145b;

});

parcelRegister("7yndN", function(module, exports) {

var $elerM = parcelRequire("elerM");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/studio/space/manifest.ts
var $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $elerM.StudioSpaceAriResourceOwner),
    resourceType: (0, $elerM.StudioSpaceAriResourceType),
    resourceIdSlug: "{workspaceId}/{spaceId}",
    resourceIdSegmentFormats: {
        workspaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/,
        spaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/studio/space/index.ts
var $57fdb8b699aab2bc$export$9d14a8e162eb6058 = class _StudioSpaceAri extends (0, $1gKSA.RegisteredAri) {
    get workspaceId() {
        return this._workspaceId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts.qualifier,
            platformQualifier: $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts.resourceOwner,
            resourceType: $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.spaceId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts);
        return new _StudioSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $57fdb8b699aab2bc$var$studioSpaceAriStaticOpts);
        return new _StudioSpaceAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            spaceId: this.spaceId
        };
    }
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
};
module.exports["StudioSpaceAri"] = $57fdb8b699aab2bc$export$9d14a8e162eb6058;

});

parcelRegister("elerM", function(module, exports) {
// src/studio/space/types.ts
var $a70e3bbf91600e1a$export$7273abcabf6247f5 = "studio", $a70e3bbf91600e1a$export$136946b303fa22e0 = "space";
module.exports["StudioSpaceAriResourceOwner"] = $a70e3bbf91600e1a$export$7273abcabf6247f5;
module.exports["StudioSpaceAriResourceType"] = $a70e3bbf91600e1a$export$136946b303fa22e0;

});

parcelRegister("9KNO1", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $1UApO = parcelRequire("1UApO");

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */ const $0691681f8bad8323$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await (0, $f7B1p.cfetch)('https://localhost:8082/devStack.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'omit'
        });
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`);
        return null;
    }
};
const $0691681f8bad8323$export$6123178d3f5fb24d = async (environment)=>{
    switch(environment){
        case 'DEVELOPMENT':
        case 'STAGING':
            return await $0691681f8bad8323$var$getAutomationDevStackFromLocalServer() || window.localStorage.getItem((0, $1UApO.keys).AUTOMATION_PLATFORM_STACK) || 'staging';
        default:
            return 'pro';
    }
};
module.exports["getAutomationStack"] = $0691681f8bad8323$export$6123178d3f5fb24d;

});

parcelRegister("fuH8U", function(module, exports) {

var $as9lu = parcelRequire("as9lu");

const $c1c2eeaa5050cd7d$export$aca8186b03c6237e = (userId)=>{
    if (!userId) return null;
    try {
        return (0, $as9lu.IdentityUserAri).create({
            userId: userId
        });
    } catch (error) {
        return null;
    }
};
module.exports["getUserAri"] = $c1c2eeaa5050cd7d$export$aca8186b03c6237e;

});

parcelRegister("dWpd3", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $8s9DV.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $kBr4q.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $kBr4q.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("jXbuX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bbe3107b8dcb4caf83567322ed86022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e86c725a407358ea$var$_react = $e86c725a407358ea$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e86c725a407358ea$var$_iconNew = $e86c725a407358ea$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e86c725a407358ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e86c725a407358ea$var$SunsetIcon = (props)=>/*#__PURE__*/ $e86c725a407358ea$var$_react.default.createElement($e86c725a407358ea$var$_iconNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$e86c725a407358ea$var$SunsetIcon.displayName = 'SunsetIcon';
var $e86c725a407358ea$var$_default = module.exports.default = $e86c725a407358ea$var$SunsetIcon;

});

parcelRegister("9Ke0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79d00c97b076e624cafe200482318a3d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7183465f1a1868e6$var$_react = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7183465f1a1868e6$var$_iconNew = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7183465f1a1868e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/generative-indicator
 * Usage guidance:
 * Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7183465f1a1868e6$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $7183465f1a1868e6$var$_react.default.createElement($7183465f1a1868e6$var$_iconNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$7183465f1a1868e6$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $7183465f1a1868e6$var$_default = module.exports.default = $7183465f1a1868e6$var$GenerativeIndicatorIcon;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPoYT = parcelRequire("dPoYT");


var $kQqCc = parcelRequire("kQqCc");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("eDWhq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");

const $d70864677eee19d7$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $85mU8.getBrowserBridgeAPI)())=>{
    const refApi = (0, $cozmU.useRef)(apiInstance);
    const refReady = (0, $cozmU.useRef)(false);
    const refMount = (0, $cozmU.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $cozmU.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $cozmU.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $cozmU.useCallback)((command_0, params)=>{
        // devx: provide current `clientId`
        return api.send(command_0, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $cozmU.useCallback)((command_1, params_0, options)=>{
        api.broadcast(command_1, params_0, options);
    }, [
        api
    ]);
    const teardown = (0, $cozmU.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
   * If we have already mounted our handlers once and marked ourselves as ready, then this
   * bridge API client is already capable of receiving & handling commands. On subsequent renders
   * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
   *
   * This will ensure the newest state of every handler is being used, with no stale references
   * in closures, as can often occur with initialise-only-once code in React.
   */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $d70864677eee19d7$export$a74fbbd6fb01001c;

});

parcelRegister("ZKswU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $8lhhf = parcelRequire("8lhhf");


var $7dHQW = parcelRequire("7dHQW");

const $326b9cee4ac976c2$var$PROMPT_CATEGORIES = [
    'Analyze',
    'Brainstorm',
    'Review',
    'Summarize',
    'Create',
    'Execute',
    'Find',
    'Learn'
];
const $326b9cee4ac976c2$var$PROMPT_ROLES = [
    'General',
    'Engineering',
    'Product',
    'Program Management',
    'Design',
    'Marketing',
    'IT Ops',
    'Sales',
    'Customer Support',
    'Helpdesk Support',
    'Security'
];
const $326b9cee4ac976c2$var$createFilterOptions = (values)=>values.map((value)=>({
            id: value,
            label: value
        }));
const $326b9cee4ac976c2$export$9fa6e712ef03097f = $326b9cee4ac976c2$var$createFilterOptions($326b9cee4ac976c2$var$PROMPT_CATEGORIES);
const $326b9cee4ac976c2$export$9472c6a87dde5170 = $326b9cee4ac976c2$var$createFilterOptions($326b9cee4ac976c2$var$PROMPT_ROLES);
const $326b9cee4ac976c2$export$1ac99e1b5b1a8cfe = 'rovo-chat-prompt-gallery';
const $326b9cee4ac976c2$export$bee44b12dce7b448 = (prompt)=>{
    const slugs = [];
    const slashSkillPattern = new RegExp((0, $8lhhf.ROVO_SKILL_TAG_PATTERN).source, 'g');
    for (const m of prompt.matchAll(slashSkillPattern))slugs.push(m[1]);
    return slugs;
};
// Prompts with multiple placeholders are commented out until they are supported by this
// PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/217105
const $326b9cee4ac976c2$var$staticPrompts = [
    {
        id: 'analyze-customer-feedback-trends',
        title: 'Analyze customer feedback trends',
        prompt: 'Gather and synthesize customer feedback on `product/feature` from various channels such as emails, calls, surveys, support tickets to identify key themes, pain points, opportunities such as upsell and adoption, and organize findings into actionable recommendations. If relevant, map them to stages of the customer journey.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Program Management',
            'Customer Support',
            'Sales'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'analyze-it-support-trends',
    // 	title: 'Analyze Trends in IT Support Requests',
    // 	prompt:
    // 		'Examine all IT support requests related to `request type` from the past `number of months` months. Break down the request type by identifying the most common sub-categories and providing counts for each. Investigate resolution notes or agent comments to uncover recurring root causes behind these issues. Identify any time-based patterns, such as spikes in requests during specific times of day, days of the week, or months. Based on your findings, recommend actionable strategies to effectively reduce the volume of this request type.',
    // 	useCase: 'Analyze',
    // 	roles: ['Helpdesk Support', 'IT Ops', 'Customer Support', 'Program Management'],
    // },
    {
        id: 'brainstorm-project-ideas',
        title: 'Brainstorm ideas for project',
        prompt: "We're running a brainstorming session on `topic/problem/goal`. Generate a diverse list of creative ideas, solutions, and/or approaches. For each idea, include a brief description, potential benefits, and any risks or challenges. Organize the ideas by theme or category if possible.",
        useCase: 'Brainstorm',
        roles: [
            'General'
        ]
    },
    {
        id: 'send-slack-weekly-progress',
        title: 'Send Slack message of weekly progress',
        prompt: 'Draft a summary of the key updates and additions I made over the past week. Send this summary in Slack to `Teams channel link`. Confirm the draft with me before sending.',
        useCase: 'Execute',
        roles: [
            'General'
        ]
    },
    {
        id: 'compare-jira-support-article',
        title: 'Compare Jira work item to support article',
        prompt: 'Review the summary, description, and comments of the current request `work item ID`. Based on this information and considering common themes from recently resolved requests, determine if this issue points to a recurring problem that currently lacks a dedicated knowledge base article. If so, propose a concise title for a new knowledge base article and 2-3 key topics or resolution steps it should cover. This should be a distinct problem, not a minor variation of an existing knowledge base article.',
        useCase: 'Review',
        roles: [
            'Helpdesk Support',
            'Customer Support',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'conduct-competitive-research',
    // 	title: 'Conduct competitive research',
    // 	prompt:
    // 		'Analyze the competitive landscape for `product` against `Competitor A, B, C, and D` by comparing features, pricing, market positioning, and strengths. Identify market gaps for `product` to explore. Summarize findings in a narrative, including a comparison matrix.',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management', 'Marketing', 'Sales'],
    // },
    {
        id: 'convert-request-jql-query',
        title: 'Convert request into JQL query',
        prompt: 'Write a JQL query to find all unresolved bugs assigned to my team in the last 30 days.',
        useCase: 'Execute',
        roles: [
            'Engineering',
            'Product',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'create-jira-work-item-summaries',
    // 	title: 'Create a document of Jira work item summaries',
    // 	prompt:
    // 		'Generate a Confluence page summarizing information in these work items: `work item ID(s)`.',
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Program Management', 'Engineering', 'Customer Support'],
    // },
    // {
    // 	id: 'create-new-sprint',
    // 	title: 'Create a new sprint',
    // 	prompt:
    // 		'Create a new sprint named `sprint name` on the board: `board key`. Set the sprint goal to `sprint goal`, start date to `YYYY-MM-DD`, and end date to `YYYY-MM-DD`.',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'create-ab-testing-plan',
        title: 'Create A/B testing plan',
        prompt: 'Create a detailed A/B testing plan for `project/feature`. Start by defining the hypothesis and primary goal, specifying the variants to be tested, and identifying the key metric(s) for success. Outline the target audience and sample size, describe how users will be randomly assigned to each group, and set the test duration and timeline. Include steps for implementation, data collection, and analysis, and note any tools or platforms to be used. Finally, add placeholders for documenting results, learnings, and next steps, ensuring the plan is clear, actionable, and easy to adapt for different experiments, with space for users to add or modify details as needed.',
        useCase: 'Create',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Design'
        ]
    },
    // {
    // 	id: 'create-effective-okr',
    // 	title: 'Create an effective OKR',
    // 	prompt: 'Help me create an effective OKR for my team.',
    // 	useCase: 'Create',
    // 	roles: ['General', 'Product', 'Program Management'],
    // },
    {
        id: 'create-background-research-plan',
        title: 'Create background research plan',
        prompt: 'Create a first draft or conduct background research on `topic/work item`. Summarise key points, relevant history, and provide links to supporting documents.',
        useCase: 'Summarize',
        roles: [
            'Product',
            'Program Management',
            'Engineering',
            'Design'
        ]
    },
    {
        id: 'create-customer-onboarding-strategy',
        title: 'Create customer onboarding strategy',
        prompt: 'As a customer success lead, outline a clear customer onboarding strategy for `product or service`, including key objectives, main onboarding steps, communication touchpoints, and success metrics; highlight best practices for activation and engagement, and provide space for users to add project-specific details or adapt the strategy for different customer segments, ensuring the plan is concise, actionable, and easy to share with stakeholders.',
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Sales',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'create-jira-work-item',
    // 	title: 'Create Jira work item',
    // 	prompt:
    // 		'Create a Jira work item in project `project key` with work type as `bug/task/story/epic`, status as TO DO, classification level as project default, and the summary "`summary`."',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'IT Ops', 'Customer Support'],
    // },
    // {
    // 	id: 'create-meeting-agenda',
    // 	title: 'Create meeting agenda',
    // 	prompt:
    // 		'Create a `number of minutes/hours` meeting agenda with `person/team/department` on `meeting topic` to discuss `objectives for the meeting`. Based on these objectives, suggest key topics, allocate appropriate time for each, and list any supporting materials needed.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-personalized-onboarding-plan',
    // 	title: 'Create personalized onboarding plan',
    // 	prompt:
    // 		'Create a 30-day plan to help me get up to speed. I am onboarding onto `team` as a `role`. Include learning resources, team priorities, key contacts, and engagement strategies.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-presentation-outline',
    // 	title: 'Create presentation outline',
    // 	prompt:
    // 		'Outline a talk track for a presentation targeting `company/product` clients in the `sector` to educate them on the `solution`. Ensure the talk track is clear, informative, and formatted with timestamps in a table.',
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    // {
    // 	id: 'create-pricing-model-customers',
    // 	title: 'Create pricing model for customers',
    // 	prompt:
    // 		'Generate a pricing model for `customer/product` using the latest customer data. Include scenario analysis and pricing plan comparisons.',
    // 	useCase: 'Create',
    // 	roles: ['Sales', 'Product', 'Marketing'],
    // },
    {
        id: 'create-product-requirements-document',
        title: 'Create product requirements document',
        prompt: 'Draft a PRD for `project/feature`. Depending on context such as OKRs, PRD, A/B test, retrospective, include objectives, hypotheses, requirements, metrics, learnings, and next steps.',
        useCase: 'Create',
        roles: [
            'Program Management',
            'Design',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'create-recurring-calendar-meeting',
    // 	title: 'Create recurring calendar meeting',
    // 	prompt:
    // 		'Create a `number of minutes` recurring calendar meeting every `day` at `HH:MM am/pm` `timezone` for `project` with `person`.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-release-notes',
    // 	title: 'Create release notes',
    // 	prompt:
    // 		'Create clear release documentation for `project/product`. Include release date, features, fixes, known issues, and Jira work items/references if found. Provide output in multiple formats such as Confluence, PDF, Markdown as needed.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'Customer Support'],
    // },
    // {
    // 	id: 'create-resolution-notes',
    // 	title: 'Create resolution notes',
    // 	prompt:
    // 		'Create resolution notes for future reference suitable for other agents and team leads to quickly understand the following work item and its resolution: `work item link`. Include a brief and clear description of the problem, the identified root cause, and a summary of the diagnostic steps and actions performed. Clearly state the exact resolution that was implemented. Specify the total time from ticket creation to resolution using HH:MM format, or days/hours if longer.',
    // 	useCase: 'Create',
    // 	roles: ['Helpdesk Support', 'Customer Support', 'IT Ops'],
    // },
    // {
    // 	id: 'draft-blog-post',
    // 	title: 'Draft a blog post',
    // 	prompt:
    // 		'Draft a blog post or marketing collateral for `product/feature`. Highlight key benefits, use cases, and include customer testimonials if available.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Product', 'Sales'],
    // },
    // {
    // 	id: 'draft-usability-testing-script',
    // 	title: 'Draft a usability testing script',
    // 	prompt:
    // 		'Draft a detailed usability testing script for the following feature/product `Confluence page link`. The script should be suitable for a moderated session and include the following sections: Introduction for the participant (Reassure the participant that the focus is on the product, not their performance), Warm-up/background questions, Scenario setup, Task instructions, and Wrap-up questions. For each task, specify what a successful outcome looks like and, if appropriate, include a rating scale for ease of use. Throughout, use accessible, concise, and clear language, avoid jargon and directional UI language, keep instructions and questions short and focused, and ensure the script is easy to follow for both moderator and participant, formatting it as a template that can be easily adapted for different products or features',
    // 	useCase: 'Create',
    // 	roles: ['Design', 'Product'],
    // },
    // {
    // 	id: 'draft-and-send-email',
    // 	title: 'Draft and send email',
    // 	prompt:
    // 		"Draft an email to `email address` with the subject `Subject` with a message regarding `topic/purpose`. Once I've confirmed, send this email.",
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'edit-confluence-page-status',
        title: 'Edit Confluence page status',
        prompt: "Update this page's status to Ready for Review: `Confluence page link`",
        useCase: 'Execute',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'explain-acronym',
    // 	title: 'Explain an acronym',
    // 	prompt:
    // 		"Explain the meaning of the acronym '`acronym`' in this context: `context`. Provide its full form and a brief definition.",
    // 	useCase: 'Learn',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'explain-end-to-end-service-flow',
    // 	title: 'Explain End-to-End Service Flow',
    // 	prompt:
    // 		'Explain the `process/system flow` for `feature` as experienced by `end-user/customer`. Include each step from `start event` to `end event`. Highlight any system interactions, notifications, and common issues or exceptions. Provide diagrams or documentation links if available.',
    // 	useCase: 'Learn',
    // 	roles: [
    // 		'Sales',
    // 		'IT Ops',
    // 		'Program Management',
    // 		'Customer Support',
    // 		'Product',
    // 		'Security',
    // 		'Helpdesk Support',
    // 		'Engineering',
    // 	],
    // },
    {
        id: 'explain-code',
        title: 'Explain this code',
        prompt: 'Explain what the code below does, describing its purpose, how it works, and any important details or logic involved. Use clear, concise language suitable for someone with basic programming knowledge. `Insert code snippet`.',
        useCase: 'Learn',
        roles: [
            'Engineering'
        ]
    },
    {
        id: 'extract-key-insights-datasets',
        title: 'Extract key insights from datasets',
        prompt: '`Upload dataset file(s)` Based on the provided dataset, please analyze and present the top 5 most interesting observations, highlights, or trends, identifying segments that were more likely to respond in a certain way, significant patterns, or unexpected insights from the data.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-analyze-customer-contracts',
    // 	title: 'Find and analyze information from customer contracts',
    // 	prompt:
    // 		'Analyze all existing contracts for `project/customer segment/time period` and extract information on response times, maintenance obligations, and product rates. Present findings in a comparative table, highlighting any variations between customers. If available, include contract names (`Contract name/ID`), customer names (`Customer A, Customer B]), and any relevant contract dates (`Effective Date, Expiry Date`).',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management'],
    // },
    {
        id: 'find-prioritize-open-pull-requests',
        title: 'Find and prioritize open pull requests',
        prompt: "Summarize all my open pull requests in across all repositories I have access to in Bitbucket, as well as all pull requests where I'm assigned as a reviewer. Clearly indicate the number of pull requests pending my review and the total number of open PRs involving me. Group the results by repository and include key details such as PR title, status, author, and last updated date.",
        useCase: 'Summarize',
        roles: [
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-hr-policies',
    // 	title: 'Find HR policies',
    // 	prompt:
    // 		'Find all the HR policies that a new hire joining the `location` office would need during onboarding. Reference the latest HR policy resources. Organize results in a table and check if all required policies and contacts are included.',
    // 	useCase: 'Find',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'find-information-3p-sources',
    // 	title: 'Find information from 3P sources',
    // 	prompt: 'Find the latest `topic` presentation in our Google Drive or other 3rd party sources.',
    // 	useCase: 'Find',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    {
        id: 'find-overdue-jira-work-items',
        title: 'Find overdue Jira work items for my team',
        prompt: 'Show all overdue work items for my team, including links to them and how long they have been overdue.',
        useCase: 'Find',
        roles: [
            'Engineering',
            'IT Ops',
            'Helpdesk Support',
            'Program Management'
        ]
    },
    // {
    // 	id: 'find-potential-security-vulnerabilities',
    // 	title: 'Find potential security vulnerabilities',
    // 	prompt:
    // 		'For this pull request `pull request ID`, identify and summarize any changes that were made that have potential security vulnerabilities.',
    // 	useCase: 'Find',
    // 	roles: ['Security', 'IT Ops'],
    // },
    // {
    // 	id: 'find-related-jira-projects',
    // 	title: 'Find related Jira projects',
    // 	prompt: 'What Jira projects have ongoing work that relates to this decision: `description`?',
    // 	useCase: 'Find',
    // 	roles: ['Program Management', 'Product', 'Engineering'],
    // },
    {
        id: 'find-relevant-confluence-pages',
        title: 'Find relevant Confluence pages',
        prompt: 'For `work item ID/project/feature`, find and list any related Confluence pages or reference work items. Include links and a brief summary of how each is relevant.',
        useCase: 'Find',
        roles: [
            'Program Management',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-requirements-jira-work-item',
    // 	title: 'Find requirements for a Jira work item',
    // 	prompt:
    // 		'Identify and document the requirements for work item `work item ID`. Ensure all necessary details are captured, including dependencies and acceptance criteria.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'find-subject-matter-expertise',
    // 	title: 'Find subject-matter expertise',
    // 	prompt:
    // 		'Find the subject matter expert for `topic`. I need to contact them for `purpose, e.g., advice, review, collaboration`. Confirm the recommended person is the most relevant and available expert.',
    // 	useCase: 'Find',
    // 	roles: ['General', 'Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'draft-it-support-response',
    // 	title: 'Draft IT Support response',
    // 	prompt:
    // 		'Draft a reply to a user who is experiencing `topic` issues. Provide clear, empathetic guidance and suggest next steps for resolving the problem using this guide/playbook [Confluence page link]. Here is the user request: `User request`.',
    // 	useCase: 'Create',
    // 	roles: ['Customer Support', 'Helpdesk Support'],
    // },
    {
        id: 'find-latest-company-policies',
        title: 'Find the latest company policies',
        prompt: 'How do I request reimbursements for my travels?',
        useCase: 'Learn',
        roles: [
            'General'
        ]
    },
    {
        id: 'generate-faq',
        title: 'Generate an FAQ',
        prompt: "Map out the typical customer journey for `product/service`, from initial discovery through onboarding, usage, and support. Then, generate top FAQs that customers most frequently ask at each stage\u2014covering how to get started, feature usage, troubleshooting, billing, and best practices\u2014with concise, step-by-step answers formatted for a chatbot.",
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Program Management',
            'Product',
            'Marketing'
        ]
    },
    {
        id: 'generate-post-project-surveys',
        title: 'Generate post-project surveys',
        prompt: "Create a comprehensive evaluation survey for `project` to assess the project's performance, including successes, challenges, areas for improvement, and lessons learned. Include questions such as scale, multiple choice, and open answer covering: objectives and outcomes, budget and resources, team performance and collaboration, challenges and problem-solving, stakeholder satisfaction, and recommendations for future projects.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Product',
            'General'
        ]
    },
    // {
    // 	id: 'identify-upsell-opportunities',
    // 	title: 'Identify upsell opportunities',
    // 	prompt:
    // 		"Analyze the provided call transcript `link to call transcript` with the customer `customer name` and identify all instances where the customer expresses interest in additional features or services. For each instance, include relevant background context, the exact customer quote indicating interest, and a brief explanation of why it represents a potential upsell opportunity. Additionally, recommend the most suitable upsell product or service based on the customer's expressed needs or goals.",
    // 	useCase: 'Analyze',
    // 	roles: ['Sales', 'Product', 'Customer Support', 'Marketing'],
    // },
    {
        id: 'learn-company-procedure-information',
        title: 'Learn about company procedure information',
        prompt: 'Summarize the standard procedures for `process/activity` across the company. Include step-by-step instructions and reference documents.',
        useCase: 'Summarize',
        roles: [
            'General',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'plan-sprint-tasks',
    // 	title: 'Plan sprint tasks',
    // 	prompt:
    // 		'Generate a detailed task list for our upcoming sprint using the information provided in `project poster`. For each task, include the task name, a brief description, the responsible team member, and estimated completion time. Organize the tasks by priority level and group them according to their related user stories to ensure clarity and alignment with sprint goals. Flag any missing details needed to finalize sprint planning.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'IT Ops'],
    // },
    // {
    // 	id: 'prepare-performance-review',
    // 	title: 'Prepare for your performance review',
    // 	prompt:
    // 		'Prepare talking points for an upcoming growth conversation with my manager, summarizing my work between `dates`, organized by key projects. The points should facilitate a productive discussion about my performance, achievements, and areas for improvement. They should be clear, concise, and backed by specific examples and evidence. Organize into sections for each major project, including: project overview, my specific contributions, and relevant links.',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'retrieve-pull-request-insights-jira',
    // 	title: 'Retrieve pull request insights from Jira',
    // 	prompt:
    // 		'For the given Jira work item Jira work item `link to Jira work item`, retrieve all linked pull requests across repositories. Include each pull request number, title, current review status such as Draft, Open, Approved, Merged, or Rejected, the associated reviewers, and the merge date if applicable. Output a structured table with the columns PR Number, Title, Status, Reviewers, and Merge Date.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering'],
    // },
    // {
    // 	id: 'review-improve-presentation',
    // 	title: 'Review and improve presentation',
    // 	prompt:
    // 		'Review this presentation `upload or link presentation slides/script` and provide me with suggestions on how to improve it. Please consider the following context: the audience consists of [audience, e.g., senior executives, students, clients], the primary goal is [goal, e.g., to persuade, to inform, to inspire], and the desired outcome is `outcome, e.g., increased engagement, clear understanding, actionable next steps`. Focus your feedback on the overall structure, flow, clarity, and impact, and tailor your suggestions to maximize effectiveness for this specific audience and goal.',
    // 	useCase: 'Review',
    // 	roles: ['General'],
    // },
    {
        id: 'review-improve-writing',
        title: 'Review and improve writing',
        prompt: 'Rewrite the following message to make it more clear, concise, and professional while retaining all key details: `Insert message here`.',
        useCase: 'Review',
        roles: [
            'General',
            'Sales',
            'Customer Support'
        ]
    },
    {
        id: 'search-policies-questionnaires',
        title: 'Search policies related to questionnaires',
        prompt: 'Search all internal security and compliance policies and provide answers to the following questionnaire. Reference policy documents and highlight relevant sections for each answer.',
        useCase: 'Find',
        roles: [
            'Security',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'send-ms-teams-weekly-progress',
    // 	title: 'Send MS Teams message of weekly progress',
    // 	prompt:
    // 		'Draft a summary of the key updates and additions I made over the past week. Send this summary in MS Teams to `Teams channel link`. Confirm the draft with me before sending.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'suggest-process-streamlining',
        title: 'Suggest process streamlining',
        prompt: 'Suggest ways to streamline the process for `process/task`. Identify steps that can be automated or simplified to reduce manual work and produce more succinct outputs.',
        useCase: 'Learn',
        roles: [
            'Program Management',
            'IT Ops',
            'Engineering'
        ]
    },
    {
        id: 'summarize-track-project-updates',
        title: 'Summarize and track project updates',
        prompt: 'Summarize the status and history of `project/topic/feature`. Include key initiatives, progress made, stakeholders, decisions, timelines, and relevant documents. Highlight upcoming milestones or blockers.',
        useCase: 'Summarize',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'summarize-confluence-page-google-doc',
    // 	title: 'Summarize Confluence page and add to Google doc',
    // 	prompt:
    // 		'Summarize key points and any action items/next steps in this Confluence page: `Confluence page link` and add this summary to a new Google doc titled "`title`" under the folder "`folder`."',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'summarize-engineering-requests',
    // 	title: 'Summarize engineering requests',
    // 	prompt: 'Review and summarize recent Engineering Requests (ERs) for my team.',
    // 	useCase: 'Review',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'summarize-meeting-notes',
        title: 'Summarize meeting notes',
        prompt: 'Summarize the meeting with the transcript `attach file or paste transcript`, including main topics discussed, key decisions, and action items.',
        useCase: 'Summarize',
        roles: [
            'General'
        ]
    },
    {
        id: 'synthesize-user-testing-findings',
        title: 'Synthesize findings from user testing',
        prompt: 'Synthesize key insights from my user testing: `Confluence page link/transcript`. Identify the top pain points or issues that users faced during the testing. Categorize these issues by severity and impact on user experience.',
        useCase: 'Analyze',
        roles: [
            'Design'
        ]
    },
    {
        id: 'visualize-data-charts',
        title: 'Visualize your data into charts',
        prompt: '`Upload your dataset file(s)` Based on the uploaded dataset file, determine the most effective way to visualize the data. Identify the key structure and variables within the dataset and the most likely user goals for this data, to suggest and describe the most appropriate type of visualization.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Engineering',
            'Marketing'
        ]
    }
];
const $326b9cee4ac976c2$var$staticPromptsWithSkill = [
    // {
    // 	id: 'summarize-release',
    // 	title: 'Summarize release',
    // 	prompt:
    // 		"/summarize-release this `Jira release` for `product` to generate an executive snapshot. Include: 1) key changes grouped by epic or component, 2) risks and blockers with owners and dates, 3) quality signals (open bugs, regressions, flaky tests), 4) planned rollout and key dates, and 5) clear next steps for stakeholders.",
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'create-release',
        title: 'Create release',
        prompt: "/create-release in this `Jira space` to create a new release with start and release dates. Include completed work items and summarize what's included by epic or team.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Engineering'
        ],
        tags: [
            'jira-releases'
        ]
    },
    // {
    // 	id: 'draft-release-notes',
    // 	title: 'Draft release notes',
    // 	prompt:
    // 		"/draft-release-notes for this `Jira release` and related `Confluence page` to generate customer-facing release notes. Organize into \"What's new\", \"Improvements\", \"Fixes\", and \"Known issues\" with clear, non-technical language.",
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'create-work-items',
    // 	title: 'Create work items',
    // 	prompt:
    // 		"/create-work-items from this `Confluence page` (feature spec) in this `Jira space`. Break the feature into epics, stories, and tasks with summaries, descriptions, and estimates. List everything created, grouped by epic.",
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'write-status-update',
    // 	title: 'Write status update',
    // 	prompt:
    // 		"/write-status-update with this `Jira space` and these `Confluence pages` to draft a status update for `project/initiative` over the last `time period`. Include overall RAG, key achievements, major risks/blockers with owners, and next steps.",
    // 	useCase: 'Create',
    // 	roles: ['Program Management', 'Product'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'page-catchup',
    // 	title: 'Page catchup',
    // 	prompt:
    // 		"/page-catchup this `Confluence page` to summarize what changed in the last `time period`. Highlight new sections, major edits, important comments, and open tasks or questions.",
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'update-work-items',
    // 	title: 'Update work items',
    // 	prompt:
    // 		"/update-work-items for these `Jira work items` in this `Jira space` to bulk update: set assignee, add label, and move items to a new status if no blockers. Show a summary of planned changes first.",
    // 	useCase: 'Execute',
    // 	roles: ['Program Management', 'Engineering'],
    // },
    // {
    // 	id: 'manage-jira-permissions',
    // 	title: 'Manage Jira permissions',
    // 	prompt:
    // 		"/manage-jira-permissions for this `Jira work item` or `Jira space` to diagnose permission issues, explain missing permissions, and provide admin guidance to resolve.",
    // 	useCase: 'Execute',
    // 	roles: ['IT Ops', 'Security'],
    // },
    // {
    // 	id: 'find-jira-settings',
    // 	title: 'Find Jira settings',
    // 	prompt:
    // 		"/find-jira-settings for this `Jira space` and my goal \"`desired behavior`\". Tell me which settings to change, where to find them, and any trade-offs.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'manage-jira-workflows',
        title: 'Manage Jira workflows',
        prompt: '/manage-jira-workflows for this `Jira space` to analyze its workflow: explain statuses, transitions, top workflow rules, and propose simplifications.',
        useCase: 'Execute',
        roles: [
            'IT Ops',
            'Program Management'
        ],
        tags: [
            'jira-workflows'
        ]
    },
    // {
    // 	id: 'search-assets',
    // 	title: 'Search Assets',
    // 	prompt:
    // 		"/search-assets in this `JSM project` for \"`asset search criteria`\" and highlight any related to this `JSM incident` or `Jira work item`. Return a table of matching assets.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    // {
    // 	id: 'create-pir',
    // 	title: 'Create PIR',
    // 	prompt:
    // 		"/create-pir for this `JSM incident` and related `Confluence pages` to draft a complete Post Incident Review with all standard sections.",
    // 	useCase: 'Create',
    // 	roles: ['IT Ops'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'analyze-incident-root-cause',
        title: 'Find root cause of an incident (RCA)',
        prompt: '/analyze-incident-root-cause for this `JSM incident` to analyze details, linked alerts, changes, assets, and similar incidents. Propose likely root cause and investigation steps.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'find-incident-root-cause',
        title: 'Find incident root cause',
        prompt: '/find-incident-root-cause for this `JSM incident` to infer the most likely root cause and provide a stakeholder-friendly summary.',
        useCase: 'Find',
        roles: [
            'IT Ops',
            'General'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'find-incidents',
    // 	title: 'Find incidents',
    // 	prompt:
    // 		"/find-incidents in this `JSM project` for incidents from the last `time period` matching \"`criteria`\". Group by status or service, show counts, and surface the most impactful incidents.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'find-similar-incidents',
        title: 'Find similar incidents',
        prompt: '/find-similar-incidents for this `JSM incident` to find the most similar historical incidents, how they were resolved, and any recurring patterns.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'suggest-problem-ticket',
        title: 'Suggest problem ticket',
        prompt: '/suggest-problem-ticket for this `JSM incident` to check for similar incidents and, if recurring, propose a problem ticket with all key details and links.',
        useCase: 'Create',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-fields',
        title: 'Suggest incident fields',
        prompt: '/suggest-incident-fields for this `JSM incident` to propose values for service, component, priority, impact, urgency, and major incident flag, with justifications.',
        useCase: 'Execute',
        roles: [
            'Helpdesk Support',
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-sme',
        title: 'Suggest incident SME',
        prompt: '/suggest-incident-expert for this `JSM incident` to recommend the best people or teams to involve, with reasons and suggested actions.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'summarize-incident',
        title: 'Summarize incident',
        prompt: '/summarize-incident for this `JSM incident` to create an executive summary with impact, timeline, root cause, mitigation, and next steps.',
        useCase: 'Summarize',
        roles: [
            'IT Ops',
            'General'
        ]
    },
    // {
    // 	id: 'find-alerts',
    // 	title: 'Find alerts',
    // 	prompt:
    // 		"/find-alerts in this `JSM project` for alerts from the last `time period`. Group by service and severity, highlight recurring alerts, and relate to incidents or changes.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    // {
    // 	id: 'recommend-playbook',
    // 	title: 'Recommend playbook',
    // 	prompt:
    // 		"/recommend-playbook for this `alert` or `JSM incident` to suggest the best runbooks or playbooks, with links and first steps.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    {
        id: 'assess-change-risk-insights',
        title: 'Assess change risk insights',
        prompt: '/assess-change-risk for this `JSM change request` to assess risk, explain drivers, and suggest safeguards like canary deployments or extra approvals.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'get-data-insights',
        title: 'Get data insights',
        prompt: '/get-data-insights for this `Jira space` to create charts (throughput, cycle time, WIP) and interpret trends, bottlenecks, and recommendations.',
        useCase: 'Analyze',
        roles: [
            'Engineering',
            'Program Management'
        ],
        enableDeepResearch: true
    }
];
// Filters out prompt cards that reference skills but have no skill metadata.
// This will also act as an entitlement check for the user.
const $326b9cee4ac976c2$var$filterCardsBySkillMetadata = (cards, skillMetadataMap)=>{
    if (skillMetadataMap === undefined) return cards;
    return cards.filter((card)=>{
        const slugs = $326b9cee4ac976c2$export$bee44b12dce7b448(card.prompt);
        if (slugs.length === 0) return true;
        return slugs.every((slug)=>slug in skillMetadataMap);
    });
};
const $326b9cee4ac976c2$export$47aa2ee75b720c2e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    let t0;
    if ($[0] !== skillMetadata?.skillMetadataMap) {
        const first3Prompts = $326b9cee4ac976c2$var$staticPrompts.slice(0, 3);
        const remainingPrompts = $326b9cee4ac976c2$var$staticPrompts.slice(3);
        const skillsPrompts = $326b9cee4ac976c2$var$filterCardsBySkillMetadata($326b9cee4ac976c2$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
        const promptCards = [
            ...first3Prompts,
            ...skillsPrompts,
            ...remainingPrompts
        ];
        t0 = {
            promptCards: promptCards
        };
        $[0] = skillMetadata?.skillMetadataMap;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    // First 3 curated prompts, then skills prompts, then the rest
    const first3Prompts = $326b9cee4ac976c2$var$staticPrompts.slice(0, 3);
    const remainingPrompts = $326b9cee4ac976c2$var$staticPrompts.slice(3);
    const skillsPrompts = $326b9cee4ac976c2$var$filterCardsBySkillMetadata($326b9cee4ac976c2$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
    const promptCards = [
        ...first3Prompts,
        ...skillsPrompts,
        ...remainingPrompts
    ];
    return {
        promptCards: promptCards
    };
};
module.exports["useCaseOptions"] = $326b9cee4ac976c2$export$9fa6e712ef03097f;
module.exports["roleOptions"] = $326b9cee4ac976c2$export$9472c6a87dde5170;
module.exports["PROMPT_LIBRARY_SKILL_TAG"] = $326b9cee4ac976c2$export$1ac99e1b5b1a8cfe;
module.exports["usePromptCards"] = $326b9cee4ac976c2$export$47aa2ee75b720c2e;

});

parcelRegister("dStyd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3upRY = parcelRequire("3upRY");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $arQY7 = parcelRequire("arQY7");


var $ekCm6 = parcelRequire("ekCm6");


var $eFbDl = parcelRequire("eFbDl");


var $iMnC5 = parcelRequire("iMnC5");

const $4d36537dd1ad55e2$var$styles = {
    showBorder: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc"
}; // The fixed partition/resource-owner/resource-type segments of an identity user ARI — only the
// account id itself varies. Matched by prefix rather than via `@atlassian/ari` (an internal
// package this public package can't depend on).
const $4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX = 'ari:cloud:identity::user/'; /**
                                                               * Parses the account id needed for the picture fetch from whatever identity a caller carries —
                                                               * either the bare account id, or the full identity ARI (callers that already have one on hand
                                                               * don't need to strip it first).
                                                               */ 
const $4d36537dd1ad55e2$var$parseIdentityAccountId = (value)=>{
    const trimmed = value?.trim();
    if (!trimmed) return undefined;
    return trimmed.startsWith($4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX) ? trimmed.slice($4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX.length) : trimmed;
};
const $4d36537dd1ad55e2$var$FetchedAgentAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { accountId: accountId, agentName: agentName, fallback: fallback, showBorder: showBorder, size: size } = t0;
    let t1;
    if ($[0] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[0] = accountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $3upRY.default), t1, t2);
    let t3;
    if ($[3] !== data.user?.picture) {
        t3 = data.user?.picture?.trim();
        $[3] = data.user?.picture;
        $[4] = t3;
    } else t3 = $[4];
    const picture = t3;
    if (!picture) return fallback;
    let t4;
    if ($[5] !== agentName || $[6] !== data.user?.name) {
        t4 = data.user?.name?.trim() || agentName;
        $[5] = agentName;
        $[6] = data.user?.name;
        $[7] = t4;
    } else t4 = $[7];
    const name = t4;
    if (!showBorder) {
        let t5;
        if ($[8] !== name || $[9] !== picture || $[10] !== size) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                src: picture,
                name: name,
                label: name,
                size: size
            });
            $[8] = name;
            $[9] = picture;
            $[10] = size;
            $[11] = t5;
        } else t5 = $[11];
        return t5;
    }
    const t5 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t6 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = {
            height: t5,
            width: t6
        };
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== name || $[16] !== picture || $[17] !== size) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            src: picture,
            name: name,
            label: name,
            size: size
        });
        $[15] = name;
        $[16] = picture;
        $[17] = size;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t7 || $[20] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "resolved-agent-avatar-border",
            xcss: $4d36537dd1ad55e2$var$styles.showBorder,
            style: t7
        }, t8);
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
} : ({ accountId: accountId, agentName: agentName, fallback: fallback, showBorder: showBorder, size: size })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $3upRY.default), {
        accountId: accountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const picture = data.user?.picture?.trim();
    if (!picture) return fallback;
    const name = data.user?.name?.trim() || agentName;
    if (!showBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        src: picture,
        name: name,
        label: name,
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "resolved-agent-avatar-border",
        xcss: $4d36537dd1ad55e2$var$styles.showBorder,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size]
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        src: picture,
        name: name,
        label: name,
        size: size
    }));
};
const $4d36537dd1ad55e2$export$4e9b8ef47b20fa25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, fallback: fallback, showBorder: t1, size: t2 } = t0;
    const showBorder = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "medium" : t2;
    let t3;
    if ($[0] !== agentName || $[1] !== fallback || $[2] !== size) {
        t3 = fallback ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            name: agentName,
            size: size
        });
        $[0] = agentName;
        $[1] = fallback;
        $[2] = size;
        $[3] = t3;
    } else t3 = $[3];
    const resolvedFallback = t3;
    let t4;
    if ($[4] !== agentIdentityAccountId) {
        t4 = $4d36537dd1ad55e2$var$parseIdentityAccountId(agentIdentityAccountId);
        $[4] = agentIdentityAccountId;
        $[5] = t4;
    } else t4 = $[5];
    const accountId = t4;
    if (!accountId) return resolvedFallback;
    let t5;
    if ($[6] !== size) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: size
        });
        $[6] = size;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== accountId || $[9] !== agentName || $[10] !== resolvedFallback || $[11] !== showBorder || $[12] !== size) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d36537dd1ad55e2$var$FetchedAgentAvatar, {
            accountId: accountId,
            agentName: agentName,
            fallback: resolvedFallback,
            showBorder: showBorder,
            size: size
        });
        $[8] = accountId;
        $[9] = agentName;
        $[10] = resolvedFallback;
        $[11] = showBorder;
        $[12] = size;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t5
        }, t6);
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== resolvedFallback || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: resolvedFallback
        }, t7);
        $[17] = resolvedFallback;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, fallback: fallback, showBorder: showBorder = false, size: size = 'medium' })=>{
    const resolvedFallback = fallback ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        name: agentName,
        size: size
    });
    const accountId = $4d36537dd1ad55e2$var$parseIdentityAccountId(agentIdentityAccountId);
    if (!accountId) return resolvedFallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: resolvedFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: size
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d36537dd1ad55e2$var$FetchedAgentAvatar, {
        accountId: accountId,
        agentName: agentName,
        fallback: resolvedFallback,
        showBorder: showBorder,
        size: size
    })));
};
module.exports["ResolvedAgentAvatar"] = $4d36537dd1ad55e2$export$4e9b8ef47b20fa25;

});

parcelRegister("3upRY", function(module, exports) {
/**
 * @generated SignedSource<<765322731b31afdb0584c134ed53e12a>>
 * @relayHash 07c2f9612a7a8401a21c6ad1a0936b2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa69c7a83a201b1f2a5cdca116d15f149410a79d7ce49e3fafb7ce1e4a4e38d5
const $9f11dc73dc13bcc3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ResolvedAgentAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ResolvedAgentAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aa69c7a83a201b1f2a5cdca116d15f149410a79d7ce49e3fafb7ce1e4a4e38d5",
            "metadata": {},
            "name": "ResolvedAgentAvatarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f11dc73dc13bcc3$var$node.hash = "a2c97e7ac7feca789629a3b50c6150aa";
var $9f11dc73dc13bcc3$export$2e2bcd8739ae039 = $9f11dc73dc13bcc3$var$node;
module.exports["default"] = $9f11dc73dc13bcc3$export$2e2bcd8739ae039;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: [],
    copiedPageContentId: null,
    copiedPageActions: [],
    agentMentionId: null,
    agentMentionInsertionCount: 0,
    resolvedAgentMentionId: null,
    agentMentionContext: null,
    agentMentionPrompt: null,
    agentMentionName: null,
    agentMentionParentNodeType: null,
    agentMentionNodeLocalId: null
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        },
    setCopiedPageState: ({ contentId: contentId, actions: copiedPageActions })=>({ setState: setState })=>{
            setState({
                copiedPageContentId: contentId,
                copiedPageActions: copiedPageActions
            });
        },
    clearCopiedPageState: ()=>({ setState: setState })=>{
            setState({
                copiedPageContentId: null,
                copiedPageActions: []
            });
        },
    setAgentMentionState: (state)=>({ setState: setState, getState: getState })=>{
            // Only reset resolvedAgentMentionId when the agent itself changes — not when
            // agentMentionContext updates (user typing after the mention) — to prevent the nudge
            // from flashing on every keystroke while the resolved UUID is already available.
            const current = getState();
            // Reset resolvedAgentMentionId when the agent changes OR when a new insertion
            // is made for the same agent — the insertion count increase means a new fetch
            // is about to start, and the old resolved UUID should not persist if it fails.
            const shouldResetResolved = state.agentMentionId !== current.agentMentionId || state.agentMentionInsertionCount !== current.agentMentionInsertionCount;
            setState({
                ...state,
                ...shouldResetResolved ? {
                    resolvedAgentMentionId: null
                } : {}
            });
        },
    setResolvedAgentMentionId: (resolvedAgentMentionId)=>({ setState: setState })=>{
            setState({
                resolvedAgentMentionId: resolvedAgentMentionId
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $8s9DV.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $kBr4q.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
const $4c5988c837301b49$export$55e2629117d47ccd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.copiedPageContentId
});
const $4c5988c837301b49$export$775383c2d1c66c92 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.copiedPageActions
});
const $4c5988c837301b49$export$f47243b349b78626 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionId
});
const $4c5988c837301b49$export$65c1c9c4f5245bef = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionInsertionCount
});
const $4c5988c837301b49$export$c4372fb8872a2f0b = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.resolvedAgentMentionId
});
const $4c5988c837301b49$export$5c060a79a26e7361 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionContext
});
const $4c5988c837301b49$export$4f371676b9a398fe = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionPrompt
});
const $4c5988c837301b49$export$95a191dd4fa0d1fd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionName
});
const $4c5988c837301b49$export$f79a54b315516f9f = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionParentNodeType
});
const $4c5988c837301b49$export$af8dd61c1ae633af = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionNodeLocalId ?? null
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;
module.exports["useEditorRovoButtonCopiedPageContentId"] = $4c5988c837301b49$export$55e2629117d47ccd;
module.exports["useEditorRovoButtonCopiedPageActions"] = $4c5988c837301b49$export$775383c2d1c66c92;
module.exports["useEditorRovoButtonAgentMentionId"] = $4c5988c837301b49$export$f47243b349b78626;
module.exports["useEditorRovoButtonAgentMentionInsertionCount"] = $4c5988c837301b49$export$65c1c9c4f5245bef;
module.exports["useEditorRovoButtonResolvedAgentMentionId"] = $4c5988c837301b49$export$c4372fb8872a2f0b;
module.exports["useEditorRovoButtonAgentMentionContext"] = $4c5988c837301b49$export$5c060a79a26e7361;
module.exports["useEditorRovoButtonAgentMentionPrompt"] = $4c5988c837301b49$export$4f371676b9a398fe;
module.exports["useEditorRovoButtonAgentMentionName"] = $4c5988c837301b49$export$95a191dd4fa0d1fd;
module.exports["useEditorRovoButtonAgentMentionParentNodeType"] = $4c5988c837301b49$export$f79a54b315516f9f;
module.exports["useEditorRovoButtonAgentMentionNodeLocalId"] = $4c5988c837301b49$export$af8dd61c1ae633af;

});

parcelRegister("jQDPt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");


var $gP4Ah = parcelRequire("gP4Ah");


var $iKq5p = parcelRequire("iKq5p");


var $aDLTK = parcelRequire("aDLTK");


var $d1E9z = parcelRequire("d1E9z");


var $4dGeq = parcelRequire("4dGeq");


var $7lEy4 = parcelRequire("7lEy4");


var $gLHF9 = parcelRequire("gLHF9");


var $3ZJWK = parcelRequire("3ZJWK");


var $6691T = parcelRequire("6691T");

const $2c0f5767430884e4$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: src,
            alt: ''
        });
const $2c0f5767430884e4$var$defaultIcon = $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7lEy4))));
const $2c0f5767430884e4$export$cbe04d535daede57 = {
    Analyze: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gP4Ah)))),
    Brainstorm: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($iKq5p)))),
    Review: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($3ZJWK)))),
    Summarize: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($6691T)))),
    Create: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($aDLTK)))),
    Execute: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($d1E9z)))),
    Find: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($4dGeq)))),
    Learn: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gLHF9))))
};
const $2c0f5767430884e4$export$8581fc8a588fa6e0 = $2c0f5767430884e4$var$defaultIcon;
const $2c0f5767430884e4$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $2c0f5767430884e4$export$cbe04d535daede57)) return $2c0f5767430884e4$var$defaultIcon;
    return $2c0f5767430884e4$export$cbe04d535daede57[useCase];
};
module.exports["getUseCaseIcon"] = $2c0f5767430884e4$export$9b54dda66a3b3d54;

});

parcelRegister("gP4Ah", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("iKq5p", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("aDLTK", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("d1E9z", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("4dGeq", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("7lEy4", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("gLHF9", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("3ZJWK", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("6691T", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("NHD0A", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $dTEBe = parcelRequire("dTEBe");


var $1AJi3 = parcelRequire("1AJi3");


var $jmjWc = parcelRequire("jmjWc");


var $eCmUm = parcelRequire("eCmUm");


var $jln20 = parcelRequire("jln20");


const $2894748abe105937$var$remixObjectPagePopupLoader = ()=>(parcelRequire("gM7w9"));
const $2894748abe105937$var$RemixObjectPagePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "yWhOM",
    name: "RemixObjectPagePopup",
    loader: async ()=>(await $2894748abe105937$var$remixObjectPagePopupLoader()).RemixObjectPagePopup
});
const $2894748abe105937$var$stablePopupTriggerStyle = null;
const $2894748abe105937$var$legacySession = {
    hasAdapter: false,
    isObjectSidebarRemixModalOpen: false,
    retainedLifecycleToken: undefined,
    admitLifecycle: ()=>true,
    admitObjectSidebarRemixLifecycle: ()=>'legacy',
    openObjectSidebarRemixModal: ()=>{},
    releaseCurrentRetainedLifecycle: ()=>{},
    releaseRetainedLifecycleForToken: ()=>{},
    closeObjectSidebarRemixModal: ()=>{},
    stopObjectSidebarRemixThinking: ()=>{}
};
const $2894748abe105937$var$ObjectSidebarRemixLifecycleSessionContext = /*#__PURE__*/ (0, $cozmU.createContext)($2894748abe105937$var$legacySession);
const $2894748abe105937$export$dd4ef3ed24572382 = ({ children: children, lifecycleAdapter: lifecycleAdapter })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: rightSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const { openConversationAssistant: openConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive } = (0, $1AJi3.useToggleConversationAssistant)();
    const lifecycleOwner = (0, $eCmUm.useObjectSidebarRemixLifecycleOwner)();
    const retainedLifecycleRef = (0, $cozmU.useRef)(undefined);
    const [retainedLifecycleToken, setRetainedLifecycleToken] = (0, $cozmU.useState)();
    const [activePopupSession, setActivePopupSession] = (0, $cozmU.useState)();
    const isConversationAssistantSidebarActiveRef = (0, $cozmU.useRef)(isConversationAssistantSidebarActive);
    isConversationAssistantSidebarActiveRef.current = isConversationAssistantSidebarActive;
    const releaseCurrentRetainedLifecycle = (0, $cozmU.useCallback)((reason)=>{
        const retainedLifecycle = retainedLifecycleRef.current;
        if (!retainedLifecycle) return;
        retainedLifecycleRef.current = undefined;
        setRetainedLifecycleToken(undefined);
        retainedLifecycle.lifecycle.end(reason);
    }, []);
    const releaseRetainedLifecycleForToken = (0, $cozmU.useCallback)((expectedToken, reason_0)=>{
        const retainedLifecycle_0 = retainedLifecycleRef.current;
        if (!expectedToken || !retainedLifecycle_0 || retainedLifecycle_0.token !== expectedToken) return;
        retainedLifecycleRef.current = undefined;
        setRetainedLifecycleToken(undefined);
        retainedLifecycle_0.lifecycle.end(reason_0);
    }, []);
    const admitObjectSidebarRemixLifecycle = (0, $cozmU.useCallback)((request = {})=>{
        // The lifecycle adapter owns rollout and exposure at the Object Sidebar Remix start
        // boundary. Disabled/control outcomes fall through to the legacy path.
        const lifecycleRetention = (0, $eCmUm.admitAndRetainObjectSidebarRemixLifecycle)({
            adapter: lifecycleAdapter,
            owner: lifecycleOwner,
            request: {
                kind: 'create',
                ...request.conversationId !== undefined && {
                    conversationId: request.conversationId
                }
            }
        });
        if (lifecycleRetention.status === 'active-flow-rejected') return 'rejected';
        if (lifecycleRetention.status === 'retained') {
            const token = Symbol('object-sidebar-remix-lifecycle');
            retainedLifecycleRef.current = {
                token: token,
                lifecycle: lifecycleRetention.lifecycle
            };
            setRetainedLifecycleToken(token);
            return 'retained';
        }
        return 'legacy';
    }, [
        lifecycleAdapter,
        lifecycleOwner
    ]);
    const admitLifecycle = (0, $cozmU.useCallback)((request_0 = {})=>admitObjectSidebarRemixLifecycle(request_0) !== 'rejected', [
        admitObjectSidebarRemixLifecycle
    ]);
    const openObjectSidebarRemixModal = (0, $cozmU.useCallback)((adfDocument)=>{
        setActivePopupSession({
            adfDocument: adfDocument,
            isModalOpen: true,
            lifecycleToken: retainedLifecycleRef.current?.token,
            sessionToken: Symbol('object-sidebar-remix-popup-session')
        });
    }, []);
    const closeObjectSidebarRemixModal = (0, $cozmU.useCallback)((options)=>{
        setActivePopupSession((popupSession)=>{
            if (!popupSession) return popupSession;
            const reason_1 = options?.remixLifecycleEndReason ?? 'cancelled';
            if (popupSession.lifecycleToken) releaseRetainedLifecycleForToken(popupSession.lifecycleToken, reason_1);
            else releaseCurrentRetainedLifecycle(reason_1);
            return {
                ...popupSession,
                isModalOpen: false,
                lifecycleToken: undefined
            };
        });
    }, [
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken
    ]);
    const closeObjectSidebarRemixModalForSession = (0, $cozmU.useCallback)((expectedSessionToken, options_0)=>{
        setActivePopupSession((popupSession_0)=>{
            if (!popupSession_0 || popupSession_0.sessionToken !== expectedSessionToken) return popupSession_0;
            const reason_2 = options_0?.remixLifecycleEndReason ?? 'cancelled';
            if (popupSession_0.lifecycleToken) releaseRetainedLifecycleForToken(popupSession_0.lifecycleToken, reason_2);
            else releaseCurrentRetainedLifecycle(reason_2);
            return {
                ...popupSession_0,
                isModalOpen: false,
                lifecycleToken: undefined
            };
        });
    }, [
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken
    ]);
    const stopObjectSidebarRemixThinking = (0, $cozmU.useCallback)((options_1)=>{
        if (!options_1?.reopenModal) return;
        setActivePopupSession((popupSession_1)=>popupSession_1 ? {
                ...popupSession_1,
                isModalOpen: true
            } : popupSession_1);
    }, []);
    const stopObjectSidebarRemixThinkingForSession = (0, $cozmU.useCallback)((expectedSessionToken_0, options_2)=>{
        if (!options_2?.reopenModal) return;
        setActivePopupSession((popupSession_2)=>popupSession_2 && popupSession_2.sessionToken === expectedSessionToken_0 ? {
                ...popupSession_2,
                isModalOpen: true
            } : popupSession_2);
    }, []);
    const handleOpenSidebarConversation = (0, $cozmU.useCallback)((conversationId)=>{
        (0, $dTEBe.updatePageRovoParams)({
            pathway: 'chat',
            conversationId: conversationId
        });
        if (!isConversationAssistantSidebarActiveRef.current) openConversationAssistant('sidebar');
    }, [
        openConversationAssistant
    ]);
    const renderPopupTrigger = (0, $cozmU.useCallback)(({ ref: ref, ...triggerProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            ref: ref,
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _39xV02HZdu _0jFU0VHZdu _1pp6NdYbGa"
            ])
        });
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            hasAdapter: lifecycleAdapter !== undefined,
            isObjectSidebarRemixModalOpen: activePopupSession?.isModalOpen ?? false,
            retainedLifecycleToken: retainedLifecycleToken,
            admitLifecycle: admitLifecycle,
            admitObjectSidebarRemixLifecycle: admitObjectSidebarRemixLifecycle,
            openObjectSidebarRemixModal: openObjectSidebarRemixModal,
            releaseCurrentRetainedLifecycle: releaseCurrentRetainedLifecycle,
            releaseRetainedLifecycleForToken: releaseRetainedLifecycleForToken,
            closeObjectSidebarRemixModal: closeObjectSidebarRemixModal,
            stopObjectSidebarRemixThinking: stopObjectSidebarRemixThinking
        }), [
        admitLifecycle,
        admitObjectSidebarRemixLifecycle,
        activePopupSession?.isModalOpen,
        closeObjectSidebarRemixModal,
        lifecycleAdapter,
        openObjectSidebarRemixModal,
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken,
        retainedLifecycleToken,
        stopObjectSidebarRemixThinking
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2894748abe105937$var$ObjectSidebarRemixLifecycleSessionContext.Provider, {
        value: value
    }, children, activePopupSession ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2894748abe105937$var$RemixObjectPagePopup, {
        adfDocument: activePopupSession.adfDocument,
        isModalOpen: activePopupSession.isModalOpen,
        onClose: (options_3)=>closeObjectSidebarRemixModalForSession(activePopupSession.sessionToken, options_3),
        onStopThinking: (options_4)=>stopObjectSidebarRemixThinkingForSession(activePopupSession.sessionToken, options_4),
        popupRepositionKey: rightSidebarWidth,
        onOpenSidebarConversation: handleOpenSidebarConversation,
        shouldWaitForRemixHandoffBeforeClose: activePopupSession.lifecycleToken !== undefined,
        trigger: renderPopupTrigger
    }) : null);
};
const $2894748abe105937$export$a75eec40de8c7652 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2894748abe105937$var$ObjectSidebarRemixLifecycleSessionContext);
} : ()=>(0, $cozmU.useContext)($2894748abe105937$var$ObjectSidebarRemixLifecycleSessionContext);
module.exports["ObjectSidebarRemixLifecycleSessionProvider"] = $2894748abe105937$export$dd4ef3ed24572382;
module.exports["useObjectSidebarRemixLifecycleSession"] = $2894748abe105937$export$a75eec40de8c7652;

});

parcelRegister("gM7w9", function(module, exports) {

let $c366f5dcb9bfce62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c366f5dcb9bfce62$var$load("6wr18"),
    $c366f5dcb9bfce62$var$load("ih3Pw"),
    $c366f5dcb9bfce62$var$load("9Oxea"),
    $c366f5dcb9bfce62$var$load("ly931"),
    $c366f5dcb9bfce62$var$load("ffEVr"),
    $c366f5dcb9bfce62$var$load("fA1hG")
]).then(()=>parcelRequire('6UgwP'));

});

parcelRegister("dF5G8", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $eefe01aff44a51d3$export$2e8f8ad7223eff71 = (0, $kSwu1.defineMessages)({
    suggestionsLabel: {
        id: "object-sidebar-components.suggestions.button.label",
        defaultMessage: "Suggestions"
    }
});
module.exports["reviewButtonMessages"] = $eefe01aff44a51d3$export$2e8f8ad7223eff71;

});

parcelRegister("5Uf3U", function(module, exports) {

let $44cdddb8a3ebe225$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44cdddb8a3ebe225$var$load("glIEn").then(()=>parcelRequire('6pfrs'));

});

parcelRegister("5qQdB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $clm0n = parcelRequire("clm0n");


var $2FDVd = parcelRequire("2FDVd");

function $b7ce1064e1aa0864$export$c7e43f4a82ad66db() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $2FDVd.tableOfContentsButtonMessages).buttonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($clm0n))),
        label: label,
        isDisabled: true,
        testId: "sidebar-table-of-contents-button"
    }));
}
module.exports["TableOfContentsButtonPlaceholder"] = $b7ce1064e1aa0864$export$c7e43f4a82ad66db;

});

parcelRegister("2FDVd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $75070bb589e76133$export$3cce5d4c8b8a1da0 = (0, $kSwu1.defineMessages)({
    buttonLabel: {
        id: "floating-table-of-contents-common.button-label",
        defaultMessage: "Table of contents"
    }
});
module.exports["tableOfContentsButtonMessages"] = $75070bb589e76133$export$3cce5d4c8b8a1da0;

});

parcelRegister("kKSyI", function(module, exports) {

let $f1c26cc7037748bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1c26cc7037748bd$var$load("eGnZE"),
    $f1c26cc7037748bd$var$load("lwTz1"),
    $f1c26cc7037748bd$var$load("cdiJX"),
    $f1c26cc7037748bd$var$load("foA2q"),
    $f1c26cc7037748bd$var$load("l7Pap")
]).then(()=>parcelRequire('hMNzI'));

});

parcelRegister("cYXKf", function(module, exports) {

let $97396eb8abdff925$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97396eb8abdff925$var$load("6wr18"),
    $97396eb8abdff925$var$load("j6yAY"),
    $97396eb8abdff925$var$load("flgjz"),
    $97396eb8abdff925$var$load("f3qSD"),
    $97396eb8abdff925$var$load("lFmKr"),
    $97396eb8abdff925$var$load("do5z1"),
    $97396eb8abdff925$var$load("aOIZj"),
    $97396eb8abdff925$var$load("ffEVr"),
    $97396eb8abdff925$var$load("7EorR"),
    $97396eb8abdff925$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("kONYb", function(module, exports) {

let $f27f3d1a111e48ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27f3d1a111e48ff$var$load("1jVx9").then(()=>parcelRequire('3D12W'));

});

parcelRegister("gN62b", function(module, exports) {

let $c395e738886479fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c395e738886479fa$var$load("k3amn").then(()=>parcelRequire('5A18u'));

});

parcelRegister("2sYsz", function(module, exports) {

let $1cbd1856e38901ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cbd1856e38901ac$var$load("2Hp35").then(()=>parcelRequire('dRspb'));

});

parcelRegister("cv9SU", function(module, exports) {

let $91a00c2ab4957bf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91a00c2ab4957bf9$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("3zDXO", function(module, exports) {

let $29a3a3f56e45a9db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29a3a3f56e45a9db$var$load("6wr18"),
    $29a3a3f56e45a9db$var$load("ffEVr"),
    $29a3a3f56e45a9db$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("jyQuB", function(module, exports) {

let $e3d9e936067b1c66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3d9e936067b1c66$var$load("4wPZ7").then(()=>parcelRequire('eQF4d'));

});

parcelRegister("a02bs", function(module, exports) {

let $747b992038497a3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $747b992038497a3f$var$load("6wr18"),
    $747b992038497a3f$var$load("ih3Pw"),
    $747b992038497a3f$var$load("9Oxea"),
    $747b992038497a3f$var$load("ly931"),
    $747b992038497a3f$var$load("ffEVr"),
    $747b992038497a3f$var$load("fjSG8")
]).then(()=>parcelRequire('gMGbk'));

});

parcelRegister("fmz8s", function(module, exports) {

let $b2f42a442b045b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2f42a442b045b0c$var$load("fvcK2"),
    $b2f42a442b045b0c$var$load("cyTuQ"),
    $b2f42a442b045b0c$var$load("6e5Dd")
]).then(()=>parcelRequire('8woNY'));

});

parcelRegister("jzzzm", function(module, exports) {

let $e3fce08b1c6fd2f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3fce08b1c6fd2f4$var$load("31msE").then(()=>parcelRequire('9POeP'));

});

parcelRegister("3R9tJ", function(module, exports) {

let $2cedac92278937c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cedac92278937c5$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jp2Q3 = parcelRequire("jp2Q3");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $kSwu1.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6wGOF.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("lQXDC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $gBjHb = parcelRequire("gBjHb");

const $71fb2a898293aa35$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $71fb2a898293aa35$export$34282a1f95511a11 = (props)=>{
    const data = $71fb2a898293aa35$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $71fb2a898293aa35$export$34282a1f95511a11;

});

parcelRegister("8auAj", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $34b824decffaa688$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).NONE];
}
module.exports["isRestricted"] = $34b824decffaa688$export$dbaa15dc1820b89a;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("jX0rV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2tbWn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("dOzBl")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ePsdA")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2GvIV")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("16HIv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("WAFjY")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("474Ah")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("84VXz")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fQ8BA")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dDWYb")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5XRxk")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("hMxVZ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("58PuX")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jglh9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("iHOtt")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("d3k1V")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXcxb")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jK2My")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("ge9it")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1O6Yy")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jNfyP")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("eL47t")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("jX0rV", function(module, exports) {

let $e863e0441b14ec08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e863e0441b14ec08$var$load("1JYrd"),
    $e863e0441b14ec08$var$load("cip6w"),
    $e863e0441b14ec08$var$load("gAG2n"),
    $e863e0441b14ec08$var$load("hFpP9"),
    $e863e0441b14ec08$var$load("3feYV"),
    $e863e0441b14ec08$var$load("cwjU2"),
    $e863e0441b14ec08$var$load("3Ff1R"),
    $e863e0441b14ec08$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2tbWn", function(module, exports) {

let $1cc78d5897d732a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cc78d5897d732a7$var$load("30242"),
    $1cc78d5897d732a7$var$load("3qBwQ"),
    $1cc78d5897d732a7$var$load("cYGDU"),
    $1cc78d5897d732a7$var$load("ddSTH"),
    $1cc78d5897d732a7$var$load("7Q1SM"),
    $1cc78d5897d732a7$var$load("33Iaa"),
    $1cc78d5897d732a7$var$load("blA7x"),
    $1cc78d5897d732a7$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("dOzBl", function(module, exports) {

let $a0eb8f8a89644122$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0eb8f8a89644122$var$load("15aAJ"),
    $a0eb8f8a89644122$var$load("8rREG"),
    $a0eb8f8a89644122$var$load("dgXJL"),
    $a0eb8f8a89644122$var$load("9d8JZ"),
    $a0eb8f8a89644122$var$load("7JdzX"),
    $a0eb8f8a89644122$var$load("6681T"),
    $a0eb8f8a89644122$var$load("3dn3H"),
    $a0eb8f8a89644122$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("ePsdA", function(module, exports) {

let $acbbb7a8f95cd6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acbbb7a8f95cd6fc$var$load("l5BBd"),
    $acbbb7a8f95cd6fc$var$load("93ASN"),
    $acbbb7a8f95cd6fc$var$load("htu5t"),
    $acbbb7a8f95cd6fc$var$load("1A450"),
    $acbbb7a8f95cd6fc$var$load("24LNf"),
    $acbbb7a8f95cd6fc$var$load("iYQCc"),
    $acbbb7a8f95cd6fc$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("2GvIV", function(module, exports) {

let $1f481cafca2c7f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f481cafca2c7f01$var$load("bbv9t"),
    $1f481cafca2c7f01$var$load("9fQoJ"),
    $1f481cafca2c7f01$var$load("lTboH"),
    $1f481cafca2c7f01$var$load("gBDXQ"),
    $1f481cafca2c7f01$var$load("cnlNg"),
    $1f481cafca2c7f01$var$load("d3Phe"),
    $1f481cafca2c7f01$var$load("lASLx"),
    $1f481cafca2c7f01$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("16HIv", function(module, exports) {

let $0ce8433c656a7df9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ce8433c656a7df9$var$load("7p4je"),
    $0ce8433c656a7df9$var$load("8SZbD"),
    $0ce8433c656a7df9$var$load("iE05k"),
    $0ce8433c656a7df9$var$load("lv5aU"),
    $0ce8433c656a7df9$var$load("9Uf61"),
    $0ce8433c656a7df9$var$load("3Yk1e"),
    $0ce8433c656a7df9$var$load("5lJyy"),
    $0ce8433c656a7df9$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("WAFjY", function(module, exports) {

let $0b01dbe497441ac5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b01dbe497441ac5$var$load("5ZQnr"),
    $0b01dbe497441ac5$var$load("lJyww"),
    $0b01dbe497441ac5$var$load("gVfjY"),
    $0b01dbe497441ac5$var$load("2hqQb"),
    $0b01dbe497441ac5$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("474Ah", function(module, exports) {

let $2feb5f3312640ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2feb5f3312640ee1$var$load("1jQRQ"),
    $2feb5f3312640ee1$var$load("5pOQA"),
    $2feb5f3312640ee1$var$load("5GSny"),
    $2feb5f3312640ee1$var$load("cQump"),
    $2feb5f3312640ee1$var$load("fJSEb"),
    $2feb5f3312640ee1$var$load("ajzkj"),
    $2feb5f3312640ee1$var$load("eyysG"),
    $2feb5f3312640ee1$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("84VXz", function(module, exports) {

let $5e1ba813b36eb977$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5e1ba813b36eb977$var$load("km37l"),
    $5e1ba813b36eb977$var$load("gbksI"),
    $5e1ba813b36eb977$var$load("j2X7f"),
    $5e1ba813b36eb977$var$load("fE8pi"),
    $5e1ba813b36eb977$var$load("9TeWr"),
    $5e1ba813b36eb977$var$load("kUZ7k"),
    $5e1ba813b36eb977$var$load("dJQL7"),
    $5e1ba813b36eb977$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("fQ8BA", function(module, exports) {

let $b882632b90032289$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b882632b90032289$var$load("lTbXI"),
    $b882632b90032289$var$load("a98cw"),
    $b882632b90032289$var$load("e40mE"),
    $b882632b90032289$var$load("btBGI"),
    $b882632b90032289$var$load("fOGnR"),
    $b882632b90032289$var$load("cDQOq"),
    $b882632b90032289$var$load("8upye"),
    $b882632b90032289$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("dDWYb", function(module, exports) {

let $9eeca90420daddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9eeca90420daddea$var$load("iUyZj"),
    $9eeca90420daddea$var$load("4PDaO"),
    $9eeca90420daddea$var$load("lMhbw"),
    $9eeca90420daddea$var$load("amTTV"),
    $9eeca90420daddea$var$load("8nEeY"),
    $9eeca90420daddea$var$load("kLZKK"),
    $9eeca90420daddea$var$load("c7GMc"),
    $9eeca90420daddea$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("5XRxk", function(module, exports) {

let $457bfdb241591b32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $457bfdb241591b32$var$load("kPlMQ"),
    $457bfdb241591b32$var$load("ervs7"),
    $457bfdb241591b32$var$load("8CX31"),
    $457bfdb241591b32$var$load("kYd4i"),
    $457bfdb241591b32$var$load("fzzMQ"),
    $457bfdb241591b32$var$load("33S6H"),
    $457bfdb241591b32$var$load("kFae4"),
    $457bfdb241591b32$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("hMxVZ", function(module, exports) {

let $03573eef817c65ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03573eef817c65ad$var$load("iT2sv"),
    $03573eef817c65ad$var$load("iMMtn"),
    $03573eef817c65ad$var$load("23VWs"),
    $03573eef817c65ad$var$load("e1KaU"),
    $03573eef817c65ad$var$load("3gNEO"),
    $03573eef817c65ad$var$load("93obY"),
    $03573eef817c65ad$var$load("6Y9jE"),
    $03573eef817c65ad$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("58PuX", function(module, exports) {

let $3be5a59a48a9e11b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be5a59a48a9e11b$var$load("lyPpF"),
    $3be5a59a48a9e11b$var$load("eX5n7"),
    $3be5a59a48a9e11b$var$load("aiYuN"),
    $3be5a59a48a9e11b$var$load("gqMCT"),
    $3be5a59a48a9e11b$var$load("gvylW"),
    $3be5a59a48a9e11b$var$load("bxfRe"),
    $3be5a59a48a9e11b$var$load("ed6s8"),
    $3be5a59a48a9e11b$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("jglh9", function(module, exports) {

let $e06003d5e1220a42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e06003d5e1220a42$var$load("iN3cj"),
    $e06003d5e1220a42$var$load("3nHdy"),
    $e06003d5e1220a42$var$load("gDEvm"),
    $e06003d5e1220a42$var$load("5MwHB"),
    $e06003d5e1220a42$var$load("80OLx"),
    $e06003d5e1220a42$var$load("1EVcg"),
    $e06003d5e1220a42$var$load("96q1k"),
    $e06003d5e1220a42$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("iHOtt", function(module, exports) {

let $d9e3654e24ebe721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9e3654e24ebe721$var$load("eC1OL"),
    $d9e3654e24ebe721$var$load("ilL9c"),
    $d9e3654e24ebe721$var$load("64nco"),
    $d9e3654e24ebe721$var$load("9cx6P"),
    $d9e3654e24ebe721$var$load("e4s0V"),
    $d9e3654e24ebe721$var$load("28EXy"),
    $d9e3654e24ebe721$var$load("7RZp5"),
    $d9e3654e24ebe721$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("d3k1V", function(module, exports) {

let $980b17bc6670e7c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $980b17bc6670e7c7$var$load("4NJ49"),
    $980b17bc6670e7c7$var$load("bfOZL"),
    $980b17bc6670e7c7$var$load("jLbRX"),
    $980b17bc6670e7c7$var$load("5g0HW"),
    $980b17bc6670e7c7$var$load("4dPO1"),
    $980b17bc6670e7c7$var$load("gg8tK"),
    $980b17bc6670e7c7$var$load("eF54W"),
    $980b17bc6670e7c7$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("lXcxb", function(module, exports) {

let $ffb8d4b57da0499e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffb8d4b57da0499e$var$load("fsCDU"),
    $ffb8d4b57da0499e$var$load("kuolm"),
    $ffb8d4b57da0499e$var$load("fvE7S"),
    $ffb8d4b57da0499e$var$load("apVmx"),
    $ffb8d4b57da0499e$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("jK2My", function(module, exports) {

let $e5f478a9b13e5070$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f478a9b13e5070$var$load("g9gkE"),
    $e5f478a9b13e5070$var$load("jYdbS"),
    $e5f478a9b13e5070$var$load("6ncWv"),
    $e5f478a9b13e5070$var$load("gFneG"),
    $e5f478a9b13e5070$var$load("ltrgi"),
    $e5f478a9b13e5070$var$load("fu25G"),
    $e5f478a9b13e5070$var$load("iQGcz"),
    $e5f478a9b13e5070$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("ge9it", function(module, exports) {

let $bd052a544036c7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd052a544036c7c1$var$load("jhikU"),
    $bd052a544036c7c1$var$load("f0i3H"),
    $bd052a544036c7c1$var$load("bvBAp"),
    $bd052a544036c7c1$var$load("9kqmW"),
    $bd052a544036c7c1$var$load("69YlM"),
    $bd052a544036c7c1$var$load("cyTsc"),
    $bd052a544036c7c1$var$load("kXCsp"),
    $bd052a544036c7c1$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("1O6Yy", function(module, exports) {

let $150fdf33bc578fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $150fdf33bc578fed$var$load("fSsz4"),
    $150fdf33bc578fed$var$load("kWOpS"),
    $150fdf33bc578fed$var$load("9tUAi"),
    $150fdf33bc578fed$var$load("bS9pO"),
    $150fdf33bc578fed$var$load("kgHzZ"),
    $150fdf33bc578fed$var$load("j4ur8"),
    $150fdf33bc578fed$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("jNfyP", function(module, exports) {

let $e68ea9f4734869ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e68ea9f4734869ef$var$load("d91RK"),
    $e68ea9f4734869ef$var$load("f7hfJ"),
    $e68ea9f4734869ef$var$load("QI1kr"),
    $e68ea9f4734869ef$var$load("5LvhC"),
    $e68ea9f4734869ef$var$load("brdRT"),
    $e68ea9f4734869ef$var$load("lWBlc"),
    $e68ea9f4734869ef$var$load("s2EmI"),
    $e68ea9f4734869ef$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("eL47t", function(module, exports) {

let $abe8a684a19ae877$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abe8a684a19ae877$var$load("708J7"),
    $abe8a684a19ae877$var$load("kVqUf"),
    $abe8a684a19ae877$var$load("2IMxh"),
    $abe8a684a19ae877$var$load("98tcg"),
    $abe8a684a19ae877$var$load("j03Pa"),
    $abe8a684a19ae877$var$load("kke1I"),
    $abe8a684a19ae877$var$load("gOwMq"),
    $abe8a684a19ae877$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("f6VI9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES = new Set([
    'WorkItemWorkflowContextMinion',
    'JiraWorkItemCreateMinion',
    'JiraPermissionsSkill',
    'JiraNavigationMinion'
]);
/**
 * Rovo Space conversations support Anthropic skills plus a small set of
 * Stratus skills that provide the Jira capabilities required in that context.
 */ function $ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node) {
    return node.source === 'ANTHROPIC' || node.source === 'STRATUS' && Boolean(node.name && $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES.has(node.name));
}
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || ((0, $iDrrr.fg)('rovo_skill_tag_label_wrapping') ? node.name : '') || '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges, options = {}) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) {
            // Legacy directory items do not expose the source needed to establish
            // eligibility for a Rovo Space conversation.
            if (options.restrictToRovoSpaceSkills) return null;
            return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        }
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) {
            if (options.restrictToRovoSpaceSkills && !$ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node)) return null;
            return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        }
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== initLoomEntryPointVariant || $[5] !== loading || $[6] !== skip || $[7] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = initLoomEntryPointVariant;
        $[5] = loading;
        $[6] = skip;
        $[7] = userId;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ay1SM"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("ay1SM", function(module, exports) {

let $7ade8a33111eb984$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ade8a33111eb984$var$load("avoXg"),
    $7ade8a33111eb984$var$load("dQT3c"),
    $7ade8a33111eb984$var$load("kHXvF"),
    $7ade8a33111eb984$var$load("6wr18"),
    $7ade8a33111eb984$var$load("ffEVr"),
    $7ade8a33111eb984$var$load("Wowvf"),
    $7ade8a33111eb984$var$load("7gL7H"),
    $7ade8a33111eb984$var$load("hhss7"),
    $7ade8a33111eb984$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $jyA9t = parcelRequire("jyA9t");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE = 'confluence-rovo-agent-menu-create-agent';
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    // Keep the config object identity stable when its semantic inputs are stable.
    const assistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    return (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: assistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        assistanceServiceConfig,
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        userId
    ]);
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false)) return;
        openModal({
            entryPoint: $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE,
            initialOutcomeType: 'agent',
            lockInitialOutcomeType: true
        });
    }, [
        openModal
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    return (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                onCreateAgentClick: handleCreateAgent,
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        handleCreateAgent,
        navigateToObject,
        shouldShowGreeting
    ]);
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined,
    onSubmitCallback: undefined,
    editorInsertionAcknowledgement: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, onSubmitCallback: onSubmitCallback, editorInsertionAcknowledgement: editorInsertionAcknowledgement, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined,
                onSubmitCallback: onSubmitCallback ?? undefined,
                editorInsertionAcknowledgement: editorInsertionAcknowledgement ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined,
                onSubmitCallback: undefined,
                editorInsertionAcknowledgement: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("5n93X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b8aeb40a0dd9aac20350a989eb3c9ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e96216f98bcdad5$var$_react = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3e96216f98bcdad5$var$_iconNew = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3e96216f98bcdad5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e96216f98bcdad5$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $3e96216f98bcdad5$var$_react.default.createElement($3e96216f98bcdad5$var$_iconNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$3e96216f98bcdad5$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $3e96216f98bcdad5$var$_default = module.exports.default = $3e96216f98bcdad5$var$CloudArrowUpIcon;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    preserveUrlConversationId: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        backButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("k1Pvg", function(module, exports) {
const $facdac86f4ba08d8$export$49073de218c0e4d6 = {
    AI_MATE: 'ai-mate',
    AI_MATE_ACTIONS: 'ai-mate-actions',
    AI_MATE_INSERT_URLS: 'ai-mate-chat-inserts',
    AI_MATE_CHAT_INPUT_OVERLAY: 'ai-mate-chat-input-overlay',
    AI_MATE_AIFC: 'ai-mate-aifc',
    ROVO_REMIX_LAUNCH: 'rovo-remix-launch',
    ROVO_REMIX: 'rovo-remix',
    AVP: 'avp'
};
const $facdac86f4ba08d8$export$69d3cd8e04a34bd6 = 'jira-inline-agent-creation-agent-assigned';
const $facdac86f4ba08d8$export$273aa0a3b01f12a3 = 'jira-work-items-creating';
const $facdac86f4ba08d8$export$6c48beaef33b5d07 = 'jira-work-items-created';
const $facdac86f4ba08d8$export$141a1577d8898865 = 'jira-work-items-create-failed';
const $facdac86f4ba08d8$export$5007e3a11d326b89 = 'confluence-content-finalized';
module.exports["Topics"] = $facdac86f4ba08d8$export$49073de218c0e4d6;
module.exports["JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT"] = $facdac86f4ba08d8$export$69d3cd8e04a34bd6;
module.exports["JIRA_WORK_ITEMS_CREATING_EVENT"] = $facdac86f4ba08d8$export$273aa0a3b01f12a3;
module.exports["JIRA_WORK_ITEMS_CREATED_EVENT"] = $facdac86f4ba08d8$export$6c48beaef33b5d07;
module.exports["JIRA_WORK_ITEMS_CREATE_FAILED_EVENT"] = $facdac86f4ba08d8$export$141a1577d8898865;
module.exports["CONFLUENCE_CONTENT_FINALIZED_EVENT"] = $facdac86f4ba08d8$export$5007e3a11d326b89;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action, options)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            if (!options?.preserveSelectedConversation) setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("jz8lo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $5BOJB = parcelRequire("5BOJB");


var $6iWVH = parcelRequire("6iWVH");


var $jmjWc = parcelRequire("jmjWc");


var $lpaq2 = parcelRequire("lpaq2");


const $133397c2abdefdc4$var$LazyRovoChatRemixView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "b2tBI",
    name: "LazyRovoChatRemixView",
    loader: async ()=>(await (parcelRequire("62Bnh"))).RovoChatRemixView
});
const $133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload = (payload)=>payload.type === 'open-rovo-remix-sidebar';
const $133397c2abdefdc4$var$createRovoRemixAction = (session)=>{
    return {
        id: `confluence-rovo-remix:${crypto.randomUUID()}`,
        title: 'Remix',
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            fillAvailableHeight: true
        },
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($133397c2abdefdc4$var$LazyRovoChatRemixView, {
                    renderRovoChatRemixPicker: (0, $lpaq2.renderRovoChatRemixPicker),
                    session: session
                })
        }
    };
};
const $133397c2abdefdc4$export$96c35e5f3a6712f8 = ()=>{
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleEvent = (0, $cozmU.useCallback)((payload)=>{
        if (!$133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload(payload)) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'rovoChatRemixScreen',
                source: payload.source,
                attributes: {
                    entryPoint: payload.source,
                    product: 'confluence'
                }
            }
        }).fire();
        setActiveAction($133397c2abdefdc4$var$createRovoRemixAction({
            consumer: payload.data.remixConsumer,
            scope: payload.data.remixPreset
        }), {
            preserveSelectedConversation: true
        });
    }, [
        createAnalyticsEvent,
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        consumeOnceKey: "confluence-rovo-remix-action-launcher",
        onEvent: handleEvent,
        topic: (0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH,
        triggerLatest: true
    });
};
module.exports["RovoRemixActionLauncher"] = $133397c2abdefdc4$export$96c35e5f3a6712f8;

});

parcelRegister("lpaq2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HAlgh",
    name: "LazyRovoChatRemixPickerAdapter",
    loader: async ()=>(await (parcelRequire("cpTD2"))).RovoChatRemixPickerAdapter
});
const $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0 = ({ isDisabled: isDisabled, onSelect: onSelect, preset: preset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter, {
        isDisabled: isDisabled,
        onSelect: onSelect,
        preset: preset
    });
module.exports["renderRovoChatRemixPicker"] = $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0;

});

parcelRegister("cpTD2", function(module, exports) {

let $90a2f88596e85b56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $90a2f88596e85b56$var$load("9Oxea"),
    $90a2f88596e85b56$var$load("6wr18"),
    $90a2f88596e85b56$var$load("ffEVr"),
    $90a2f88596e85b56$var$load("j1ofJ")
]).then(()=>parcelRequire('fK5VE'));

});

parcelRegister("62Bnh", function(module, exports) {

let $465febc97edda457$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $465febc97edda457$var$load("kT6dz"),
    $465febc97edda457$var$load("1BcpX"),
    $465febc97edda457$var$load("9Oxea"),
    $465febc97edda457$var$load("h5t0Y"),
    $465febc97edda457$var$load("ksOjm"),
    $465febc97edda457$var$load("jAsJw"),
    $465febc97edda457$var$load("8TYN0"),
    $465febc97edda457$var$load("hUbK8"),
    $465febc97edda457$var$load("48RB1"),
    $465febc97edda457$var$load("dDcsi"),
    $465febc97edda457$var$load("8X7OO"),
    $465febc97edda457$var$load("4BjK2"),
    $465febc97edda457$var$load("2j57H"),
    $465febc97edda457$var$load("ke023"),
    $465febc97edda457$var$load("2mGc6"),
    $465febc97edda457$var$load("b4OQl"),
    $465febc97edda457$var$load("1b3GG"),
    $465febc97edda457$var$load("2gzeE"),
    $465febc97edda457$var$load("glZF7"),
    $465febc97edda457$var$load("kccW9"),
    $465febc97edda457$var$load("4dKZ4"),
    $465febc97edda457$var$load("k72sK"),
    $465febc97edda457$var$load("kD76L"),
    $465febc97edda457$var$load("agVmZ"),
    $465febc97edda457$var$load("jqoep"),
    $465febc97edda457$var$load("9Zg1k"),
    $465febc97edda457$var$load("dZYhM"),
    $465febc97edda457$var$load("ef2CU"),
    $465febc97edda457$var$load("VXbA1"),
    $465febc97edda457$var$load("9cxGI"),
    $465febc97edda457$var$load("3wf3h"),
    $465febc97edda457$var$load("gBrSK"),
    $465febc97edda457$var$load("13lqP"),
    $465febc97edda457$var$load("eGnZE"),
    $465febc97edda457$var$load("lwTz1"),
    $465febc97edda457$var$load("kyAJ3"),
    $465febc97edda457$var$load("21HSP"),
    $465febc97edda457$var$load("4x9Jx"),
    $465febc97edda457$var$load("ea3NB"),
    $465febc97edda457$var$load("59hV4"),
    $465febc97edda457$var$load("jSV6e"),
    $465febc97edda457$var$load("6iimb"),
    $465febc97edda457$var$load("11yNG"),
    $465febc97edda457$var$load("gQYVn"),
    $465febc97edda457$var$load("lya9W"),
    $465febc97edda457$var$load("9BBvG"),
    $465febc97edda457$var$load("cYv6T"),
    $465febc97edda457$var$load("cL90P"),
    $465febc97edda457$var$load("fob67"),
    $465febc97edda457$var$load("cdiJX"),
    $465febc97edda457$var$load("foA2q"),
    $465febc97edda457$var$load("6wr18"),
    $465febc97edda457$var$load("ffEVr"),
    $465febc97edda457$var$load("Wowvf"),
    $465febc97edda457$var$load("hhss7"),
    $465febc97edda457$var$load("gnocL"),
    $465febc97edda457$var$load("duumh"),
    $465febc97edda457$var$load("cVq6e"),
    $465febc97edda457$var$load("1JeTB"),
    $465febc97edda457$var$load("7EorR"),
    $465febc97edda457$var$load("7XiLa")
]).then(()=>parcelRequire('f7cmi'));

});

parcelRegister("4n04n", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $8OOZ2 = parcelRequire("8OOZ2");


var $6OV8L = parcelRequire("6OV8L");


var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $iDrrr = parcelRequire("iDrrr");


var $9DPMp = parcelRequire("9DPMp");

const $41ee172e87bea8b0$var$defaultSerializer = new (0, $2lPWP.JSONTransformer)();
function $41ee172e87bea8b0$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    if (featureToggles?.markdownPlusSanitizeProseMirrorOnlyNodes === undefined) featureToggles.markdownPlusSanitizeProseMirrorOnlyNodes = (0, $iDrrr.fg)('platform_editor_markdown_plus_sanitize_pm_nodes');
    let serializer = $41ee172e87bea8b0$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $2lPWP.JSONTransformer)((0, $8OOZ2.createSchema)({
        ...(0, $4XbfY.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $41ee172e87bea8b0$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $41ee172e87bea8b0$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $41ee172e87bea8b0$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $41ee172e87bea8b0$var$getUserMentionValues(node) {
    if (node.attrs && $41ee172e87bea8b0$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $41ee172e87bea8b0$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $41ee172e87bea8b0$export$bd172d9b9473ac80;

});

parcelRegister("htTUm", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $97CWy = parcelRequire("97CWy");

const $ecada00de6215dbb$var$serializer = new (0, $2lPWP.JSONTransformer)();
function $ecada00de6215dbb$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $97CWy.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $4XbfY.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $ecada00de6215dbb$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $ecada00de6215dbb$export$dfca419434f7e5a8;

});

parcelRegister("jXXTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c95ca5773a013d33452a456ad3fda3ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e891fc467a4625b3$var$_react = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e891fc467a4625b3$var$_iconNew = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e891fc467a4625b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e891fc467a4625b3$var$AtomIcon = (props)=>/*#__PURE__*/ $e891fc467a4625b3$var$_react.default.createElement($e891fc467a4625b3$var$_iconNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e891fc467a4625b3$var$AtomIcon.displayName = 'AtomIcon';
var $e891fc467a4625b3$var$_default = module.exports.default = $e891fc467a4625b3$var$AtomIcon;

});

parcelRegister("76xix", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $de0bfd2141159d80$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d8UlV"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $de0bfd2141159d80$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $de0bfd2141159d80$export$7ea4e54699cd5224;

});

parcelRegister("d8UlV", function(module, exports) {

let $9917bc308f190038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9917bc308f190038$var$load("b7fR4").then(()=>parcelRequire('9r8so'));

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("ai7NK", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $8s9DV.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $kBr4q.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $kBr4q.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("kmWRd", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $buxP3.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $cozmU.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("eCmUm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bWlOZ = parcelRequire("bWlOZ");


var $fjeDY = parcelRequire("fjeDY");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $8ff099389db409fa$export$ae079d925b48f2c0 = (0, $fjeDY.admitAndRetainEditorRemixLifecycle);
const $8ff099389db409fa$export$a605b6a80891ed8e = (0, $fjeDY.EditorRemixLifecycleOwnerProvider);
const $8ff099389db409fa$export$fbf8271f5096a86c = (0, $fjeDY.useEditorRemixLifecycle);
const $8ff099389db409fa$export$f14cb6f91ccb4b34 = (0, $fjeDY.useEditorRemixLifecycleOwner);
const $8ff099389db409fa$var$OBJECT_SIDEBAR_REMIX_LIFECYCLE_EXPERIMENT = 'remix_state_rearchitecture_object_sidebar';
const $8ff099389db409fa$var$createObjectSidebarRemixLifecycleHandle = ({ conversationId: conversationId, remixId: remixId })=>{
    let hasSettled = false;
    const end = (reason)=>{
        if (hasSettled) return;
        hasSettled = true;
        (0, $bWlOZ.endRemix)(remixId, reason);
    };
    const transition = (event)=>{
        if (hasSettled) return false;
        const phaseBefore = (0, $bWlOZ.getRemixMachine)(remixId)?.state();
        (0, $bWlOZ.sendRemixEvent)(remixId, event);
        const accepted = phaseBefore !== (0, $bWlOZ.getRemixMachine)(remixId)?.state();
        if (accepted && event.type === 'INSERTED') hasSettled = true;
        return accepted;
    };
    const rollback = ()=>{
        if (hasSettled) return;
        try {
            (0, $bWlOZ.sendRemixEvent)(remixId, {
                type: 'CANCELLED'
            });
        } finally{
            end('cancelled');
        }
    };
    return {
        conversationId: conversationId,
        remixId: remixId,
        rollback: rollback,
        transition: transition,
        end: end
    };
};
const $8ff099389db409fa$export$d31bd6cf26dd9f2 = ()=>{
    const startFlow = (0, $cozmU.useCallback)((request)=>{
        if (!(0, $9wGTI.fg)('remix_state_rearchitecture_enabled')) return {
            status: 'disabled'
        };
        if (!(0, $6mKj3.isExperimentEnabled)($8ff099389db409fa$var$OBJECT_SIDEBAR_REMIX_LIFECYCLE_EXPERIMENT)) return {
            status: 'disabled'
        };
        try {
            const result = (0, $bWlOZ.startRemix)({
                ...request,
                metadata: {}
            });
            if (!result) return {
                status: 'active-flow-rejected'
            };
            return {
                status: 'admitted',
                handle: $8ff099389db409fa$var$createObjectSidebarRemixLifecycleHandle(result)
            };
        } catch  {
            return {
                status: 'shadow-infrastructure-failure'
            };
        }
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            startFlow: startFlow
        }), [
        startFlow
    ]);
};
module.exports["admitAndRetainObjectSidebarRemixLifecycle"] = $8ff099389db409fa$export$ae079d925b48f2c0;
module.exports["ObjectSidebarRemixLifecycleOwnerProvider"] = $8ff099389db409fa$export$a605b6a80891ed8e;
module.exports["useObjectSidebarRemixLifecycleOwner"] = $8ff099389db409fa$export$f14cb6f91ccb4b34;
module.exports["useObjectSidebarRemixLifecycleAdapter"] = $8ff099389db409fa$export$d31bd6cf26dd9f2;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $cozmU = parcelRequire("cozmU");


var $4L9ve = parcelRequire("4L9ve");

const $c085ac79a8833850$export$453b7c79178856e5 = (_contentId)=>{
    // Get processed comment data from the Comments Data Manager store
    const { isDataProcessed: isDataProcessed, openInlineComments: openInlineComments, openFooterComments: openFooterComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        if (isDataProcessed) return {
            unresolvedInlineCommentsCount: openInlineComments.length,
            footerCommentsCount: openFooterComments.length
        };
        // Fallback when data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        isDataProcessed,
        openInlineComments.length,
        openFooterComments.length
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});


//# sourceMappingURL=ObjectSidebarControl.f14145f0.js.map
